/*Easeljs*/
(function(a) {
    var b = function() {
        throw "UID cannot be instantiated"
    };
    b._nextID = 0;
    b.get = function() {
        return b._nextID++
    };
    a.UID = b
})(window);
(function(a) {
    var b = function(a, b, c, d, e, f) {
        this.initialize(a, b, c, d, e, f)
    };
    var c = b.prototype;
    b.identity = null;
    b.DEG_TO_RAD = Math.PI / 180;
    c.a = 1;
    c.b = 0;
    c.c = 0;
    c.d = 1;
    c.tx = 0;
    c.ty = 0;
    c.alpha = 1;
    c.shadow = null;
    c.compositeOperation = null;
    c.initialize = function(a, b, c, d, e, f) {
        if (a != null) {
            this.a = a
        }
        this.b = b || 0;
        this.c = c || 0;
        if (d != null) {
            this.d = d
        }
        this.tx = e || 0;
        this.ty = f || 0;
        return this
    };
    c.prepend = function(a, b, c, d, e, f) {
        var g = this.tx;
        if (a != 1 || b != 0 || c != 0 || d != 1) {
            var h = this.a;
            var i = this.c;
            this.a = h * a + this.b * c;
            this.b = h * b + this.b * d;
            this.c = i * a + this.d * c;
            this.d = i * b + this.d * d
        }
        this.tx = g * a + this.ty * c + e;
        this.ty = g * b + this.ty * d + f;
        return this
    };
    c.append = function(a, b, c, d, e, f) {
        var g = this.a;
        var h = this.b;
        var i = this.c;
        var j = this.d;
        this.a = a * g + b * i;
        this.b = a * h + b * j;
        this.c = c * g + d * i;
        this.d = c * h + d * j;
        this.tx = e * g + f * i + this.tx;
        this.ty = e * h + f * j + this.ty;
        return this
    };
    c.prependMatrix = function(a) {
        this.prepend(a.a, a.b, a.c, a.d, a.tx, a.ty);
        this.prependProperties(a.alpha, a.shadow, a.compositeOperation);
        return this
    };
    c.appendMatrix = function(a) {
        this.append(a.a, a.b, a.c, a.d, a.tx, a.ty);
        this.appendProperties(a.alpha, a.shadow, a.compositeOperation);
        return this
    };
    c.prependTransform = function(a, c, d, e, f, g, h, i, j) {
        if (f % 360) {
            var k = f * b.DEG_TO_RAD;
            var l = Math.cos(k);
            var m = Math.sin(k)
        } else {
            l = 1;
            m = 0
        }
        if (i || j) {
            this.tx -= i;
            this.ty -= j
        }
        if (g || h) {
            g *= b.DEG_TO_RAD;
            h *= b.DEG_TO_RAD;
            this.prepend(l * d, m * d, -m * e, l * e, 0, 0);
            this.prepend(Math.cos(h), Math.sin(h), -Math.sin(g), Math.cos(g), a, c)
        } else {
            this.prepend(l * d, m * d, -m * e, l * e, a, c)
        }
        return this
    };
    c.appendTransform = function(a, c, d, e, f, g, h, i, j) {
        if (f % 360) {
            var k = f * b.DEG_TO_RAD;
            var l = Math.cos(k);
            var m = Math.sin(k)
        } else {
            l = 1;
            m = 0
        }
        if (g || h) {
            g *= b.DEG_TO_RAD;
            h *= b.DEG_TO_RAD;
            this.append(Math.cos(h), Math.sin(h), -Math.sin(g), Math.cos(g), a, c);
            this.append(l * d, m * d, -m * e, l * e, 0, 0)
        } else {
            this.append(l * d, m * d, -m * e, l * e, a, c)
        }
        if (i || j) {
            this.tx -= i * this.a + j * this.c;
            this.ty -= i * this.b + j * this.d
        }
        return this
    };
    c.rotate = function(a) {
        var b = Math.cos(a);
        var c = Math.sin(a);
        var d = this.a;
        var e = this.c;
        var f = this.tx;
        this.a = d * b - this.b * c;
        this.b = d * c + this.b * b;
        this.c = e * b - this.d * c;
        this.d = e * c + this.d * b;
        this.tx = f * b - this.ty * c;
        this.ty = f * c + this.ty * b;
        return this
    };
    c.skew = function(a, c) {
        a = a * b.DEG_TO_RAD;
        c = c * b.DEG_TO_RAD;
        this.append(Math.cos(c), Math.sin(c), -Math.sin(a), Math.cos(a), 0, 0);
        return this
    };
    c.scale = function(a, b) {
        this.a *= a;
        this.d *= b;
        this.tx *= a;
        this.ty *= b;
        return this
    };
    c.translate = function(a, b) {
        this.tx += a;
        this.ty += b;
        return this
    };
    c.identity = function() {
        this.alpha = this.a = this.d = 1;
        this.b = this.c = this.tx = this.ty = 0;
        this.shadow = this.compositeOperation = null;
        return this
    };
    c.invert = function() {
        var a = this.a;
        var b = this.b;
        var c = this.c;
        var d = this.d;
        var e = this.tx;
        var f = a * d - b * c;
        this.a = d / f;
        this.b = -b / f;
        this.c = -c / f;
        this.d = a / f;
        this.tx = (c * this.ty - d * e) / f;
        this.ty = -(a * this.ty - b * e) / f;
        return this
    };
    c.isIdentity = function() {
        return this.tx == 0 && this.ty == 0 && this.a == 1 && this.b == 0 && this.c == 0 && this.d == 1
    };
    c.decompose = function(a) {
        if (a == null) {
            a = {}
        }
        a.x = this.tx;
        a.y = this.ty;
        a.scaleX = Math.sqrt(this.a * this.a + this.b * this.b);
        a.scaleY = Math.sqrt(this.c * this.c + this.d * this.d);
        var c = Math.atan2(-this.c, this.d);
        var d = Math.atan2(this.b, this.a);
        if (c == d) {
            a.rotation = d / b.DEG_TO_RAD;
            if (this.a < 0 && this.d >= 0) {
                a.rotation += a.rotation <= 0 ? 180 : -180
            }
            a.skewX = a.skewY = 0
        } else {
            a.skewX = c / b.DEG_TO_RAD;
            a.skewY = d / b.DEG_TO_RAD
        }
        return a
    };
    c.reinitialize = function(a, b, c, d, e, f, g, h, i) {
        this.initialize(a, b, c, d, e, f);
        this.alpha = g || 1;
        this.shadow = h;
        this.compositeOperation = i;
        return this
    };
    c.appendProperties = function(a, b, c) {
        this.alpha *= a;
        this.shadow = b || this.shadow;
        this.compositeOperation = c || this.compositeOperation;
        return this
    };
    c.prependProperties = function(a, b, c) {
        this.alpha *= a;
        this.shadow = this.shadow || b;
        this.compositeOperation = this.compositeOperation || c;
        return this
    };
    c.clone = function() {
        var a = new b(this.a, this.b, this.c, this.d, this.tx, this.ty);
        a.shadow = this.shadow;
        a.alpha = this.alpha;
        a.compositeOperation = this.compositeOperation;
        return a
    };
    c.toString = function() {
        return "[Matrix2D (a=" + this.a + " b=" + this.b + " c=" + this.c + " d=" + this.d + " tx=" + this.tx + " ty=" + this.ty + ")]"
    };
    b.identity = new b(1, 0, 0, 1, 0, 0);
    a.Matrix2D = b
})(window);
(function(a) {
    var b = function() {
        this.initialize()
    };
    var c = b.prototype;
    b.suppressCrossDomainErrors = false;
    b._hitTestCanvas = document.createElement("canvas");
    b._hitTestCanvas.width = b._hitTestCanvas.height = 1;
    b._hitTestContext = b._hitTestCanvas.getContext("2d");
    b._nextCacheID = 1;
    c.alpha = 1;
    c.cacheCanvas = null;
    c.id = -1;
    c.mouseEnabled = true;
    c.name = null;
    c.parent = null;
    c.regX = 0;
    c.regY = 0;
    c.rotation = 0;
    c.scaleX = 1;
    c.scaleY = 1;
    c.skewX = 0;
    c.skewY = 0;
    c.shadow = null;
    c.visible = true;
    c.x = 0;
    c.y = 0;
    c.compositeOperation = null;
    c.snapToPixel = false;
    c.onPress = null;
    c.onClick = null;
    c.onDoubleClick = null;
    c.onMouseOver = null;
    c.onMouseOut = null;
    c.onTick = null;
    c.filters = null;
    c.cacheID = 0;
    c.mask = null;
    c.hitArea = null;
    c._cacheOffsetX = 0;
    c._cacheOffsetY = 0;
    c._cacheDataURLID = 0;
    c._cacheDataURL = null;
    c._matrix = null;
    c.initialize = function() {
        this.id = UID.get();
        this._matrix = new Matrix2D
    };
    c.isVisible = function() {
        return this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0
    };
    c.draw = function(a, b) {
        if (b || !this.cacheCanvas) {
            return false
        }
        a.drawImage(this.cacheCanvas, this._cacheOffsetX, this._cacheOffsetY);
        return true
    };
    c.updateContext = function(a) {
        var b, c = this.mask,
            d = this;
        if (c && c.graphics) {
            b = c.getMatrix(c._matrix);
            a.transform(b.a, b.b, b.c, b.d, b.tx, b.ty);
            c.graphics.drawAsPath(a);
            a.clip();
            b.invert();
            a.transform(b.a, b.b, b.c, b.d, b.tx, b.ty)
        }
        b = d._matrix.identity().appendTransform(d.x, d.y, d.scaleX, d.scaleY, d.rotation, d.skewX, d.skewY, d.regX, d.regY);
        if (Stage._snapToPixelEnabled && d.snapToPixel) {
            a.transform(b.a, b.b, b.c, b.d, b.tx + .5 | 0, b.ty + .5 | 0)
        } else {
            a.transform(b.a, b.b, b.c, b.d, b.tx, b.ty)
        }
        a.globalAlpha *= d.alpha;
        if (d.compositeOperation) {
            a.globalCompositeOperation = d.compositeOperation
        }
        if (d.shadow) {
            this._applyShadow(a, d.shadow)
        }
    };
    c.cache = function(a, c, d, e) {
        var f = this.cacheCanvas;
        if (f == null) {
            f = this.cacheCanvas = document.createElement("canvas")
        }
        var g = f.getContext("2d");
        f.width = d;
        f.height = e;
        g.setTransform(1, 0, 0, 1, -a, -c);
        g.clearRect(a, c, f.width, f.height);
        this.draw(g, true, this._matrix.reinitialize(1, 0, 0, 1, -a, -c));
        this._cacheOffsetX = a;
        this._cacheOffsetY = c;
        this._applyFilters();
        this.cacheID = b._nextCacheID++
    };
    c.updateCache = function(a) {
        var c = this.cacheCanvas,
            d = this._cacheOffsetX,
            e = this._cacheOffsetY;
        if (c == null) {
            throw "cache() must be called before updateCache()"
        }
        var f = c.getContext("2d");
        f.setTransform(1, 0, 0, 1, -d, -e);
        if (!a) {
            f.clearRect(d, e, c.width, c.height)
        } else {
            f.globalCompositeOperation = a
        }
        this.draw(f, true);
        if (a) {
            f.globalCompositeOperation = "source-over"
        }
        this._applyFilters();
        this.cacheID = b._nextCacheID++
    };
    c.uncache = function() {
        this._cacheDataURL = this.cacheCanvas = null;
        this.cacheID = this._cacheOffsetX = this._cacheOffsetY = 0
    };
    c.getCacheDataURL = function() {
        if (!this.cacheCanvas) {
            return null
        }
        if (this.cacheID != this._cacheDataURLID) {
            this._cacheDataURL = this.cacheCanvas.toDataURL()
        }
        return this._cacheDataURL
    };
    c.getStage = function() {
        var a = this;
        while (a.parent) {
            a = a.parent
        }
        if (a instanceof Stage) {
            return a
        }
        return null
    };
    c.localToGlobal = function(a, b) {
        var c = this.getConcatenatedMatrix(this._matrix);
        if (c == null) {
            return null
        }
        c.append(1, 0, 0, 1, a, b);
        return new Point(c.tx, c.ty)
    };
    c.globalToLocal = function(a, b) {
        var c = this.getConcatenatedMatrix(this._matrix);
        if (c == null) {
            return null
        }
        c.invert();
        c.append(1, 0, 0, 1, a, b);
        return new Point(c.tx, c.ty)
    };
    c.localToLocal = function(a, b, c) {
        var d = this.localToGlobal(a, b);
        return c.globalToLocal(d.x, d.y)
    };
    c.setTransform = function(a, b, c, d, e, f, g, h, i) {
        this.x = a || 0;
        this.y = b || 0;
        this.scaleX = c == null ? 1 : c;
        this.scaleY = d == null ? 1 : d;
        this.rotation = e || 0;
        this.skewX = f || 0;
        this.skewY = g || 0;
        this.regX = h || 0;
        this.regY = i || 0
    };
    c.getMatrix = function(a) {
        var b = this;
        return (a ? a.identity() : new Matrix).appendTransform(b.x, b.y, b.scaleX, b.scaleY, b.rotation, b.skewX, b.skewY, b.regX, b.regY).appendProperties(b.alpha, b.shadow, b.compositeOperation)
    };
    c.getConcatenatedMatrix = function(a) {
        if (a) {
            a.identity()
        } else {
            a = new Matrix2D
        }
        var b = this;
        while (b != null) {
            a.prependTransform(b.x, b.y, b.scaleX, b.scaleY, b.rotation, b.skewX, b.skewY, b.regX, b.regY).prependProperties(b.alpha, b.shadow, b.compositeOperation);
            b = b.parent
        }
        return a
    };
    c.hitTest = function(a, c) {
        var d = b._hitTestContext;
        var e = b._hitTestCanvas;
        d.setTransform(1, 0, 0, 1, -a, -c);
        this.draw(d);
        var f = this._testHit(d);
        e.width = 0;
        e.width = 1;
        return f
    };
    c.clone = function() {
        var a = new b;
        this.cloneProps(a);
        return a
    };
    c.toString = function() {
        return "[DisplayObject (name=" + this.name + ")]"
    };
    c.cloneProps = function(a) {
        a.alpha = this.alpha;
        a.name = this.name;
        a.regX = this.regX;
        a.regY = this.regY;
        a.rotation = this.rotation;
        a.scaleX = this.scaleX;
        a.scaleY = this.scaleY;
        a.shadow = this.shadow;
        a.skewX = this.skewX;
        a.skewY = this.skewY;
        a.visible = this.visible;
        a.x = this.x;
        a.y = this.y;
        a.mouseEnabled = this.mouseEnabled;
        a.compositeOperation = this.compositeOperation;
        if (this.cacheCanvas) {
            a.cacheCanvas = this.cacheCanvas.cloneNode(true);
            a.cacheCanvas.getContext("2d").putImageData(this.cacheCanvas.getContext("2d").getImageData(0, 0, this.cacheCanvas.width, this.cacheCanvas.height), 0, 0)
        }
    };
    c._applyShadow = function(a, b) {
        b = b || Shadow.identity;
        a.shadowColor = b.color;
        a.shadowOffsetX = b.offsetX;
        a.shadowOffsetY = b.offsetY;
        a.shadowBlur = b.blur
    };
    c._tick = function(a) {
        if (this.onTick) {
            this.onTick(a)
        }
    };
    c._testHit = function(a) {
        try {
            var c = a.getImageData(0, 0, 1, 1).data[3] > 1
        } catch (d) {
            if (!b.suppressCrossDomainErrors) {
                throw "An error has occurred. This is most likely due to security restrictions on reading canvas pixel data with local or cross-domain images."
            }
        }
        return c
    };
    c._applyFilters = function() {
        if (!this.filters || this.filters.length == 0 || !this.cacheCanvas) {
            return
        }
        var a = this.filters.length;
        var b = this.cacheCanvas.getContext("2d");
        var c = this.cacheCanvas.width;
        var d = this.cacheCanvas.height;
        for (var e = 0; e < a; e++) {
            this.filters[e].applyFilter(b, 0, 0, c, d)
        }
    };
    a.DisplayObject = b
})(window);
(function(a) {
    var b = function() {
        this.initialize()
    };
    var c = b.prototype = new DisplayObject;
    c.children = null;
    c.DisplayObject_initialize = c.initialize;
    c.initialize = function() {
        this.DisplayObject_initialize();
        this.children = []
    };
    c.isVisible = function() {
        return this.visible && this.alpha > 0 && this.children.length && this.scaleX != 0 && this.scaleY != 0
    };
    c.DisplayObject_draw = c.draw;
    c.draw = function(a, b, c) {
        if (this.DisplayObject_draw(a, b)) {
            return true
        }
        var d = this.children.slice(0);
        for (var e = 0, f = d.length; e < f; e++) {
            var g = d[e];
            if (!g.isVisible()) {
                continue
            }
            a.save();
            g.updateContext(a);
            g.draw(a);
            a.restore()
        }
        return true
    };
    c.addChild = function(a) {
        if (a == null) {
            return a
        }
        var b = arguments.length;
        if (b > 1) {
            for (var c = 0; c < b; c++) {
                this.addChild(arguments[c])
            }
            return arguments[b - 1]
        }
        if (a.parent) {
            a.parent.removeChild(a)
        }
        a.parent = this;
        this.children.push(a);
        return a
    };
    c.addChildAt = function(a, b) {
        var c = arguments.length;
        var d = arguments[c - 1];
        if (d < 0 || d > this.children.length) {
            return arguments[c - 2]
        }
        if (c > 2) {
            for (var e = 0; e < c - 1; e++) {
                this.addChildAt(arguments[e], d + e)
            }
            return arguments[c - 2]
        }
        if (a.parent) {
            a.parent.removeChild(a)
        }
        a.parent = this;
        this.children.splice(b, 0, a);
        return a
    };
    c.removeChild = function(a) {
        var b = arguments.length;
        if (b > 1) {
            var c = true;
            for (var d = 0; d < b; d++) {
                c = c && this.removeChild(arguments[d])
            }
            return c
        }
        return this.removeChildAt(this.children.indexOf(a))
    };
    c.removeChildAt = function(a) {
        var b = arguments.length;
        if (b > 1) {
            var c = [];
            for (var d = 0; d < b; d++) {
                c[d] = arguments[d]
            }
            c.sort(function(a, b) {
                return b - a
            });
            var e = true;
            for (d = 0; d < b; d++) {
                e = e && this.removeChildAt(c[d])
            }
            return e
        }
        if (a < 0 || a > this.children.length - 1) {
            return false
        }
        var f = this.children[a];
        if (f) {
            f.parent = null
        }
        this.children.splice(a, 1);
        return true
    };
    c.removeAllChildren = function() {
        var a = this.children;
        while (a.length) {
            a.pop().parent = null
        }
    };
    c.getChildAt = function(a) {
        return this.children[a]
    };
    c.sortChildren = function(a) {
        this.children.sort(a)
    };
    c.getChildIndex = function(a) {
        return this.children.indexOf(a)
    };
    c.getNumChildren = function() {
        return this.children.length
    };
    c.swapChildrenAt = function(a, b) {
        var c = this.children;
        var d = c[a];
        var e = c[b];
        if (!d || !e) {
            return
        }
        c[a] = e;
        c[b] = d
    };
    c.swapChildren = function(a, b) {
        var c = this.children;
        var d, e;
        for (var f = 0, g = c.length; f < g; f++) {
            if (c[f] == a) {
                d = f
            }
            if (c[f] == b) {
                e = f
            }
            if (d != null && e != null) {
                break
            }
        }
        if (f == g) {
            return
        }
        c[d] = b;
        c[e] = a
    };
    c.setChildIndex = function(a, b) {
        var c = this.children,
            d = c.length;
        if (a.parent != this || b < 0 || b >= d) {
            return
        }
        for (var e = 0; e < d; e++) {
            if (c[e] == a) {
                break
            }
        }
        if (e == d || e == b) {
            return
        }
        c.splice(e, 1);
        if (b < e) {
            b--
        }
        c.splice(b, 0, a)
    };
    c.contains = function(a) {
        while (a) {
            if (a == this) {
                return true
            }
            a = a.parent
        }
        return false
    };
    c.hitTest = function(a, b) {
        return this.getObjectUnderPoint(a, b) != null
    };
    c.getObjectsUnderPoint = function(a, b) {
        var c = [];
        var d = this.localToGlobal(a, b);
        this._getObjectsUnderPoint(d.x, d.y, c);
        return c
    };
    c.getObjectUnderPoint = function(a, b) {
        var c = this.localToGlobal(a, b);
        return this._getObjectsUnderPoint(c.x, c.y)
    };
    c.clone = function(a) {
        var c = new b;
        this.cloneProps(c);
        if (a) {
            var d = c.children = [];
            for (var e = 0, f = this.children.length; e < f; e++) {
                var g = this.children[e].clone(a);
                g.parent = c;
                d.push(g)
            }
        }
        return c
    };
    c.toString = function() {
        return "[Container (name=" + this.name + ")]"
    };
    c._tick = function(a) {
        for (var b = this.children.length - 1; b >= 0; b--) {
            var c = this.children[b];
            if (c._tick) {
                c._tick(a)
            }
        }
        if (this.onTick) {
            this.onTick(a)
        }
    };
    c._getObjectsUnderPoint = function(a, c, d, e) {
        var f = DisplayObject._hitTestContext;
        var g = DisplayObject._hitTestCanvas;
        var h = this._matrix;
        var i = e & 1 && (this.onPress || this.onClick || this.onDoubleClick) || e & 2 && (this.onMouseOver || this.onMouseOut);
        if (this.cacheCanvas && i) {
            this.getConcatenatedMatrix(h);
            f.setTransform(h.a, h.b, h.c, h.d, h.tx - a, h.ty - c);
            f.globalAlpha = h.alpha;
            this.draw(f);
            if (this._testHit(f)) {
                g.width = 0;
                g.width = 1;
                return this
            }
        }
        var j = this.children.length;
        for (var k = j - 1; k >= 0; k--) {
            var l = this.children[k];
            if (!l.isVisible() || !l.mouseEnabled) {
                continue
            }
            if (l instanceof b) {
                var m;
                if (i) {
                    m = l._getObjectsUnderPoint(a, c);
                    if (m) {
                        return this
                    }
                } else {
                    m = l._getObjectsUnderPoint(a, c, d, e);
                    if (!d && m) {
                        return m
                    }
                }
            } else if (!e || i || e & 1 && (l.onPress || l.onClick || l.onDoubleClick) || e & 2 && (l.onMouseOver || l.onMouseOut)) {
                var n = l.hitArea;
                l.getConcatenatedMatrix(h);
                if (n) {
                    h.appendTransform(n.x + l.regX, n.y + l.regY, n.scaleX, n.scaleY, n.rotation, n.skewX, n.skewY, n.regX, n.regY);
                    h.alpha *= n.alpha / l.alpha
                }
                f.globalAlpha = h.alpha;
                f.setTransform(h.a, h.b, h.c, h.d, h.tx - a, h.ty - c);
                (n || l).draw(f);
                if (!this._testHit(f)) {
                    continue
                }
                g.width = 0;
                g.width = 1;
                if (i) {
                    return this
                } else if (d) {
                    d.push(l)
                } else {
                    return l
                }
            }
        }
        return null
    };
    a.Container = b
})(window);
(function(a) {
    var b = function(a) {
        this.initialize(a)
    };
    var c = b.prototype = new Container;
    b._snapToPixelEnabled = false;
    c.autoClear = true;
    c.canvas = null;
    c.mouseX = null;
    c.mouseY = null;
    c.onMouseMove = null;
    c.onMouseUp = null;
    c.onMouseDown = null;
    c.snapToPixelEnabled = false;
    c.mouseInBounds = false;
    c.tickOnUpdate = true;
    c._activeMouseEvent = null;
    c._activeMouseTarget = null;
    c._mouseOverIntervalID = null;
    c._mouseOverX = 0;
    c._mouseOverY = 0;
    c._mouseOverTarget = null;
    c.Container_initialize = c.initialize;
    c.initialize = function(a) {
        this.Container_initialize();
        this.canvas = a instanceof HTMLCanvasElement ? a : document.getElementById(a);
        this._enableMouseEvents(true)
    };
    c.update = function(a) {
        if (!this.canvas) {
            return
        }
        if (this.autoClear) {
            this.clear()
        }
        b._snapToPixelEnabled = this.snapToPixelEnabled;
        if (this.tickOnUpdate) {
            this._tick(a)
        }
        this.draw(this.canvas.getContext("2d"), false, this.getConcatenatedMatrix(this._matrix))
    };
    c.tick = c.update;
    c.clear = function() {
        if (!this.canvas) {
            return
        }
        var a = this.canvas.getContext("2d");
        a.setTransform(1, 0, 0, 1, 0, 0);
        a.clearRect(0, 0, this.canvas.width, this.canvas.height)
    };
    c.toDataURL = function(a, b) {
        if (!b) {
            b = "image/png"
        }
        var c = this.canvas.getContext("2d");
        var d = this.canvas.width;
        var e = this.canvas.height;
        var f;
        if (a) {
            f = c.getImageData(0, 0, d, e);
            var g = c.globalCompositeOperation;
            c.globalCompositeOperation = "destination-over";
            c.fillStyle = a;
            c.fillRect(0, 0, d, e)
        }
        var h = this.canvas.toDataURL(b);
        if (a) {
            c.clearRect(0, 0, d, e);
            c.putImageData(f, 0, 0);
            c.globalCompositeOperation = g
        }
        return h
    };
    c.enableMouseOver = function(a) {
        if (this._mouseOverIntervalID) {
            clearInterval(this._mouseOverIntervalID);
            this._mouseOverIntervalID = null
        }
        if (a == null) {
            a = 20
        } else if (a <= 0) {
            return
        }
        var b = this;
        this._mouseOverIntervalID = setInterval(function() {
            b._testMouseOver()
        }, 1e3 / Math.min(50, a));
        this._mouseOverX = NaN;
        this._mouseOverTarget = null
    };
    c.clone = function() {
        var a = new b(null);
        this.cloneProps(a);
        return a
    };
    c.toString = function() {
        return "[Stage (name=" + this.name + ")]"
    };
    c._enableMouseEvents = function() {
        var b = this;
        var c = a.addEventListener ? a : document;
        c.addEventListener("mouseup", function(a) {
            b._handleMouseUp(a)
        }, false);
        c.addEventListener("mousemove", function(a) {
            b._handleMouseMove(a)
        }, false);
        c.addEventListener("dblclick", function(a) {
            b._handleDoubleClick(a)
        }, false);
        if (this.canvas) {
            this.canvas.addEventListener("mousedown", function(a) {
                b._handleMouseDown(a)
            }, false)
        }
    };
    c._handleMouseMove = function(b) {
        if (!this.canvas) {
            this.mouseX = this.mouseY = null;
            return
        }
        if (!b) {
            b = a.event
        }
        var c = this.mouseInBounds;
        this._updateMousePosition(b.pageX, b.pageY);
        if (!c && !this.mouseInBounds) {
            return
        }
        var d = new MouseEvent("onMouseMove", this.mouseX, this.mouseY, this, b);
        if (this.onMouseMove) {
            this.onMouseMove(d)
        }
        if (this._activeMouseEvent && this._activeMouseEvent.onMouseMove) {
            this._activeMouseEvent.onMouseMove(d)
        }
    };
    c._updateMousePosition = function(a, b) {
        var c = this.canvas;
        do {
            a -= c.offsetLeft;
            b -= c.offsetTop
        } while (c = c.offsetParent);
        this.mouseInBounds = a >= 0 && b >= 0 && a < this.canvas.width && b < this.canvas.height;
        if (this.mouseInBounds) {
            this.mouseX = a;
            this.mouseY = b
        }
    };
    c._handleMouseUp = function(a) {
        var b = new MouseEvent("onMouseUp", this.mouseX, this.mouseY, this, a);
        if (this.onMouseUp) {
            this.onMouseUp(b)
        }
        if (this._activeMouseEvent && this._activeMouseEvent.onMouseUp) {
            this._activeMouseEvent.onMouseUp(b)
        }
        if (this._activeMouseTarget && this._activeMouseTarget.onClick && this._getObjectsUnderPoint(this.mouseX, this.mouseY, null, true, this._mouseOverIntervalID ? 3 : 1) == this._activeMouseTarget) {
            this._activeMouseTarget.onClick(new MouseEvent("onClick", this.mouseX, this.mouseY, this._activeMouseTarget, a))
        }
        this._activeMouseEvent = this._activeMouseTarget = null
    };
    c._handleMouseDown = function(a) {
        if (this.onMouseDown) {
            this.onMouseDown(new MouseEvent("onMouseDown", this.mouseX, this.mouseY, this, a))
        }
        var b = this._getObjectsUnderPoint(this.mouseX, this.mouseY, null, this._mouseOverIntervalID ? 3 : 1);
        if (b) {
            if (b.onPress instanceof Function) {
                var c = new MouseEvent("onPress", this.mouseX, this.mouseY, b, a);
                b.onPress(c);
                if (c.onMouseMove || c.onMouseUp) {
                    this._activeMouseEvent = c
                }
            }
            this._activeMouseTarget = b
        }
    };
    c._testMouseOver = function() {
        if (this.mouseX == this._mouseOverX && this.mouseY == this._mouseOverY && this.mouseInBounds) {
            return
        }
        var a = null;
        if (this.mouseInBounds) {
            a = this._getObjectsUnderPoint(this.mouseX, this.mouseY, null, 3);
            this._mouseOverX = this.mouseX;
            this._mouseOverY = this.mouseY
        }
        if (this._mouseOverTarget != a) {
            if (this._mouseOverTarget && this._mouseOverTarget.onMouseOut) {
                this._mouseOverTarget.onMouseOut(new MouseEvent("onMouseOut", this.mouseX, this.mouseY, this._mouseOverTarget))
            }
            if (a && a.onMouseOver) {
                a.onMouseOver(new MouseEvent("onMouseOver", this.mouseX, this.mouseY, a))
            }
            this._mouseOverTarget = a
        }
    };
    c._handleDoubleClick = function(a) {
        if (this.onDoubleClick) {
            this.onDoubleClick(new MouseEvent("onDoubleClick", this.mouseX, this.mouseY, this, a))
        }
        var b = this._getObjectsUnderPoint(this.mouseX, this.mouseY, null, this._mouseOverIntervalID ? 3 : 1);
        if (b) {
            if (b.onDoubleClick instanceof Function) {
                b.onDoubleClick(new MouseEvent("onPress", this.mouseX, this.mouseY, b, a))
            }
        }
    };
    a.Stage = b
})(window);
(function(a) {
    var b = function(a, b, c, d, e) {
        this.initialize(a, b, c, d, e)
    };
    var c = b.prototype;
    c.stageX = 0;
    c.stageY = 0;
    c.type = null;
    c.nativeEvent = null;
    c.onMouseMove = null;
    c.onMouseUp = null;
    c.target = null;
    c.initialize = function(a, b, c, d, e) {
        this.type = a;
        this.stageX = b;
        this.stageY = c;
        this.target = d;
        this.nativeEvent = e
    };
    c.clone = function() {
        return new b(this.type, this.stageX, this.stageY, this.target, this.nativeEvent)
    };
    c.toString = function() {
        return "[MouseEvent (type=" + this.type + " stageX=" + this.stageX + " stageY=" + this.stageY + ")]"
    };
    a.MouseEvent = b
})(window);
(function(a) {
    var b = function() {
        throw "Ticker cannot be instantiated."
    };
    b.useRAF = null;
    b.animationTarget = null;
    b._listeners = null;
    b._pauseable = null;
    b._paused = false;
    b._inited = false;
    b._startTime = 0;
    b._pausedTime = 0;
    b._ticks = 0;
    b._pausedTickers = 0;
    b._interval = 50;
    b._lastTime = 0;
    b._times = null;
    b._tickTimes = null;
    b._rafActive = false;
    b._timeoutID = null;
    b.addListener = function(a, c) {
        if (a == null) {
            return
        }
        if (!b._inited) {
            b.init()
        }
        b.removeListener(a);
        b._pauseable[b._listeners.length] = c == null ? true : c;
        b._listeners.push(a)
    };
    b.init = function() {
        b._inited = true;
        b._times = [];
        b._tickTimes = [];
        b._pauseable = [];
        b._listeners = [];
        b._times.push(b._lastTime = b._startTime = b._getTime());
        b.setInterval(b._interval)
    };
    b.removeListener = function(a) {
        if (b._listeners == null) {
            return
        }
        var c = b._listeners.indexOf(a);
        if (c != -1) {
            b._listeners.splice(c, 1);
            b._pauseable.splice(c, 1)
        }
    };
    b.removeAllListeners = function() {
        b._listeners = [];
        b._pauseable = []
    };
    b.setInterval = function(a) {
        b._interval = a;
        if (!b._inited) {
            return
        }
        b._setupTick()
    };
    b.getInterval = function() {
        return b._interval
    };
    b.setFPS = function(a) {
        b.setInterval(1e3 / a)
    };
    b.getFPS = function() {
        return 1e3 / b._interval
    };
    b.getMeasuredFPS = function(a) {
        if (b._times.length < 2) {
            return -1
        }
        if (a == null) {
            a = b.getFPS() | 0
        }
        a = Math.min(b._times.length - 1, a);
        return 1e3 / ((b._times[0] - b._times[a]) / a)
    };
    b.setPaused = function(a) {
        b._paused = a
    };
    b.getPaused = function() {
        return b._paused
    };
    b.getTime = function(a) {
        return b._getTime() - b._startTime - (a ? b._pausedTime : 0)
    };
    b.getTicks = function(a) {
        return b._ticks - (a ? b._pausedTickers : 0)
    };
    b._handleAF = function(a) {
        b._rafActive = false;
        b._setupTick();
        if (a - b._lastTime >= b._interval - 1) {
            b._tick()
        }
    };
    b._handleTimeout = function() {
        b.timeoutID = null;
        b._setupTick();
        b._tick()
    };
    b._setupTick = function() {
        if (b._rafActive || b.timeoutID != null) {
            return
        }
        if (b.useRAF) {
            var c = a.requestAnimationFrame || a.webkitRequestAnimationFrame || a.mozRequestAnimationFrame || a.oRequestAnimationFrame || a.msRequestAnimationFrame;
            if (c) {
                c(b._handleAF, b.animationTarget);
                b._rafActive = true;
                return
            }
        }
        b.timeoutID = setTimeout(b._handleTimeout, b._interval)
    };
    b._tick = function() {
        b._ticks++;
        var a = b._getTime();
        var c = a - b._lastTime;
        var d = b._paused;
        if (d) {
            b._pausedTickers++;
            b._pausedTime += c
        }
        b._lastTime = a;
        var e = b._pauseable;
        var f = b._listeners.slice();
        var g = f ? f.length : 0;
        for (var h = 0; h < g; h++) {
            var i = f[h];
            if (i == null || d && e[h]) {
                continue
            }
            if (i.tick) {
                i.tick(c, d)
            } else if (i instanceof Function) {
                i(c, d)
            }
        }
        b._tickTimes.unshift(b._getTime() - a);
        while (b._tickTimes.length > 100) {
            b._tickTimes.pop()
        }
        b._times.unshift(a);
        while (b._times.length > 100) {
            b._times.pop()
        }
    };
    b._getTime = function() {
        return (new Date).getTime()
    };
    a.Ticker = b
})(window);
(function(a) {
    var b = function(a, b, c) {
        this.initialize(a, b, c)
    };
    var c = b.prototype = new DisplayObject;
    b._workingContext = document.createElement("canvas").getContext("2d");
    c.text = "";
    c.font = null;
    c.color = null;
    c.textAlign = null;
    c.textBaseline = null;
    c.maxWidth = null;
    c.outline = false;
    c.lineHeight = 0;
    c.lineWidth = null;
    c.DisplayObject_initialize = c.initialize;
    c.initialize = function(a, b, c) {
        this.DisplayObject_initialize();
        this.text = a;
        this.font = b;
        this.color = c ? c : "#000"
    };
    c.isVisible = function() {
        return Boolean(this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && this.text != null && this.text !== "")
    };
    c.DisplayObject_draw = c.draw;
    c.draw = function(a, b) {
        if (this.DisplayObject_draw(a, b)) {
            return true
        }
        if (this.outline) {
            a.strokeStyle = this.color
        } else {
            a.fillStyle = this.color
        }
        a.font = this.font;
        a.textAlign = this.textAlign || "start";
        a.textBaseline = this.textBaseline || "alphabetic";
        this._drawText(a);
        return true
    };
    c.getMeasuredWidth = function() {
        return this._getWorkingContext().measureText(this.text).width
    };
    c.getMeasuredLineHeight = function() {
        return this._getWorkingContext().measureText("M").width * 1.2
    };
    c.getMeasuredHeight = function() {
        return this._drawText() * (this.lineHeight || this.getMeasuredLineHeight())
    };
    c.clone = function() {
        var a = new b(this.text, this.font, this.color);
        this.cloneProps(a);
        return a
    };
    c.toString = function() {
        return "[Text (text=" + (this.text.length > 20 ? this.text.substr(0, 17) + "..." : this.text) + ")]"
    };
    c.DisplayObject_cloneProps = c.cloneProps;
    c.cloneProps = function(a) {
        this.DisplayObject_cloneProps(a);
        a.textAlign = this.textAlign;
        a.textBaseline = this.textBaseline;
        a.maxWidth = this.maxWidth;
        a.outline = this.outline;
        a.lineHeight = this.lineHeight;
        a.lineWidth = this.lineWidth
    };
    c._getWorkingContext = function() {
        var a = b._workingContext;
        a.font = this.font;
        a.textAlign = this.textAlign || "start";
        a.textBaseline = this.textBaseline || "alphabetic";
        return a
    };
    c._drawText = function(a) {
        var b = !!a;
        if (!b) {
            a = this._getWorkingContext()
        }
        var c = String(this.text).split(/(?:\r\n|\r|\n)/);
        var d = this.lineHeight || this.getMeasuredLineHeight();
        var e = 0;
        for (var f = 0, g = c.length; f < g; f++) {
            var h = a.measureText(c[f]).width;
            if (this.lineWidth == null || h < this.lineWidth) {
                if (b) {
                    this._drawTextLine(a, c[f], e * d)
                }
                e++;
                continue
            }
            var i = c[f].split(/(\s)/);
            var j = i[0];
            for (var k = 1, l = i.length; k < l; k += 2) {
                if (a.measureText(j + i[k] + i[k + 1]).width > this.lineWidth) {
                    if (b) {
                        this._drawTextLine(a, j, e * d)
                    }
                    e++;
                    j = i[k + 1]
                } else {
                    j += i[k] + i[k + 1]
                }
            }
            if (b) {
                this._drawTextLine(a, j, e * d)
            }
            e++
        }
        return e
    };
    c._drawTextLine = function(a, b, c) {
        if (this.outline) {
            a.strokeText(b, 0, c, this.maxWidth || 65535)
        } else {
            a.fillText(b, 0, c, this.maxWidth || 65535)
        }
    };
    a.Text = b
})(window);
(function(a) {
    var b = function() {
        this.initialize()
    };
    var c = b.prototype;
    c.initialize = function() {};
    c.getBounds = function() {
        return new Rectangle(0, 0, 0, 0)
    };
    c.applyFilter = function(a, b, c, d, e, f, g, h) {};
    c.toString = function() {
        return "[Filter]"
    };
    c.clone = function() {
        return new b
    };
    a.Filter = b
})(window);
(function(a) {
    var b = function(a) {
        this.initialize(a)
    };
    var c = b.prototype = new DisplayObject;
    c.image = null;
    c.snapToPixel = true;
    c.sourceRect = null;
    c.DisplayObject_initialize = c.initialize;
    c.initialize = function(a) {
        this.DisplayObject_initialize();
        if (typeof a == "string") {
            this.image = new Image;
            this.image.src = a
        } else {
            this.image = a
        }
    };
    c.isVisible = function() {
        return this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && this.image && (this.image.complete || this.image.getContext || this.image.readyState >= 2)
    };
    c.DisplayObject_draw = c.draw;
    c.draw = function(a, b) {
        if (this.DisplayObject_draw(a, b)) {
            return true
        }
        var c = this.sourceRect;
        if (c) {
            a.drawImage(this.image, c.x, c.y, c.width, c.height, 0, 0, c.width, c.height)
        } else {
            a.drawImage(this.image, 0, 0)
        }
        return true
    };
    c.clone = function() {
        var a = new b(this.image);
        this.cloneProps(a);
        return a
    };
    c.toString = function() {
        return "[Bitmap (name=" + this.name + ")]"
    };
    a.Bitmap = b
})(window);
(function(a) {
    var b = function(a, b, c, d) {
        this.initialize(a, b, c, d)
    };
    var c = b.prototype;
    b.identity = null;
    c.color = null;
    c.offsetX = 0;
    c.offsetY = 0;
    c.blur = 0;
    c.initialize = function(a, b, c, d) {
        this.color = a;
        this.offsetX = b;
        this.offsetY = c;
        this.blur = d
    };
    c.toString = function() {
        return "[Shadow]"
    };
    c.clone = function() {
        return new b(this.color, this.offsetX, this.offsetY, this.blur)
    };
    b.identity = new b("transparent", 0, 0, 0);
    a.Shadow = b
})(window);
(function(a) {
    ColorMatrix = function(a, b, c, d) {
        this.initialize(a, b, c, d)
    };
    var b = ColorMatrix.prototype = [];
    ColorMatrix.DELTA_INDEX = [0, .01, .02, .04, .05, .06, .07, .08, .1, .11, .12, .14, .15, .16, .17, .18, .2, .21, .22, .24, .25, .27, .28, .3, .32, .34, .36, .38, .4, .42, .44, .46, .48, .5, .53, .56, .59, .62, .65, .68, .71, .74, .77, .8, .83, .86, .89, .92, .95, .98, 1, 1.06, 1.12, 1.18, 1.24, 1.3, 1.36, 1.42, 1.48, 1.54, 1.6, 1.66, 1.72, 1.78, 1.84, 1.9, 1.96, 2, 2.12, 2.25, 2.37, 2.5, 2.62, 2.75, 2.87, 3, 3.2, 3.4, 3.6, 3.8, 4, 4.3, 4.7, 4.9, 5, 5.5, 6, 6.5, 6.8, 7, 7.3, 7.5, 7.8, 8, 8.4, 8.7, 9, 9.4, 9.6, 9.8, 10];
    ColorMatrix.IDENTITY_MATRIX = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
    ColorMatrix.LENGTH = ColorMatrix.IDENTITY_MATRIX.length;
    b.initialize = function(a, b, c, d) {
        this.reset();
        this.adjustColor(a, b, c, d);
        return this
    };
    b.reset = function() {
        return this.copyMatrix(ColorMatrix.IDENTITY_MATRIX)
    };
    b.adjustColor = function(a, b, c, d) {
        this.adjustHue(d);
        this.adjustContrast(b);
        this.adjustBrightness(a);
        return this.adjustSaturation(c)
    };
    b.adjustBrightness = function(a) {
        if (a == 0 || isNaN(a)) {
            return this
        }
        a = this._cleanValue(a, 255);
        this._multiplyMatrix([1, 0, 0, 0, a, 0, 1, 0, 0, a, 0, 0, 1, 0, a, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
        return this
    }, b.adjustContrast = function(a) {
        if (a == 0 || isNaN(a)) {
            return this
        }
        a = this._cleanValue(a, 100);
        var b;
        if (a < 0) {
            b = 127 + a / 100 * 127
        } else {
            b = a % 1;
            if (b == 0) {
                b = ColorMatrix.DELTA_INDEX[a]
            } else {
                b = ColorMatrix.DELTA_INDEX[a << 0] * (1 - b) + ColorMatrix.DELTA_INDEX[(a << 0) + 1] * b
            }
            b = b * 127 + 127
        }
        this._multiplyMatrix([b / 127, 0, 0, 0, .5 * (127 - b), 0, b / 127, 0, 0, .5 * (127 - b), 0, 0, b / 127, 0, .5 * (127 - b), 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
        return this
    };
    b.adjustSaturation = function(a) {
        if (a == 0 || isNaN(a)) {
            return this
        }
        a = this._cleanValue(a, 100);
        var b = 1 + (a > 0 ? 3 * a / 100 : a / 100);
        var c = .3086;
        var d = .6094;
        var e = .082;
        this._multiplyMatrix([c * (1 - b) + b, d * (1 - b), e * (1 - b), 0, 0, c * (1 - b), d * (1 - b) + b, e * (1 - b), 0, 0, c * (1 - b), d * (1 - b), e * (1 - b) + b, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
        return this
    };
    b.adjustHue = function(a) {
        if (a == 0 || isNaN(a)) {
            return this
        }
        a = this._cleanValue(a, 180) / 180 * Math.PI;
        var b = Math.cos(a);
        var c = Math.sin(a);
        var d = .213;
        var e = .715;
        var f = .072;
        this._multiplyMatrix([d + b * (1 - d) + c * -d, e + b * -e + c * -e, f + b * -f + c * (1 - f), 0, 0, d + b * -d + c * .143, e + b * (1 - e) + c * .14, f + b * -f + c * -.283, 0, 0, d + b * -d + c * -(1 - d), e + b * -e + c * e, f + b * (1 - f) + c * f, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
        return this
    };
    b.concat = function(a) {
        a = this._fixMatrix(a);
        if (a.length != ColorMatrix.LENGTH) {
            return this
        }
        this._multiplyMatrix(a);
        return this
    };
    b.clone = function() {
        return new ColorMatrix(this)
    };
    b.toArray = function() {
        return this.slice(0, ColorMatrix.LENGTH)
    };
    b.copyMatrix = function(a) {
        var b = ColorMatrix.LENGTH;
        for (var c = 0; c < b; c++) {
            this[c] = a[c]
        }
        return this
    };
    b._multiplyMatrix = function(a) {
        var b = [];
        for (var c = 0; c < 5; c++) {
            for (var d = 0; d < 5; d++) {
                b[d] = this[d + c * 5]
            }
            for (var d = 0; d < 5; d++) {
                var e = 0;
                for (var f = 0; f < 5; f++) {
                    e += a[d + f * 5] * b[f]
                }
                this[d + c * 5] = e
            }
        }
    };
    b._cleanValue = function(a, b) {
        return Math.min(b, Math.max(-b, a))
    };
    b._fixMatrix = function(a) {
        if (a instanceof ColorMatrix) {
            a = a.slice(0)
        }
        if (a.length < ColorMatrix.LENGTH) {
            a = a.slice(0, a.length).concat(ColorMatrix.IDENTITY_MATRIX.slice(a.length, ColorMatrix.LENGTH))
        } else if (a.length > ColorMatrix.LENGTH) {
            a = a.slice(0, ColorMatrix.LENGTH)
        }
        return a
    };
    a.ColorMatrix = ColorMatrix
})(window);
(function(a) {
    var b = function(a) {
        this.initialize(a)
    };
    var c = b.prototype = new Filter;
    c.matrix = null;
    c.initialize = function(a) {
        this.matrix = a
    };
    c.applyFilter = function(a, b, c, d, e, f, g, h) {
        f = f || a;
        if (g == null) {
            g = b
        }
        if (h == null) {
            h = c
        }
        try {
            var i = a.getImageData(b, c, d, e)
        } catch (j) {
            return false
        }
        var k = i.data;
        var l = k.length;
        var m, n, o, p;
        var q = this.matrix;
        var r = q[0],
            s = q[1],
            t = q[2],
            u = q[3],
            v = q[4];
        var w = q[5],
            x = q[6],
            y = q[7],
            z = q[8],
            A = q[9];
        var B = q[10],
            C = q[11],
            D = q[12],
            E = q[13],
            F = q[14];
        var G = q[15],
            H = q[16],
            I = q[17],
            J = q[18],
            K = q[19];
        for (var L = 0; L < l; L += 4) {
            m = k[L];
            n = k[L + 1];
            o = k[L + 2];
            p = k[L + 3];
            k[L] = m * r + n * s + o * t + p * u + v;
            k[L + 1] = m * w + n * x + o * y + p * z + A;
            k[L + 2] = m * B + n * C + o * D + p * E + F;
            k[L + 3] = m * G + n * H + o * I + p * J + K
        }
        i.data = k;
        f.putImageData(i, g, h);
        return true
    };
    c.toString = function() {
        return "[ColorMatrixFilter]"
    };
    c.clone = function() {
        return new b(this.matrix)
    };
    a.ColorMatrixFilter = b
})(window);
(function(a) {
    var b = function(a) {
        this.initialize(a)
    };
    var c = b.prototype = new DisplayObject;
    c.graphics = null;
    c.DisplayObject_initialize = c.initialize;
    c.initialize = function(a) {
        this.DisplayObject_initialize();
        this.graphics = a ? a : new Graphics
    };
    c.isVisible = function() {
        return this.visible && this.alpha > 0 && this.scaleX != 0 && this.scaleY != 0 && this.graphics
    };
    c.DisplayObject_draw = c.draw;
    c.draw = function(a, b) {
        if (this.DisplayObject_draw(a, b)) {
            return true
        }
        this.graphics.draw(a);
        return true
    };
    c.clone = function(a) {
        var c = new b(a && this.graphics ? this.graphics.clone() : this.graphics);
        this.cloneProps(c);
        return c
    };
    c.toString = function() {
        return "[Shape (name=" + this.name + ")]"
    };
    a.Shape = b
})(window);
(function(a) {
    function b(a, b, c) {
        this.f = a;
        this.params = b;
        this.path = c == null ? true : c
    }
    b.prototype.exec = function(a) {
        this.f.apply(a, this.params)
    };
    var c = function() {
        this.initialize()
    };
    var d = c.prototype;
    c.getRGB = function(a, b, c, d) {
        if (a != null && c == null) {
            d = b;
            c = a & 255;
            b = a >> 8 & 255;
            a = a >> 16 & 255
        }
        if (d == null) {
            return "rgb(" + a + "," + b + "," + c + ")"
        } else {
            return "rgba(" + a + "," + b + "," + c + "," + d + ")"
        }
    };
    c.getHSL = function(a, b, c, d) {
        if (d == null) {
            return "hsl(" + a % 360 + "," + b + "%," + c + "%)"
        } else {
            return "hsla(" + a % 360 + "," + b + "%," + c + "%," + d + ")"
        }
    };
    c.BASE_64 = {
        A: 0,
        B: 1,
        C: 2,
        D: 3,
        E: 4,
        F: 5,
        G: 6,
        H: 7,
        I: 8,
        J: 9,
        K: 10,
        L: 11,
        M: 12,
        N: 13,
        O: 14,
        P: 15,
        Q: 16,
        R: 17,
        S: 18,
        T: 19,
        U: 20,
        V: 21,
        W: 22,
        X: 23,
        Y: 24,
        Z: 25,
        a: 26,
        b: 27,
        c: 28,
        d: 29,
        e: 30,
        f: 31,
        g: 32,
        h: 33,
        i: 34,
        j: 35,
        k: 36,
        l: 37,
        m: 38,
        n: 39,
        o: 40,
        p: 41,
        q: 42,
        r: 43,
        s: 44,
        t: 45,
        u: 46,
        v: 47,
        w: 48,
        x: 49,
        y: 50,
        z: 51,
        0: 52,
        1: 53,
        2: 54,
        3: 55,
        4: 56,
        5: 57,
        6: 58,
        7: 59,
        8: 60,
        9: 61,
        "+": 62,
        "/": 63
    };
    c.STROKE_CAPS_MAP = ["butt", "round", "square"];
    c.STROKE_JOINTS_MAP = ["miter", "round", "bevel"];
    c._ctx = document.createElement("canvas").getContext("2d");
    c.beginCmd = new b(c._ctx.beginPath, [], false);
    c.fillCmd = new b(c._ctx.fill, [], false);
    c.strokeCmd = new b(c._ctx.stroke, [], false);
    d._strokeInstructions = null;
    d._strokeStyleInstructions = null;
    d._fillInstructions = null;
    d._instructions = null;
    d._oldInstructions = null;
    d._activeInstructions = null;
    d._active = false;
    d._dirty = false;
    d.initialize = function() {
        this.clear();
        this._ctx = c._ctx
    };
    d.draw = function(a) {
        if (this._dirty) {
            this._updateInstructions()
        }
        var b = this._instructions;
        for (var c = 0, d = b.length; c < d; c++) {
            b[c].exec(a)
        }
    };
    d.drawAsPath = function(a) {
        if (this._dirty) {
            this._updateInstructions()
        }
        var b, c = this._instructions;
        for (var d = 0, e = c.length; d < e; d++) {
            if ((b = c[d]).path || d == 0) {
                b.exec(a)
            }
        }
    };
    d.moveTo = function(a, c) {
        this._activeInstructions.push(new b(this._ctx.moveTo, [a, c]));
        return this
    };
    d.lineTo = function(a, c) {
        this._dirty = this._active = true;
        this._activeInstructions.push(new b(this._ctx.lineTo, [a, c]));
        return this
    };
    d.arcTo = function(a, c, d, e, f) {
        this._dirty = this._active = true;
        this._activeInstructions.push(new b(this._ctx.arcTo, [a, c, d, e, f]));
        return this
    };
    d.arc = function(a, c, d, e, f, g) {
        this._dirty = this._active = true;
        if (g == null) {
            g = false
        }
        this._activeInstructions.push(new b(this._ctx.arc, [a, c, d, e, f, g]));
        return this
    };
    d.quadraticCurveTo = function(a, c, d, e) {
        this._dirty = this._active = true;
        this._activeInstructions.push(new b(this._ctx.quadraticCurveTo, [a, c, d, e]));
        return this
    };
    d.bezierCurveTo = function(a, c, d, e, f, g) {
        this._dirty = this._active = true;
        this._activeInstructions.push(new b(this._ctx.bezierCurveTo, [a, c, d, e, f, g]));
        return this
    };
    d.rect = function(a, c, d, e) {
        this._dirty = this._active = true;
        this._activeInstructions.push(new b(this._ctx.rect, [a, c, d, e]));
        return this
    };
    d.closePath = function() {
        if (this._active) {
            this._dirty = true;
            this._activeInstructions.push(new b(this._ctx.closePath, []))
        }
        return this
    };
    d.clear = function() {
        this._instructions = [];
        this._oldInstructions = [];
        this._activeInstructions = [];
        this._strokeStyleInstructions = this._strokeInstructions = this._fillInstructions = null;
        this._active = this._dirty = false;
        return this
    };
    d.beginFill = function(a) {
        if (this._active) {
            this._newPath()
        }
        this._fillInstructions = a ? [new b(this._setProp, ["fillStyle", a], false)] : null;
        return this
    };
    d.beginLinearGradientFill = function(a, c, d, e, f, g) {
        if (this._active) {
            this._newPath()
        }
        var h = this._ctx.createLinearGradient(d, e, f, g);
        for (var i = 0, j = a.length; i < j; i++) {
            h.addColorStop(c[i], a[i])
        }
        this._fillInstructions = [new b(this._setProp, ["fillStyle", h], false)];
        return this
    };
    d.beginRadialGradientFill = function(a, c, d, e, f, g, h, i) {
        if (this._active) {
            this._newPath()
        }
        var j = this._ctx.createRadialGradient(d, e, f, g, h, i);
        for (var k = 0, l = a.length; k < l; k++) {
            j.addColorStop(c[k], a[k])
        }
        this._fillInstructions = [new b(this._setProp, ["fillStyle", j], false)];
        return this
    };
    d.beginBitmapFill = function(a, c) {
        if (this._active) {
            this._newPath()
        }
        c = c || "";
        var d = this._ctx.createPattern(a, c);
        this._fillInstructions = [new b(this._setProp, ["fillStyle", d], false)];
        return this
    };
    d.endFill = function() {
        return this.beginFill()
    };
    d.setStrokeStyle = function(a, d, e, f) {
        if (this._active) {
            this._newPath()
        }
        this._strokeStyleInstructions = [new b(this._setProp, ["lineWidth", a == null ? "1" : a], false), new b(this._setProp, ["lineCap", d == null ? "butt" : isNaN(d) ? d : c.STROKE_CAPS_MAP[d]], false), new b(this._setProp, ["lineJoin", e == null ? "miter" : isNaN(e) ? e : c.STROKE_JOINTS_MAP[e]], false), new b(this._setProp, ["miterLimit", f == null ? "10" : f], false)];
        return this
    };
    d.beginStroke = function(a) {
        if (this._active) {
            this._newPath()
        }
        this._strokeInstructions = a ? [new b(this._setProp, ["strokeStyle", a], false)] : null;
        return this
    };
    d.beginLinearGradientStroke = function(a, c, d, e, f, g) {
        if (this._active) {
            this._newPath()
        }
        var h = this._ctx.createLinearGradient(d, e, f, g);
        for (var i = 0, j = a.length; i < j; i++) {
            h.addColorStop(c[i], a[i])
        }
        this._strokeInstructions = [new b(this._setProp, ["strokeStyle", h], false)];
        return this
    };
    d.beginRadialGradientStroke = function(a, c, d, e, f, g, h, i) {
        if (this._active) {
            this._newPath()
        }
        var j = this._ctx.createRadialGradient(d, e, f, g, h, i);
        for (var k = 0, l = a.length; k < l; k++) {
            j.addColorStop(c[k], a[k])
        }
        this._strokeInstructions = [new b(this._setProp, ["strokeStyle", j], false)];
        return this
    };
    d.beginBitmapStroke = function(a, c) {
        if (this._active) {
            this._newPath()
        }
        var d = this._ctx.createPattern(a, c || "");
        this._strokeInstructions = [new b(this._setProp, ["strokeStyle", d], false)];
        return this
    };
    d.endStroke = function() {
        this.beginStroke();
        return this
    };
    d.curveTo = d.quadraticCurveTo;
    d.drawRect = d.rect;
    d.drawRoundRect = function(a, b, c, d, e) {
        this.drawRoundRectComplex(a, b, c, d, e, e, e, e);
        return this
    };
    d.drawRoundRectComplex = function(a, c, d, e, f, g, h, i) {
        this._dirty = this._active = true;
        var j = Math.PI,
            k = this._ctx.arc,
            l = this._ctx.lineTo;
        this._activeInstructions.push(new b(this._ctx.moveTo, [a + f, c]), new b(l, [a + d - g, c]), g >= 0 ? new b(k, [a + d - g, c + g, g, -j / 2, 0]) : new b(k, [a + d, c, -g, j, j / 2, true]), new b(l, [a + d, c + e - h]), i >= 0 ? new b(k, [a + d - h, c + e - h, h, 0, j / 2]) : new b(k, [a + d, c + e, -h, -j / 2, j, true]), new b(l, [a + i, c + e]), i >= 0 ? new b(k, [a + i, c + e - i, i, j / 2, j]) : new b(k, [a, c + e, -i, 0, -j / 2, true]), new b(l, [a, c + f]), f >= 0 ? new b(k, [a + f, c + f, f, j, -j / 2]) : new b(k, [a, c, -f, j / 2, 0, true]));
        return this
    };
    d.drawCircle = function(a, b, c) {
        this.arc(a, b, c, 0, Math.PI * 2);
        return this
    };
    d.drawEllipse = function(a, c, d, e) {
        this._dirty = this._active = true;
        var f = .5522848;
        var g = d / 2 * f;
        var h = e / 2 * f;
        var i = a + d;
        var j = c + e;
        var k = a + d / 2;
        var l = c + e / 2;
        this._activeInstructions.push(new b(this._ctx.moveTo, [a, l]), new b(this._ctx.bezierCurveTo, [a, l - h, k - g, c, k, c]), new b(this._ctx.bezierCurveTo, [k + g, c, i, l - h, i, l]), new b(this._ctx.bezierCurveTo, [i, l + h, k + g, j, k, j]), new b(this._ctx.bezierCurveTo, [k - g, j, a, l + h, a, l]));
        return this
    };
    d.drawPolyStar = function(a, c, d, e, f, g) {
        this._dirty = this._active = true;
        if (f == null) {
            f = 0
        }
        f = 1 - f;
        if (g == null) {
            g = 0
        } else {
            g /= 180 / Math.PI
        }
        var h = Math.PI / e;
        this._activeInstructions.push(new b(this._ctx.moveTo, [a + Math.cos(g) * d, c + Math.sin(g) * d]));
        for (var i = 0; i < e; i++) {
            g += h;
            if (f != 1) {
                this._activeInstructions.push(new b(this._ctx.lineTo, [a + Math.cos(g) * d * f, c + Math.sin(g) * d * f]))
            }
            g += h;
            this._activeInstructions.push(new b(this._ctx.lineTo, [a + Math.cos(g) * d, c + Math.sin(g) * d]))
        }
        return this
    };
    d.decodePath = function(a) {
        var b = [this.moveTo, this.lineTo, this.quadraticCurveTo, this.bezierCurveTo];
        var d = [2, 2, 4, 6];
        var e = 0,
            f = a.length;
        var g = [];
        var h = 0,
            i = 0;
        var j = c.BASE_64;
        while (e < f) {
            var k = j[a.charAt(e)];
            var l = k >> 3;
            var m = b[l];
            if (!m || k & 3) {
                throw "bad path data"
            }
            var n = d[l];
            if (!l) {
                h = i = 0
            }
            g.length = 0;
            e++;
            var o = (k >> 2 & 1) + 2;
            for (var p = 0; p < n; p++) {
                var q = j[a.charAt(e)];
                var r = q >> 5 ? -1 : 1;
                q = (q & 31) << 6 | j[a.charAt(e + 1)];
                if (o == 3) {
                    q = q << 6 | j[a.charAt(e + 2)]
                }
                q = r * q / 10;
                if (p % 2) {
                    h = q += h
                } else {
                    i = q += i
                }
                g[p] = q;
                e += o
            }
            m.apply(this, g)
        }
        return this
    };
    d.clone = function() {
        var a = new c;
        a._instructions = this._instructions.slice();
        a._activeInstructions = this._activeInstructions.slice();
        a._oldInstructions = this._oldInstructions.slice();
        if (this._fillInstructions) {
            a._fillInstructions = this._fillInstructions.slice()
        }
        if (this._strokeInstructions) {
            a._strokeInstructions = this._strokeInstructions.slice()
        }
        if (this._strokeStyleInstructions) {
            a._strokeStyleInstructions = this._strokeStyleInstructions.slice()
        }
        a._active = this._active;
        a._dirty = this._dirty;
        a.drawAsPath = this.drawAsPath;
        return a
    };
    d.toString = function() {
        return "[Graphics]"
    };
    d.mt = d.moveTo;
    d.lt = d.lineTo;
    d.at = d.arcTo;
    d.bt = d.bezierCurveTo;
    d.qt = d.quadraticCurveTo;
    d.a = d.arc;
    d.r = d.rect;
    d.cp = d.closePath;
    d.c = d.clear;
    d.f = d.beginFill;
    d.lf = d.beginLinearGradientFill;
    d.rf = d.beginRadialGradientFill;
    d.bf = d.beginBitmapFill;
    d.ef = d.endFill;
    d.ss = d.setStrokeStyle;
    d.s = d.beginStroke;
    d.ls = d.beginLinearGradientStroke;
    d.rs = d.beginRadialGradientStroke;
    d.bs = d.beginBitmapStroke;
    d.es = d.endStroke;
    d.dr = d.drawRect;
    d.rr = d.drawRoundRect;
    d.rc = d.drawRoundRectComplex;
    d.dc = d.drawCircle;
    d.de = d.drawEllipse;
    d.dp = d.drawPolyStar;
    d.p = d.decodePath;
    d._updateInstructions = function() {
        this._instructions = this._oldInstructions.slice();
        this._instructions.push(c.beginCmd);
        if (this._fillInstructions) {
            this._instructions.push.apply(this._instructions, this._fillInstructions)
        }
        if (this._strokeInstructions) {
            this._instructions.push.apply(this._instructions, this._strokeInstructions);
            if (this._strokeStyleInstructions) {
                this._instructions.push.apply(this._instructions, this._strokeStyleInstructions)
            }
        }
        this._instructions.push.apply(this._instructions, this._activeInstructions);
        if (this._fillInstructions) {
            this._instructions.push(c.fillCmd)
        }
        if (this._strokeInstructions) {
            this._instructions.push(c.strokeCmd)
        }
    };
    d._newPath = function() {
        if (this._dirty) {
            this._updateInstructions()
        }
        this._oldInstructions = this._instructions;
        this._activeInstructions = [];
        this._active = this._dirty = false
    };
    d._setProp = function(a, b) {
        this[a] = b
    };
    a.Graphics = c
})(window);
(function(a) {
    var b = function(a, b, c, d) {
        this.initialize(a, b, c, d)
    };
    var c = b.prototype;
    c.x = 0;
    c.y = 0;
    c.width = 0;
    c.height = 0;
    c.initialize = function(a, b, c, d) {
        this.x = a == null ? 0 : a;
        this.y = b == null ? 0 : b;
        this.width = c == null ? 0 : c;
        this.height = d == null ? 0 : d
    };
    c.clone = function() {
        return new b(this.x, this.y, this.width, this.height)
    };
    c.toString = function() {
        return "[Rectangle (x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + ")]"
    };
    a.Rectangle = b
})(window);
(function(a) {
    var b = function(a, b, c) {
        this.initialize(a, b, c)
    };
    var c = b.prototype = new Filter;
    c.initialize = function(a, b, c) {
        if (isNaN(a) || a < 0) a = 0;
        this.blurX = a | 0;
        if (isNaN(b) || b < 0) b = 0;
        this.blurY = b | 0;
        if (isNaN(c) || c < 1) c = 1;
        this.quality = c | 0
    };
    c.blurX = 0;
    c.blurY = 0;
    c.quality = 1;
    c.getBounds = function() {
        return new Rectangle(-this.blurX, -this.blurY, 2 * this.blurX, 2 * this.blurY)
    };
    c.applyFilter = function(a, b, c, d, e, f, g, h) {
        f = f || a;
        if (g == null) {
            g = b
        }
        if (h == null) {
            h = c
        }
        try {
            var i = a.getImageData(b, c, d, e)
        } catch (j) {
            return false
        }
        var k = this.blurX;
        if (isNaN(k) || k < 0) return false;
        k |= 0;
        var l = this.blurY;
        if (isNaN(l) || l < 0) return false;
        l |= 0;
        if (k == 0 && l == 0) return false;
        var m = this.quality;
        if (isNaN(m) || m < 1) m = 1;
        m |= 0;
        if (m > 3) m = 3;
        if (m < 1) m = 1;
        var n = i.data;
        var o, p, q, r, b, c, s, t, u, v, w, x, y;
        var z = d - 1;
        var A = e - 1;
        var B = k + 1;
        var C = k + B;
        var D = l + 1;
        var E = l + D;
        var F = 1 / (C * E);
        var G = [];
        var H = [];
        var I = [];
        var J = [];
        var K = [];
        var L = [];
        while (m-- > 0) {
            y = x = 0;
            for (c = 0; c < e; c++) {
                o = n[y] * B;
                p = n[y + 1] * B;
                q = n[y + 2] * B;
                r = n[y + 3] * B;
                for (s = 1; s <= k; s++) {
                    t = y + ((s > z ? z : s) << 2);
                    o += n[t++];
                    p += n[t++];
                    q += n[t++];
                    r += n[t]
                }
                for (b = 0; b < d; b++) {
                    G[x] = o;
                    H[x] = p;
                    I[x] = q;
                    J[x] = r;
                    if (c == 0) {
                        K[b] = Math.min(b + B, z) << 2;
                        L[b] = Math.max(b - k, 0) << 2
                    }
                    u = y + K[b];
                    v = y + L[b];
                    o += n[u++] - n[v++];
                    p += n[u++] - n[v++];
                    q += n[u++] - n[v++];
                    r += n[u] - n[v];
                    x++
                }
                y += d << 2
            }
            for (b = 0; b < d; b++) {
                w = b;
                o = G[w] * D;
                p = H[w] * D;
                q = I[w] * D;
                r = J[w] * D;
                for (s = 1; s <= l; s++) {
                    w += s > A ? 0 : d;
                    o += G[w];
                    p += H[w];
                    q += I[w];
                    r += J[w]
                }
                x = b << 2;
                for (c = 0; c < e; c++) {
                    n[x] = o * F + .5 | 0;
                    n[x + 1] = p * F + .5 | 0;
                    n[x + 2] = q * F + .5 | 0;
                    n[x + 3] = r * F + .5 | 0;
                    if (b == 0) {
                        K[c] = Math.min(c + D, A) * d;
                        L[c] = Math.max(c - l, 0) * d
                    }
                    u = b + K[c];
                    v = b + L[c];
                    o += G[u] - G[v];
                    p += H[u] - H[v];
                    q += I[u] - I[v];
                    r += J[u] - J[v];
                    x += d << 2
                }
            }
        }
        f.putImageData(i, g, h);
        return true
    };
    c.clone = function() {
        return new b(this.blurX, this.blurY, this.quality)
    };
    c.toString = function() {
        return "[BoxBlurFilter]"
    };
    a.BoxBlurFilter = b
})(window);
(function(a) {
    var b = function(a, b) {
        this.initialize(a, b)
    };
    var c = b.prototype;
    b.NONE = 0;
    b.LOOP = 1;
    b.REVERSE = 2;
    b.IGNORE = {};
    b._tweens = [];
    b._plugins = {};
    b.get = function(a, c, d) {
        return new b(a, c, d)
    };
    b.tick = function(a, c) {
        var d = b._tweens.slice();
        for (var e = d.length - 1; e >= 0; e--) {
            var f = d[e];
            if (c && !f.ignoreGlobalPause || f._paused) {
                continue
            }
            f.tick(f._useTicks ? 1 : a)
        }
    };
    if (a.Ticker) {
        Ticker.addListener(b, false)
    }
    b.removeTweens = function(a) {
        if (!a.tweenjs_count) {
            return
        }
        var c = b._tweens;
        for (var d = c.length - 1; d >= 0; d--) {
            if (c[d]._target == a) {
                c[d]._paused = true;
                c.splice(d, 1)
            }
        }
        a.tweenjs_count = 0
    };
    b.hasActiveTweens = function(a) {
        if (a) {
            return a.tweenjs_count
        }
        return b._tweens && b._tweens.length
    };
    b.installPlugin = function(a, c) {
        var d = a.priority;
        if (d == null) {
            a.priority = d = 0
        }
        for (var e = 0, f = c.length, g = b._plugins; e < f; e++) {
            var h = c[e];
            if (!g[h]) {
                g[h] = [a]
            } else {
                var i = g[h];
                for (var j = 0, k = i.length; j < k; j++) {
                    if (d < i[j].priority) {
                        break
                    }
                }
                g[h].splice(j, 0, a)
            }
        }
    };
    b._register = function(a, c) {
        var d = a._target;
        if (c) {
            if (d) {
                d.tweenjs_count = d.tweenjs_count ? d.tweenjs_count + 1 : 1
            }
            b._tweens.push(a)
        } else {
            if (d) {
                d.tweenjs_count--
            }
            var e = b._tweens.indexOf(a);
            if (e != -1) {
                b._tweens.splice(e, 1)
            }
        }
    };
    c.ignoreGlobalPause = false;
    c.loop = false;
    c.duration = 0;
    c.pluginData = null;
    c.onChange = null;
    c.target = null;
    c.position = null;
    c._paused = false;
    c._curQueueProps = null;
    c._initQueueProps = null;
    c._steps = null;
    c._actions = null;
    c._prevPosition = 0;
    c._stepPosition = 0;
    c._prevPos = -1;
    c._target = null;
    c._useTicks = false;
    c.initialize = function(a, c, d) {
        this.target = this._target = a;
        if (c) {
            this._useTicks = c.useTicks;
            this.ignoreGlobalPause = c.ignoreGlobalPause;
            this.loop = c.loop;
            if (c.override) {
                b.removeTweens(a)
            }
        }
        this.pluginData = d || {};
        this._curQueueProps = {};
        this._initQueueProps = {};
        this._steps = [];
        this._actions = [];
        if (c && c.paused) {
            this._paused = true
        } else {
            b._register(this, true)
        }
        if (c && c.position != null) {
            this.setPosition(c.position, b.NONE)
        }
    };
    c.wait = function(a) {
        if (a == null || a <= 0) {
            return this
        }
        var b = this._cloneProps(this._curQueueProps);
        return this._addStep({
            d: a,
            p0: b,
            e: this._linearEase,
            p1: b
        })
    };
    c.to = function(a, b, c) {
        if (isNaN(b) || b < 0) {
            b = 0
        }
        return this._addStep({
            d: b || 0,
            p0: this._cloneProps(this._curQueueProps),
            e: c,
            p1: this._cloneProps(this._appendQueueProps(a))
        })
    };
    c.call = function(a, b, c) {
        return this._addAction({
            f: a,
            p: b ? b : [this],
            o: c ? c : this._target
        })
    };
    c.set = function(a, b) {
        return this._addAction({
            f: this._set,
            o: this,
            p: [a, b ? b : this._target]
        })
    };
    c.play = function(a) {
        return this.call(a.setPaused, [false], a)
    };
    c.pause = function(a) {
        if (!a) {
            a = this
        }
        return this.call(a.setPaused, [true], a)
    };
    c.setPosition = function(a, b) {
        if (a < 0) {
            a = 0
        }
        if (b == null) {
            b = 1
        }
        var c = a;
        var d = false;
        if (c >= this.duration) {
            if (this.loop) {
                c = c % this.duration
            } else {
                c = this.duration;
                d = true
            }
        }
        if (c == this._prevPos) {
            return d
        }
        if (this._target) {
            if (d) {
                this._updateTargetProps(null, 1)
            } else if (this._steps.length > 0) {
                for (var e = 0, f = this._steps.length; e < f; e++) {
                    if (this._steps[e].t > c) {
                        break
                    }
                }
                var g = this._steps[e - 1];
                this._updateTargetProps(g, (this._stepPosition = c - g.t) / g.d, c)
            }
        }
        var h = this._prevPos;
        this.position = this._prevPos = c;
        this._prevPosition = a;
        if (b != 0 && this._actions.length > 0) {
            if (this._useTicks) {
                this._runActions(c, c)
            } else if (b == 1 && c < h) {
                if (h != this.duration) {
                    this._runActions(h, this.duration)
                }
                this._runActions(0, c, true)
            } else {
                this._runActions(h, c)
            }
        }
        if (d) {
            this.setPaused(true)
        }
        this.onChange && this.onChange(this);
        return d
    };
    c.tick = function(a) {
        if (this._paused) {
            return
        }
        this.setPosition(this._prevPosition + a)
    };
    c.setPaused = function(a) {
        this._paused = !!a;
        b._register(this, !a);
        return this
    };
    c.w = c.wait;
    c.t = c.to;
    c.c = c.call;
    c.s = c.set;
    c.toString = function() {
        return "[Tween]"
    };
    c.clone = function() {
        throw "Tween can not be cloned."
    };
    c._updateTargetProps = function(a, c, d) {
        var e, f, g, h, i, j;
        if (!a && c == 1) {
            e = f = this._curQueueProps
        } else {
            if (a.e) {
                c = a.e(c, 0, 1, 1)
            }
            e = a.p0;
            f = a.p1
        }
        for (n in this._initQueueProps) {
            if ((h = e[n]) == null) {
                e[n] = h = this._initQueueProps[n]
            }
            if ((i = f[n]) == null) {
                f[n] = i = h
            }
            if (h == i || c == 0 || c == 1 || typeof h != "number") {
                g = c == 1 ? i : h
            } else {
                g = h + (i - h) * c
            }
            var k = false;
            if (j = b._plugins[n]) {
                for (var l = 0, m = j.length; l < m; l++) {
                    var o = j[l].tween(this, n, g, e, f, c, d, !a);
                    if (o == b.IGNORE) {
                        k = true
                    } else {
                        g = o
                    }
                }
            }
            if (!k) {
                this._target[n] = g
            }
        }
    };
    c._runActions = function(a, b, c) {
        var d = a;
        var e = b;
        var f = -1;
        var g = this._actions.length;
        var h = 1;
        if (a > b) {
            d = b;
            e = a;
            f = g;
            g = h = -1
        }
        while ((f += h) != g) {
            var i = this._actions[f];
            var j = i.t;
            if (j == e || j > d && j < e || c && j == a) {
                i.f.apply(i.o, i.p)
            }
        }
    };
    c._appendQueueProps = function(a) {
        var c, d, e;
        for (var f in a) {
            if (this._initQueueProps[f] == null) {
                d = this._target[f];
                if (c = b._plugins[f]) {
                    for (var g = 0, h = c.length; g < h; g++) {
                        e = c[g].init(this, f, d);
                        if (e != b.IGNORE) {
                            d = e
                        }
                    }
                }
                this._initQueueProps[f] = d
            }
            this._curQueueProps[f] = a[f]
        }
        return this._curQueueProps
    };
    c._cloneProps = function(a) {
        var b = {};
        for (var c in a) {
            b[c] = a[c]
        }
        return b
    };
    c._addStep = function(a) {
        if (a.d > 0) {
            this._steps.push(a);
            a.t = this.duration;
            this.duration += a.d
        }
        return this
    };
    c._addAction = function(a) {
        a.t = this.duration;
        this._actions.push(a);
        return this
    };
    c._set = function(a, b) {
        for (var c in a) {
            b[c] = a[c]
        }
    };
    a.Tween = b
})(window);
(function(a) {
    var b = function() {
        throw "Ease cannot be instantiated."
    };
    b.linear = function(a) {
        return a
    };
    b.none = b.linear;
    b.get = function(a) {
        if (a < -1) {
            a = -1
        }
        if (a > 1) {
            a = 1
        }
        return function(b) {
            if (a == 0) {
                return b
            }
            if (a < 0) {
                return b * (b * -a + 1 + a)
            }
            return b * ((2 - b) * a + (1 - a))
        }
    };
    b.getPowIn = function(a) {
        return function(b) {
            return Math.pow(b, a)
        }
    };
    b.getPowOut = function(a) {
        return function(b) {
            return 1 - Math.pow(1 - b, a)
        }
    };
    b.getPowInOut = function(a) {
        return function(b) {
            if ((b *= 2) < 1) return .5 * Math.pow(b, a);
            return 1 - .5 * Math.abs(Math.pow(2 - b, a))
        }
    };
    b.quadIn = b.getPowIn(2);
    b.quadOut = b.getPowOut(2);
    b.quadInOut = b.getPowInOut(2);
    b.cubicIn = b.getPowIn(3);
    b.cubicOut = b.getPowOut(3);
    b.cubicInOut = b.getPowInOut(3);
    b.quartIn = b.getPowIn(4);
    b.quartOut = b.getPowOut(4);
    b.quartInOut = b.getPowInOut(4);
    b.quintIn = b.getPowIn(5);
    b.quintOut = b.getPowOut(5);
    b.quintInOut = b.getPowInOut(5);
    b.sineIn = function(a) {
        return 1 - Math.cos(a * Math.PI / 2)
    };
    b.sineOut = function(a) {
        return Math.sin(a * Math.PI / 2)
    };
    b.sineInOut = function(a) {
        return -.5 * (Math.cos(Math.PI * a) - 1)
    };
    b.getBackIn = function(a) {
        return function(b) {
            return b * b * ((a + 1) * b - a)
        }
    };
    b.backIn = b.getBackIn(1.7);
    b.getBackOut = function(a) {
        return function(b) {
            return --b * b * ((a + 1) * b + a) + 1
        }
    };
    b.backOut = b.getBackOut(1.7);
    b.getBackInOut = function(a) {
        a *= 1.525;
        return function(b) {
            if ((b *= 2) < 1) return .5 * b * b * ((a + 1) * b - a);
            return .5 * ((b -= 2) * b * ((a + 1) * b + a) + 2)
        }
    };
    b.backInOut = b.getBackInOut(1.7);
    b.circIn = function(a) {
        return -(Math.sqrt(1 - a * a) - 1)
    };
    b.circOut = function(a) {
        return Math.sqrt(1 - --a * a)
    };
    b.circInOut = function(a) {
        if ((a *= 2) < 1) return -.5 * (Math.sqrt(1 - a * a) - 1);
        return .5 * (Math.sqrt(1 - (a -= 2) * a) + 1)
    };
    b.bounceIn = function(a) {
        return 1 - b.bounceOut(1 - a)
    };
    b.bounceOut = function(a) {
        if (a < 1 / 2.75) {
            return 7.5625 * a * a
        } else if (a < 2 / 2.75) {
            return 7.5625 * (a -= 1.5 / 2.75) * a + .75
        } else if (a < 2.5 / 2.75) {
            return 7.5625 * (a -= 2.25 / 2.75) * a + .9375
        } else {
            return 7.5625 * (a -= 2.625 / 2.75) * a + .984375
        }
    };
    b.bounceInOut = function(a) {
        if (a < .5) return b.bounceIn(a * 2) * .5;
        return b.bounceOut(a * 2 - 1) * .5 + .5
    };
    b.getElasticIn = function(a, b) {
        var c = Math.PI * 2;
        return function(d) {
            if (d == 0 || d == 1) return d;
            var e = b / c * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (d -= 1)) * Math.sin((d - e) * c / b))
        }
    };
    b.elasticIn = b.getElasticIn(1, .3);
    b.getElasticOut = function(a, b) {
        var c = Math.PI * 2;
        return function(d) {
            if (d == 0 || d == 1) return d;
            var e = b / c * Math.asin(1 / a);
            return a * Math.pow(2, -10 * d) * Math.sin((d - e) * c / b) + 1
        }
    };
    b.elasticOut = b.getElasticOut(1, .3);
    b.getElasticInOut = function(a, b) {
        var c = Math.PI * 2;
        return function(d) {
            var e = b / c * Math.asin(1 / a);
            if ((d *= 2) < 1) return -.5 * a * Math.pow(2, 10 * (d -= 1)) * Math.sin((d - e) * c / b);
            return a * Math.pow(2, -10 * (d -= 1)) * Math.sin((d - e) * c / b) * .5 + 1
        }
    };
    b.elasticInOut = b.getElasticInOut(1, .3 * 1.5);
    a.Ease = b
})(window);
/*TweenMax*/
(window._gsQueue || (window._gsQueue = [])).push(function() {
        "use strict";
        window._gsDefine("TweenMax", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(a, b, c) {
                var d = function(a, b, d) {
                        c.call(this, a, b, d), this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._dirty = !0
                    },
                    e = function(a) {
                        return a.jquery || "function" == typeof a.each && a[0] && a[0].nodeType && a[0].style
                    },
                    f = function(a) {
                        var b = [];
                        return a.each(function() {
                            b.push(this)
                        }), b
                    },
                    g = d.prototype = c.to({}, .1, {}),
                    h = [];
                d.version = "1.9.3", g.constructor = d, g.kill()._gc = !1, d.killTweensOf = d.killDelayedCallsTo = c.killTweensOf, d.getTweensOf = c.getTweensOf, d.ticker = c.ticker, g.invalidate = function() {
                    return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), c.prototype.invalidate.call(this)
                }, g.updateTo = function(a, b) {
                    var e, d = this.ratio;
                    b && this.timeline && this._startTime < this._timeline._time && (this._startTime = this._timeline._time, this._uncache(!1), this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay));
                    for (e in a) this.vars[e] = a[e];
                    if (this._initted)
                        if (b) this._initted = !1;
                        else if (this._notifyPluginsOfEnabled && this._firstPT && c._onPluginEvent("_onDisable", this), this._time / this._duration > .998) {
                        var f = this._time;
                        this.render(0, !0, !1), this._initted = !1, this.render(f, !0, !1)
                    } else if (this._time > 0) {
                        this._initted = !1, this._init();
                        for (var i, g = 1 / (1 - d), h = this._firstPT; h;) i = h.s + h.c, h.c *= g, h.s = i - h.c, h = h._next
                    }
                    return this
                }, g.render = function(a, b, c) {
                    var i, j, k, l, m, n, o, d = this._dirty ? this.totalDuration() : this._totalDuration,
                        e = this._time,
                        f = this._totalTime,
                        g = this._cycle;
                    if (a >= d ? (this._totalTime = d, this._cycle = this._repeat, this._yoyo && 0 !== (1 & this._cycle) ? (this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0) : (this._time = this._duration, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1), this._reversed || (i = !0, j = "onComplete"), 0 === this._duration && ((0 === a || 0 > this._rawPrevTime) && this._rawPrevTime !== a && (c = !0), this._rawPrevTime = a)) : 1e-7 > a ? (this._totalTime = this._time = this._cycle = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== f || 0 === this._duration && this._rawPrevTime > 0) && (j = "onReverseComplete", i = this._reversed), 0 > a ? (this._active = !1, 0 === this._duration && (this._rawPrevTime >= 0 && (c = !0), this._rawPrevTime = a)) : this._initted || (c = !0)) : (this._totalTime = this._time = a, 0 !== this._repeat && (l = this._duration + this._repeatDelay, this._cycle = this._totalTime / l >> 0, 0 !== this._cycle && this._cycle === this._totalTime / l && this._cycle--, this._time = this._totalTime - this._cycle * l, this._yoyo && 0 !== (1 & this._cycle) && (this._time = this._duration - this._time), this._time > this._duration ? this._time = this._duration : 0 > this._time && (this._time = 0)), this._easeType ? (m = this._time / this._duration, n = this._easeType, o = this._easePower, (1 === n || 3 === n && m >= .5) && (m = 1 - m), 3 === n && (m *= 2), 1 === o ? m *= m : 2 === o ? m *= m * m : 3 === o ? m *= m * m * m : 4 === o && (m *= m * m * m * m), this.ratio = 1 === n ? 1 - m : 2 === n ? m : .5 > this._time / this._duration ? m / 2 : 1 - m / 2) : this.ratio = this._ease.getRatio(this._time / this._duration)), e === this._time && !c) return f !== this._totalTime && this._onUpdate && (b || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || h)), void 0;
                    if (!this._initted) {
                        if (this._init(), !this._initted) return;
                        this._time && !i ? this.ratio = this._ease.getRatio(this._time / this._duration) : i && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
                    }
                    for (this._active || this._paused || (this._active = !0), 0 === f && (this._startAt && (a >= 0 ? this._startAt.render(a, b, c) : j || (j = "_dummyGS")), this.vars.onStart && (0 !== this._totalTime || 0 === this._duration) && (b || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || h))), k = this._firstPT; k;) k.f ? k.t[k.p](k.c * this.ratio + k.s) : k.t[k.p] = k.c * this.ratio + k.s, k = k._next;
                    this._onUpdate && (0 > a && this._startAt && this._startAt.render(a, b, c), b || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || h)), this._cycle !== g && (b || this._gc || this.vars.onRepeat && this.vars.onRepeat.apply(this.vars.onRepeatScope || this, this.vars.onRepeatParams || h)), j && (this._gc || (0 > a && this._startAt && !this._onUpdate && this._startAt.render(a, b, c), i && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !b && this.vars[j] && this.vars[j].apply(this.vars[j + "Scope"] || this, this.vars[j + "Params"] || h)))
                }, d.to = function(a, b, c) {
                    return new d(a, b, c)
                }, d.from = function(a, b, c) {
                    return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, new d(a, b, c)
                }, d.fromTo = function(a, b, c, e) {
                    return e.startAt = c, e.immediateRender = 0 != e.immediateRender && 0 != c.immediateRender, new d(a, b, e)
                }, d.staggerTo = d.allTo = function(a, b, g, i, j, k, l) {
                    i = i || 0;
                    var p, q, r, s, m = g.delay || 0,
                        n = [],
                        o = function() {
                            g.onComplete && g.onComplete.apply(g.onCompleteScope || this, g.onCompleteParams || h), j.apply(l || this, k || h)
                        };
                    for (a instanceof Array || ("string" == typeof a && (a = c.selector(a) || a), e(a) && (a = f(a))), p = a.length, r = 0; p > r; r++) {
                        q = {};
                        for (s in g) q[s] = g[s];
                        q.delay = m, r === p - 1 && j && (q.onComplete = o), n[r] = new d(a[r], b, q), m += i
                    }
                    return n
                }, d.staggerFrom = d.allFrom = function(a, b, c, e, f, g, h) {
                    return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, d.staggerTo(a, b, c, e, f, g, h)
                }, d.staggerFromTo = d.allFromTo = function(a, b, c, e, f, g, h, i) {
                    return e.startAt = c, e.immediateRender = 0 != e.immediateRender && 0 != c.immediateRender, d.staggerTo(a, b, e, f, g, h, i)
                }, d.delayedCall = function(a, b, c, e, f) {
                    return new d(b, 0, {
                        delay: a,
                        onComplete: b,
                        onCompleteParams: c,
                        onCompleteScope: e,
                        onReverseComplete: b,
                        onReverseCompleteParams: c,
                        onReverseCompleteScope: e,
                        immediateRender: !1,
                        useFrames: f,
                        overwrite: 0
                    })
                }, d.set = function(a, b) {
                    return new d(a, 0, b)
                }, d.isTweening = function(a) {
                    for (var e, b = c.getTweensOf(a), d = b.length; --d > -1;)
                        if (e = b[d], e._active || e._startTime === e._timeline._time && e._timeline._active) return !0;
                    return !1
                };
                var i = function(a, b) {
                        for (var d = [], e = 0, f = a._first; f;) f instanceof c ? d[e++] = f : (b && (d[e++] = f), d = d.concat(i(f, b)), e = d.length), f = f._next;
                        return d
                    },
                    j = d.getAllTweens = function(b) {
                        return i(a._rootTimeline, b).concat(i(a._rootFramesTimeline, b))
                    };
                d.killAll = function(a, c, d, e) {
                    null == c && (c = !0), null == d && (d = !0);
                    var i, k, l, f = j(0 != e),
                        g = f.length,
                        h = c && d && e;
                    for (l = 0; g > l; l++) k = f[l], (h || k instanceof b || (i = k.target === k.vars.onComplete) && d || c && !i) && (a ? k.totalTime(k.totalDuration()) : k._enabled(!1, !1))
                }, d.killChildTweensOf = function(a, b) {
                    if (null != a) {
                        var h, i, j, k, l, g = c._tweenLookup;
                        if ("string" == typeof a && (a = c.selector(a) || a), e(a) && (a = f(a)), a instanceof Array)
                            for (k = a.length; --k > -1;) d.killChildTweensOf(a[k], b);
                        else {
                            h = [];
                            for (j in g)
                                for (i = g[j].target.parentNode; i;) i === a && (h = h.concat(g[j].tweens)), i = i.parentNode;
                            for (l = h.length, k = 0; l > k; k++) b && h[k].totalTime(h[k].totalDuration()), h[k]._enabled(!1, !1)
                        }
                    }
                };
                var k = function(a, c, d, e) {
                    void 0 === c && (c = !0), void 0 === d && (d = !0);
                    for (var i, k, f = j(e), g = c && d && e, h = f.length; --h > -1;) k = f[h], (g || k instanceof b || (i = k.target === k.vars.onComplete) && d || c && !i) && k.paused(a)
                };
                return d.pauseAll = function(a, b, c) {
                    k(!0, a, b, c)
                }, d.resumeAll = function(a, b, c) {
                    k(!1, a, b, c)
                }, g.progress = function(a) {
                    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), !1) : this._time / this.duration()
                }, g.totalProgress = function(a) {
                    return arguments.length ? this.totalTime(this.totalDuration() * a, !1) : this._totalTime / this.totalDuration()
                }, g.time = function(a, b) {
                    return arguments.length ? (this._dirty && this.totalDuration(), a > this._duration && (a = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? a = this._duration - a + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(a, b)) : this._time
                }, g.duration = function(b) {
                    return arguments.length ? a.prototype.duration.call(this, b) : this._duration
                }, g.totalDuration = function(a) {
                    return arguments.length ? -1 === this._repeat ? this : this.duration((a - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat, this._dirty = !1), this._totalDuration)
                }, g.repeat = function(a) {
                    return arguments.length ? (this._repeat = a, this._uncache(!0)) : this._repeat
                }, g.repeatDelay = function(a) {
                    return arguments.length ? (this._repeatDelay = a, this._uncache(!0)) : this._repeatDelay
                }, g.yoyo = function(a) {
                    return arguments.length ? (this._yoyo = a, this) : this._yoyo
                }, d
            }, !0), window._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(a, b, c) {
                var d = function(a) {
                        b.call(this, a), this._labels = {}, this.autoRemoveChildren = this.vars.autoRemoveChildren === !0, this.smoothChildTiming = this.vars.smoothChildTiming === !0, this._sortChildren = !0, this._onUpdate = this.vars.onUpdate;
                        for (var f, g, c = this.vars, d = e.length; --d > -1;)
                            if (g = c[e[d]])
                                for (f = g.length; --f > -1;) "{self}" === g[f] && (g = c[e[d]] = g.concat(), g[f] = this);
                        c.tweens instanceof Array && this.add(c.tweens, 0, c.align, c.stagger)
                    },
                    e = ["onStartParams", "onUpdateParams", "onCompleteParams", "onReverseCompleteParams", "onRepeatParams"],
                    f = [],
                    g = function(a) {
                        var c, b = {};
                        for (c in a) b[c] = a[c];
                        return b
                    },
                    h = d.prototype = new b;
                return d.version = "1.9.3", h.constructor = d, h.kill()._gc = !1, h.to = function(a, b, d, e) {
                    return this.add(new c(a, b, d), e)
                }, h.from = function(a, b, d, e) {
                    return this.add(c.from(a, b, d), e)
                }, h.fromTo = function(a, b, d, e, f) {
                    return this.add(c.fromTo(a, b, d, e), f)
                }, h.staggerTo = function(a, b, e, f, h, i, j, k) {
                    var m, n, l = new d({
                        onComplete: i,
                        onCompleteParams: j,
                        onCompleteScope: k
                    });
                    for ("string" == typeof a && (a = c.selector(a) || a), !(a instanceof Array) && "function" == typeof a.each && a[0] && a[0].nodeType && a[0].style && (n = [], a.each(function() {
                            n.push(this)
                        }), a = n), f = f || 0, m = 0; a.length > m; m++) e.startAt && (e.startAt = g(e.startAt)), l.add(new c(a[m], b, g(e)), m * f);
                    return this.add(l, h)
                }, h.staggerFrom = function(a, b, c, d, e, f, g, h) {
                    return c.immediateRender = 0 != c.immediateRender, c.runBackwards = !0, this.staggerTo(a, b, c, d, e, f, g, h)
                }, h.staggerFromTo = function(a, b, c, d, e, f, g, h, i) {
                    return d.startAt = c, d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender, this.staggerTo(a, b, d, e, f, g, h, i)
                }, h.call = function(a, b, d, e) {
                    return this.add(c.delayedCall(0, a, b, d), e)
                }, h.set = function(a, b, d) {
                    return d = this._parseTimeOrLabel(d, 0, !0), null == b.immediateRender && (b.immediateRender = d === this._time && !this._paused), this.add(new c(a, 0, b), d)
                }, d.exportRoot = function(a, b) {
                    a = a || {}, null == a.smoothChildTiming && (a.smoothChildTiming = !0);
                    var g, h, e = new d(a),
                        f = e._timeline;
                    for (null == b && (b = !0), f._remove(e, !0), e._startTime = 0, e._rawPrevTime = e._time = e._totalTime = f._time, g = f._first; g;) h = g._next, b && g instanceof c && g.target === g.vars.onComplete || e.add(g, g._startTime - g._delay), g = h;
                    return f.add(e, 0), e
                }, h.add = function(e, f, g, h) {
                    var i, j, k, l, m;
                    if ("number" != typeof f && (f = this._parseTimeOrLabel(f, 0, !0, e)), !(e instanceof a)) {
                        if (e instanceof Array) {
                            for (g = g || "normal", h = h || 0, i = f, j = e.length, k = 0; j > k; k++)(l = e[k]) instanceof Array && (l = new d({
                                tweens: l
                            })), this.add(l, i), "string" != typeof l && "function" != typeof l && ("sequence" === g ? i = l._startTime + l.totalDuration() / l._timeScale : "start" === g && (l._startTime -= l.delay())), i += h;
                            return this._uncache(!0)
                        }
                        if ("string" == typeof e) return this.addLabel(e, f);
                        if ("function" != typeof e) throw "Cannot add " + e + " into the timeline: it is neither a tween, timeline, function, nor a string.";
                        e = c.delayedCall(0, e)
                    }
                    if (b.prototype.add.call(this, e, f), this._gc && !this._paused && this._time === this._duration && this._time < this.duration())
                        for (m = this; m._gc && m._timeline;) m._timeline.smoothChildTiming ? m.totalTime(m._totalTime, !0) : m._enabled(!0, !1), m = m._timeline;
                    return this
                }, h.remove = function(b) {
                    if (b instanceof a) return this._remove(b, !1);
                    if (b instanceof Array) {
                        for (var c = b.length; --c > -1;) this.remove(b[c]);
                        return this
                    }
                    return "string" == typeof b ? this.removeLabel(b) : this.kill(null, b)
                }, h.append = function(a, b) {
                    return this.add(a, this._parseTimeOrLabel(null, b, !0, a))
                }, h.insert = h.insertMultiple = function(a, b, c, d) {
                    return this.add(a, b || 0, c, d)
                }, h.appendMultiple = function(a, b, c, d) {
                    return this.add(a, this._parseTimeOrLabel(null, b, !0, a), c, d)
                }, h.addLabel = function(a, b) {
                    return this._labels[a] = this._parseTimeOrLabel(b), this
                }, h.removeLabel = function(a) {
                    return delete this._labels[a], this
                }, h.getLabelTime = function(a) {
                    return null != this._labels[a] ? this._labels[a] : -1
                }, h._parseTimeOrLabel = function(b, c, d, e) {
                    var f;
                    if (e instanceof a && e.timeline === this) this.remove(e);
                    else if (e instanceof Array)
                        for (f = e.length; --f > -1;) e[f] instanceof a && e[f].timeline === this && this.remove(e[f]);
                    if ("string" == typeof c) return this._parseTimeOrLabel(c, d && "number" == typeof b && null == this._labels[c] ? b - this.duration() : 0, d);
                    if (c = c || 0, "string" != typeof b || !isNaN(b) && null == this._labels[b]) null == b && (b = this.duration());
                    else {
                        if (f = b.indexOf("="), -1 === f) return null == this._labels[b] ? d ? this._labels[b] = this.duration() + c : c : this._labels[b] + c;
                        c = parseInt(b.charAt(f - 1) + "1", 10) * Number(b.substr(f + 1)), b = f > 1 ? this._parseTimeOrLabel(b.substr(0, f - 1), 0, d) : this.duration()
                    }
                    return Number(b) + c
                }, h.seek = function(a, b) {
                    return this.totalTime("number" == typeof a ? a : this._parseTimeOrLabel(a), b !== !1)
                }, h.stop = function() {
                    return this.paused(!0)
                }, h.gotoAndPlay = function(a, b) {
                    return this.play(a, b)
                }, h.gotoAndStop = function(a, b) {
                    return this.pause(a, b)
                }, h.render = function(a, b, c) {
                    this._gc && this._enabled(!0, !1), this._active = !this._paused;
                    var j, k, l, m, n, d = this._dirty ? this.totalDuration() : this._totalDuration,
                        e = this._time,
                        g = this._startTime,
                        h = this._timeScale,
                        i = this._paused;
                    if (a >= d ? (this._totalTime = this._time = d, this._reversed || this._hasPausedChild() || (k = !0, m = "onComplete", 0 === this._duration && (0 === a || 0 > this._rawPrevTime) && this._rawPrevTime !== a && (n = !0)), this._rawPrevTime = a, a = d + 1e-6) : 1e-7 > a ? (this._totalTime = this._time = 0, (0 !== e || 0 === this._duration && this._rawPrevTime > 0) && (m = "onReverseComplete", k = this._reversed), 0 > a ? (this._active = !1, 0 === this._duration && this._rawPrevTime >= 0 && (n = !0)) : this._initted || (n = !0), this._rawPrevTime = a) : this._totalTime = this._time = this._rawPrevTime = a, this._time !== e || c || n) {
                        if (this._initted || (this._initted = !0), 0 === e && this.vars.onStart && 0 !== this._time && (b || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || f)), this._time >= e)
                            for (j = this._first; j && (l = j._next, !this._paused || i);)(j._active || j._startTime <= this._time && !j._paused && !j._gc) && (j._reversed ? j.render((j._dirty ? j.totalDuration() : j._totalDuration) - (a - j._startTime) * j._timeScale, b, c) : j.render((a - j._startTime) * j._timeScale, b, c)), j = l;
                        else
                            for (j = this._last; j && (l = j._prev, !this._paused || i);)(j._active || e >= j._startTime && !j._paused && !j._gc) && (j._reversed ? j.render((j._dirty ? j.totalDuration() : j._totalDuration) - (a - j._startTime) * j._timeScale, b, c) : j.render((a - j._startTime) * j._timeScale, b, c)), j = l;
                        this._onUpdate && (b || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || f)), m && (this._gc || (g === this._startTime || h !== this._timeScale) && (0 === this._time || d >= this.totalDuration()) && (k && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !b && this.vars[m] && this.vars[m].apply(this.vars[m + "Scope"] || this, this.vars[m + "Params"] || f)))
                    }
                }, h._hasPausedChild = function() {
                    for (var a = this._first; a;) {
                        if (a._paused || a instanceof d && a._hasPausedChild()) return !0;
                        a = a._next
                    }
                    return !1
                }, h.getChildren = function(a, b, d, e) {
                    e = e || -9999999999;
                    for (var f = [], g = this._first, h = 0; g;) e > g._startTime || (g instanceof c ? b !== !1 && (f[h++] = g) : (d !== !1 && (f[h++] = g), a !== !1 && (f = f.concat(g.getChildren(!0, b, d)), h = f.length))), g = g._next;
                    return f
                }, h.getTweensOf = function(a, b) {
                    for (var d = c.getTweensOf(a), e = d.length, f = [], g = 0; --e > -1;)(d[e].timeline === this || b && this._contains(d[e])) && (f[g++] = d[e]);
                    return f
                }, h._contains = function(a) {
                    for (var b = a.timeline; b;) {
                        if (b === this) return !0;
                        b = b.timeline
                    }
                    return !1
                }, h.shiftChildren = function(a, b, c) {
                    c = c || 0;
                    for (var f, d = this._first, e = this._labels; d;) d._startTime >= c && (d._startTime += a), d = d._next;
                    if (b)
                        for (f in e) e[f] >= c && (e[f] += a);
                    return this._uncache(!0)
                }, h._kill = function(a, b) {
                    if (!a && !b) return this._enabled(!1, !1);
                    for (var c = b ? this.getTweensOf(b) : this.getChildren(!0, !0, !1), d = c.length, e = !1; --d > -1;) c[d]._kill(a, b) && (e = !0);
                    return e
                }, h.clear = function(a) {
                    var b = this.getChildren(!1, !0, !0),
                        c = b.length;
                    for (this._time = this._totalTime = 0; --c > -1;) b[c]._enabled(!1, !1);
                    return a !== !1 && (this._labels = {}), this._uncache(!0)
                }, h.invalidate = function() {
                    for (var a = this._first; a;) a.invalidate(), a = a._next;
                    return this
                }, h._enabled = function(a, c) {
                    if (a === this._gc)
                        for (var d = this._first; d;) d._enabled(a, !0), d = d._next;
                    return b.prototype._enabled.call(this, a, c)
                }, h.progress = function(a) {
                    return arguments.length ? this.totalTime(this.duration() * a, !1) : this._time / this.duration()
                }, h.duration = function(a) {
                    return arguments.length ? (0 !== this.duration() && 0 !== a && this.timeScale(this._duration / a), this) : (this._dirty && this.totalDuration(), this._duration)
                }, h.totalDuration = function(a) {
                    if (!arguments.length) {
                        if (this._dirty) {
                            for (var e, f, b = 0, c = this._last, d = 999999999999; c;) e = c._prev, c._dirty && c.totalDuration(), c._startTime > d && this._sortChildren && !c._paused ? this.add(c, c._startTime - c._delay) : d = c._startTime, 0 > c._startTime && !c._paused && (b -= c._startTime, this._timeline.smoothChildTiming && (this._startTime += c._startTime / this._timeScale), this.shiftChildren(-c._startTime, !1, -9999999999), d = 0), f = c._startTime + c._totalDuration / c._timeScale, f > b && (b = f), c = e;
                            this._duration = this._totalDuration = b, this._dirty = !1
                        }
                        return this._totalDuration
                    }
                    return 0 !== this.totalDuration() && 0 !== a && this.timeScale(this._totalDuration / a), this
                }, h.usesFrames = function() {
                    for (var b = this._timeline; b._timeline;) b = b._timeline;
                    return b === a._rootFramesTimeline
                }, h.rawTime = function() {
                    return this._paused || 0 !== this._totalTime && this._totalTime !== this._totalDuration ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale
                }, d
            }, !0), window._gsDefine("TimelineMax", ["TimelineLite", "TweenLite", "easing.Ease"], function(a, b, c) {
                var d = function(b) {
                        a.call(this, b), this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._dirty = !0
                    },
                    e = [],
                    f = new c(null, null, 1, 0),
                    g = function(a) {
                        for (; a;) {
                            if (a._paused) return !0;
                            a = a._timeline
                        }
                        return !1
                    },
                    h = d.prototype = new a;
                return h.constructor = d, h.kill()._gc = !1, d.version = "1.9.3", h.invalidate = function() {
                    return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), a.prototype.invalidate.call(this)
                }, h.addCallback = function(a, c, d, e) {
                    return this.add(b.delayedCall(0, a, d, e), c)
                }, h.removeCallback = function(a, b) {
                    if (null == b) this._kill(null, a);
                    else
                        for (var c = this.getTweensOf(a, !1), d = c.length, e = this._parseTimeOrLabel(b); --d > -1;) c[d]._startTime === e && c[d]._enabled(!1, !1);
                    return this
                }, h.tweenTo = function(a, c) {
                    c = c || {};
                    var g, h, d = {
                        ease: f,
                        overwrite: 2,
                        useFrames: this.usesFrames(),
                        immediateRender: !1
                    };
                    for (g in c) d[g] = c[g];
                    return d.time = this._parseTimeOrLabel(a), h = new b(this, Math.abs(Number(d.time) - this._time) / this._timeScale || .001, d), d.onStart = function() {
                        h.target.paused(!0), h.vars.time !== h.target.time() && h.duration(Math.abs(h.vars.time - h.target.time()) / h.target._timeScale), c.onStart && c.onStart.apply(c.onStartScope || h, c.onStartParams || e)
                    }, h
                }, h.tweenFromTo = function(a, b, c) {
                    c = c || {}, c.startAt = {
                        time: this._parseTimeOrLabel(a)
                    };
                    var d = this.tweenTo(b, c);
                    return d.duration(Math.abs(d.vars.time - d.vars.startAt.time) / this._timeScale || .001)
                }, h.render = function(a, b, c) {
                    this._gc && this._enabled(!0, !1), this._active = !this._paused;
                    var n, o, p, q, r, s, d = this._dirty ? this.totalDuration() : this._totalDuration,
                        f = this._duration,
                        g = this._time,
                        h = this._totalTime,
                        i = this._startTime,
                        j = this._timeScale,
                        k = this._rawPrevTime,
                        l = this._paused,
                        m = this._cycle;
                    if (a >= d ? (this._locked || (this._totalTime = d, this._cycle = this._repeat), this._reversed || this._hasPausedChild() || (o = !0, q = "onComplete", 0 === f && (0 === a || 0 > this._rawPrevTime) && this._rawPrevTime !== a && (r = !0)), this._rawPrevTime = a, this._yoyo && 0 !== (1 & this._cycle) ? this._time = a = 0 : (this._time = f, a = f + 1e-6)) : 1e-7 > a ? (this._locked || (this._totalTime = this._cycle = 0), this._time = 0, (0 !== g || 0 === f && this._rawPrevTime > 0 && !this._locked) && (q = "onReverseComplete", o = this._reversed), 0 > a ? (this._active = !1, 0 === f && this._rawPrevTime >= 0 && (r = !0)) : this._initted || (r = !0), this._rawPrevTime = a, a = 0) : (this._time = this._rawPrevTime = a, this._locked || (this._totalTime = a, 0 !== this._repeat && (s = f + this._repeatDelay, this._cycle = this._totalTime / s >> 0, 0 !== this._cycle && this._cycle === this._totalTime / s && this._cycle--, this._time = this._totalTime - this._cycle * s, this._yoyo && 0 !== (1 & this._cycle) && (this._time = f - this._time), this._time > f ? (this._time = f, a = f + 1e-6) : 0 > this._time ? this._time = a = 0 : a = this._time))), this._cycle !== m && !this._locked) {
                        var t = this._yoyo && 0 !== (1 & m),
                            u = t === (this._yoyo && 0 !== (1 & this._cycle)),
                            v = this._totalTime,
                            w = this._cycle,
                            x = this._rawPrevTime,
                            y = this._time;
                        this._totalTime = m * f, m > this._cycle ? t = !t : this._totalTime += f, this._time = g, this._rawPrevTime = 0 === f ? k - 1e-5 : k, this._cycle = m, this._locked = !0, g = t ? 0 : f, this.render(g, b, 0 === f), b || this._gc || this.vars.onRepeat && this.vars.onRepeat.apply(this.vars.onRepeatScope || this, this.vars.onRepeatParams || e), u && (g = t ? f + 1e-6 : -1e-6, this.render(g, !0, !1)), this._time = y, this._totalTime = v, this._cycle = w, this._rawPrevTime = x, this._locked = !1
                    }
                    if (this._time === g && !c && !r) return h !== this._totalTime && this._onUpdate && (b || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || e)), void 0;
                    if (this._initted || (this._initted = !0), 0 === h && this.vars.onStart && 0 !== this._totalTime && (b || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || e)), this._time >= g)
                        for (n = this._first; n && (p = n._next, !this._paused || l);)(n._active || n._startTime <= this._time && !n._paused && !n._gc) && (n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (a - n._startTime) * n._timeScale, b, c) : n.render((a - n._startTime) * n._timeScale, b, c)), n = p;
                    else
                        for (n = this._last; n && (p = n._prev, !this._paused || l);)(n._active || g >= n._startTime && !n._paused && !n._gc) && (n._reversed ? n.render((n._dirty ? n.totalDuration() : n._totalDuration) - (a - n._startTime) * n._timeScale, b, c) : n.render((a - n._startTime) * n._timeScale, b, c)), n = p;
                    this._onUpdate && (b || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || e)), q && (this._locked || this._gc || (i === this._startTime || j !== this._timeScale) && (0 === this._time || d >= this.totalDuration()) && (o && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !b && this.vars[q] && this.vars[q].apply(this.vars[q + "Scope"] || this, this.vars[q + "Params"] || e)))
                }, h.getActive = function(a, b, c) {
                    null == a && (a = !0), null == b && (b = !0), null == c && (c = !1);
                    var i, j, d = [],
                        e = this.getChildren(a, b, c),
                        f = 0,
                        h = e.length;
                    for (i = 0; h > i; i++) j = e[i], j._paused || j._timeline._time >= j._startTime && j._timeline._time < j._startTime + j._totalDuration / j._timeScale && (g(j._timeline) || (d[f++] = j));
                    return d
                }, h.getLabelAfter = function(a) {
                    a || 0 !== a && (a = this._time);
                    var d, b = this.getLabelsArray(),
                        c = b.length;
                    for (d = 0; c > d; d++)
                        if (b[d].time > a) return b[d].name;
                    return null
                }, h.getLabelBefore = function(a) {
                    null == a && (a = this._time);
                    for (var b = this.getLabelsArray(), c = b.length; --c > -1;)
                        if (a > b[c].time) return b[c].name;
                    return null
                }, h.getLabelsArray = function() {
                    var c, a = [],
                        b = 0;
                    for (c in this._labels) a[b++] = {
                        time: this._labels[c],
                        name: c
                    };
                    return a.sort(function(a, b) {
                        return a.time - b.time
                    }), a
                }, h.progress = function(a) {
                    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), !1) : this._time / this.duration()
                }, h.totalProgress = function(a) {
                    return arguments.length ? this.totalTime(this.totalDuration() * a, !1) : this._totalTime / this.totalDuration()
                }, h.totalDuration = function(b) {
                    return arguments.length ? -1 === this._repeat ? this : this.duration((b - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (a.prototype.totalDuration.call(this), this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), this._totalDuration)
                }, h.time = function(a, b) {
                    return arguments.length ? (this._dirty && this.totalDuration(), a > this._duration && (a = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? a = this._duration - a + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(a, b)) : this._time
                }, h.repeat = function(a) {
                    return arguments.length ? (this._repeat = a, this._uncache(!0)) : this._repeat
                }, h.repeatDelay = function(a) {
                    return arguments.length ? (this._repeatDelay = a, this._uncache(!0)) : this._repeatDelay
                }, h.yoyo = function(a) {
                    return arguments.length ? (this._yoyo = a, this) : this._yoyo
                }, h.currentLabel = function(a) {
                    return arguments.length ? this.seek(a, !0) : this.getLabelBefore(this._time + 1e-8)
                }, d
            }, !0),
            function() {
                var a = 180 / Math.PI,
                    b = Math.PI / 180,
                    c = [],
                    d = [],
                    e = [],
                    f = {},
                    g = function(a, b, c, d) {
                        this.a = a, this.b = b, this.c = c, this.d = d, this.da = d - a, this.ca = c - a, this.ba = b - a
                    },
                    h = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
                    i = function(a, b, c, d) {
                        var e = {
                                a: a
                            },
                            f = {},
                            g = {},
                            h = {
                                c: d
                            },
                            i = (a + b) / 2,
                            j = (b + c) / 2,
                            k = (c + d) / 2,
                            l = (i + j) / 2,
                            m = (j + k) / 2,
                            n = (m - l) / 8;
                        return e.b = i + (a - i) / 4, f.b = l + n, e.c = f.a = (e.b + f.b) / 2, f.c = g.a = (l + m) / 2, g.b = m - n, h.b = k + (d - k) / 4, g.c = h.a = (g.b + h.b) / 2, [e, f, g, h]
                    },
                    j = function(a, b, f, g, h) {
                        var m, n, o, p, q, r, s, t, u, v, w, x, y, j = a.length - 1,
                            k = 0,
                            l = a[0].a;
                        for (m = 0; j > m; m++) q = a[k], n = q.a, o = q.d, p = a[k + 1].d, h ? (w = c[m], x = d[m], y = .25 * (x + w) * b / (g ? .5 : e[m] || .5), r = o - (o - n) * (g ? .5 * b : 0 !== w ? y / w : 0), s = o + (p - o) * (g ? .5 * b : 0 !== x ? y / x : 0), t = o - (r + ((s - r) * (3 * w / (w + x) + .5) / 4 || 0))) : (r = o - .5 * (o - n) * b, s = o + .5 * (p - o) * b, t = o - (r + s) / 2), r += t, s += t, q.c = u = r, q.b = 0 !== m ? l : l = q.a + .6 * (q.c - q.a), q.da = o - n, q.ca = u - n, q.ba = l - n, f ? (v = i(n, l, u, o), a.splice(k, 1, v[0], v[1], v[2], v[3]), k += 4) : k++, l = s;
                        q = a[k], q.b = l, q.c = l + .4 * (q.d - l), q.da = q.d - q.a, q.ca = q.c - q.a, q.ba = l - q.a, f && (v = i(q.a, l, q.c, q.d), a.splice(k, 1, v[0], v[1], v[2], v[3]))
                    },
                    k = function(a, b, e, f) {
                        var i, j, k, l, m, n, h = [];
                        if (f)
                            for (a = [f].concat(a), j = a.length; --j > -1;) "string" == typeof(n = a[j][b]) && "=" === n.charAt(1) && (a[j][b] = f[b] + Number(n.charAt(0) + n.substr(2)));
                        if (i = a.length - 2, 0 > i) return h[0] = new g(a[0][b], 0, 0, a[-1 > i ? 0 : 1][b]), h;
                        for (j = 0; i > j; j++) k = a[j][b], l = a[j + 1][b], h[j] = new g(k, 0, 0, l), e && (m = a[j + 2][b], c[j] = (c[j] || 0) + (l - k) * (l - k), d[j] = (d[j] || 0) + (m - l) * (m - l));
                        return h[j] = new g(a[j][b], 0, 0, a[j + 1][b]), h
                    },
                    l = function(a, b, g, i, l, m) {
                        var q, r, s, t, u, v, w, x, n = {},
                            o = [],
                            p = m || a[0];
                        l = "string" == typeof l ? "," + l + "," : h, null == b && (b = 1);
                        for (r in a[0]) o.push(r);
                        if (a.length > 1) {
                            for (x = a[a.length - 1], w = !0, q = o.length; --q > -1;)
                                if (r = o[q], Math.abs(p[r] - x[r]) > .05) {
                                    w = !1;
                                    break
                                } w && (a = a.concat(), m && a.unshift(m), a.push(a[1]), m = a[a.length - 3])
                        }
                        for (c.length = d.length = e.length = 0, q = o.length; --q > -1;) r = o[q], f[r] = -1 !== l.indexOf("," + r + ","), n[r] = k(a, r, f[r], m);
                        for (q = c.length; --q > -1;) c[q] = Math.sqrt(c[q]), d[q] = Math.sqrt(d[q]);
                        if (!i) {
                            for (q = o.length; --q > -1;)
                                if (f[r])
                                    for (s = n[o[q]], v = s.length - 1, t = 0; v > t; t++) u = s[t + 1].da / d[t] + s[t].da / c[t], e[t] = (e[t] || 0) + u * u;
                            for (q = e.length; --q > -1;) e[q] = Math.sqrt(e[q])
                        }
                        for (q = o.length, t = g ? 4 : 1; --q > -1;) r = o[q], s = n[r], j(s, b, g, i, f[r]), w && (s.splice(0, t), s.splice(s.length - t, t));
                        return n
                    },
                    m = function(a, b, c) {
                        b = b || "soft";
                        var i, j, k, l, m, n, o, p, q, r, s, d = {},
                            e = "cubic" === b ? 3 : 2,
                            f = "soft" === b,
                            h = [];
                        if (f && c && (a = [c].concat(a)), null == a || e + 1 > a.length) throw "invalid Bezier data";
                        for (q in a[0]) h.push(q);
                        for (n = h.length; --n > -1;) {
                            for (q = h[n], d[q] = m = [], r = 0, p = a.length, o = 0; p > o; o++) i = null == c ? a[o][q] : "string" == typeof(s = a[o][q]) && "=" === s.charAt(1) ? c[q] + Number(s.charAt(0) + s.substr(2)) : Number(s), f && o > 1 && p - 1 > o && (m[r++] = (i + m[r - 2]) / 2), m[r++] = i;
                            for (p = r - e + 1, r = 0, o = 0; p > o; o += e) i = m[o], j = m[o + 1], k = m[o + 2], l = 2 === e ? 0 : m[o + 3], m[r++] = s = 3 === e ? new g(i, j, k, l) : new g(i, (2 * j + i) / 3, (2 * j + k) / 3, k);
                            m.length = r
                        }
                        return d
                    },
                    n = function(a, b, c) {
                        for (var f, g, h, i, j, k, l, m, n, o, p, d = 1 / c, e = a.length; --e > -1;)
                            for (o = a[e], h = o.a, i = o.d - h, j = o.c - h, k = o.b - h, f = g = 0, m = 1; c >= m; m++) l = d * m, n = 1 - l, f = g - (g = (l * l * i + 3 * n * (l * j + n * k)) * l), p = e * c + m - 1, b[p] = (b[p] || 0) + f * f
                    },
                    o = function(a, b) {
                        b = b >> 0 || 6;
                        var j, k, l, m, c = [],
                            d = [],
                            e = 0,
                            f = 0,
                            g = b - 1,
                            h = [],
                            i = [];
                        for (j in a) n(a[j], c, b);
                        for (l = c.length, k = 0; l > k; k++) e += Math.sqrt(c[k]), m = k % b, i[m] = e, m === g && (f += e, m = k / b >> 0, h[m] = i, d[m] = f, e = 0, i = []);
                        return {
                            length: f,
                            lengths: d,
                            segments: h
                        }
                    },
                    p = window._gsDefine.plugin({
                        propName: "bezier",
                        priority: -1,
                        API: 2,
                        global: !0,
                        init: function(a, b, c) {
                            this._target = a, b instanceof Array && (b = {
                                values: b
                            }), this._func = {}, this._round = {}, this._props = [], this._timeRes = null == b.timeResolution ? 6 : parseInt(b.timeResolution, 10);
                            var h, i, j, k, n, d = b.values || [],
                                e = {},
                                f = d[0],
                                g = b.autoRotate || c.vars.orientToBezier;
                            this._autoRotate = g ? g instanceof Array ? g : [
                                ["x", "y", "rotation", g === !0 ? 0 : Number(g) || 0]
                            ] : null;
                            for (h in f) this._props.push(h);
                            for (j = this._props.length; --j > -1;) h = this._props[j], this._overwriteProps.push(h), i = this._func[h] = "function" == typeof a[h], e[h] = i ? a[h.indexOf("set") || "function" != typeof a["get" + h.substr(3)] ? h : "get" + h.substr(3)]() : parseFloat(a[h]), n || e[h] !== d[0][h] && (n = e);
                            if (this._beziers = "cubic" !== b.type && "quadratic" !== b.type && "soft" !== b.type ? l(d, isNaN(b.curviness) ? 1 : b.curviness, !1, "thruBasic" === b.type, b.correlate, n) : m(d, b.type, e), this._segCount = this._beziers[h].length, this._timeRes) {
                                var p = o(this._beziers, this._timeRes);
                                this._length = p.length, this._lengths = p.lengths, this._segments = p.segments, this._l1 = this._li = this._s1 = this._si = 0, this._l2 = this._lengths[0], this._curSeg = this._segments[0], this._s2 = this._curSeg[0], this._prec = 1 / this._curSeg.length
                            }
                            if (g = this._autoRotate)
                                for (g[0] instanceof Array || (this._autoRotate = g = [g]), j = g.length; --j > -1;)
                                    for (k = 0; 3 > k; k++) h = g[j][k], this._func[h] = "function" == typeof a[h] ? a[h.indexOf("set") || "function" != typeof a["get" + h.substr(3)] ? h : "get" + h.substr(3)] : !1;
                            return !0
                        },
                        set: function(b) {
                            var f, g, h, i, j, k, l, m, n, o, c = this._segCount,
                                d = this._func,
                                e = this._target;
                            if (this._timeRes) {
                                if (n = this._lengths, o = this._curSeg, b *= this._length, h = this._li, b > this._l2 && c - 1 > h) {
                                    for (m = c - 1; m > h && b >= (this._l2 = n[++h]););
                                    this._l1 = n[h - 1], this._li = h, this._curSeg = o = this._segments[h], this._s2 = o[this._s1 = this._si = 0]
                                } else if (this._l1 > b && h > 0) {
                                    for (; h > 0 && (this._l1 = n[--h]) >= b;);
                                    0 === h && this._l1 > b ? this._l1 = 0 : h++, this._l2 = n[h], this._li = h, this._curSeg = o = this._segments[h], this._s1 = o[(this._si = o.length - 1) - 1] || 0, this._s2 = o[this._si]
                                }
                                if (f = h, b -= this._l1, h = this._si, b > this._s2 && o.length - 1 > h) {
                                    for (m = o.length - 1; m > h && b >= (this._s2 = o[++h]););
                                    this._s1 = o[h - 1], this._si = h
                                } else if (this._s1 > b && h > 0) {
                                    for (; h > 0 && (this._s1 = o[--h]) >= b;);
                                    0 === h && this._s1 > b ? this._s1 = 0 : h++, this._s2 = o[h], this._si = h
                                }
                                k = (h + (b - this._s1) / (this._s2 - this._s1)) * this._prec
                            } else f = 0 > b ? 0 : b >= 1 ? c - 1 : c * b >> 0, k = (b - f * (1 / c)) * c;
                            for (g = 1 - k, h = this._props.length; --h > -1;) i = this._props[h], j = this._beziers[i][f], l = (k * k * j.da + 3 * g * (k * j.ca + g * j.ba)) * k + j.a, this._round[i] && (l = l + (l > 0 ? .5 : -.5) >> 0), d[i] ? e[i](l) : e[i] = l;
                            if (this._autoRotate) {
                                var q, r, s, t, u, v, w, p = this._autoRotate;
                                for (h = p.length; --h > -1;) i = p[h][2], v = p[h][3] || 0, w = p[h][4] === !0 ? 1 : a, j = this._beziers[p[h][0]][f], q = this._beziers[p[h][1]][f], r = j.a + (j.b - j.a) * k, t = j.b + (j.c - j.b) * k, r += (t - r) * k, t += (j.c + (j.d - j.c) * k - t) * k, s = q.a + (q.b - q.a) * k, u = q.b + (q.c - q.b) * k, s += (u - s) * k, u += (q.c + (q.d - q.c) * k - u) * k, l = Math.atan2(u - s, t - r) * w + v, d[i] ? e[i](l) : e[i] = l
                            }
                        }
                    }),
                    q = p.prototype;
                p.bezierThrough = l, p.cubicToQuadratic = i, p._autoCSS = !0, p.quadraticToCubic = function(a, b, c) {
                    return new g(a, (2 * b + a) / 3, (2 * b + c) / 3, c)
                }, p._cssRegister = function() {
                    var a = window._gsDefine.globals.CSSPlugin;
                    if (a) {
                        var c = a._internals,
                            d = c._parseToProxy,
                            e = c._setPluginRatio,
                            f = c.CSSPropTween;
                        c._registerComplexSpecialProp("bezier", {
                            parser: function(a, c, g, h, i, j) {
                                c instanceof Array && (c = {
                                    values: c
                                }), j = new p;
                                var o, q, r, k = c.values,
                                    l = k.length - 1,
                                    m = [],
                                    n = {};
                                if (0 > l) return i;
                                for (o = 0; l >= o; o++) r = d(a, k[o], h, i, j, l !== o), m[o] = r.end;
                                for (q in c) n[q] = c[q];
                                return n.values = m, i = new f(a, "bezier", 0, 0, r.pt, 2), i.data = r, i.plugin = j, i.setRatio = e, 0 === n.autoRotate && (n.autoRotate = !0), !n.autoRotate || n.autoRotate instanceof Array || (o = n.autoRotate === !0 ? 0 : Number(n.autoRotate) * b, n.autoRotate = null != r.end.left ? [
                                    ["left", "top", "rotation", o, !0]
                                ] : null != r.end.x ? [
                                    ["x", "y", "rotation", o, !0]
                                ] : !1), n.autoRotate && (h._transform || h._enableTransforms(!1), r.autoRotate = h._target._gsTransform), j._onInitTween(r.proxy, n, h._tween), i
                            }
                        })
                    }
                }, q._roundProps = function(a, b) {
                    for (var c = this._overwriteProps, d = c.length; --d > -1;)(a[c[d]] || a.bezier || a.bezierThrough) && (this._round[c[d]] = b)
                }, q._kill = function(a) {
                    var c, d, b = this._props;
                    for (c in this._beziers)
                        if (c in a)
                            for (delete this._beziers[c], delete this._func[c], d = b.length; --d > -1;) b[d] === c && b.splice(d, 1);
                    return this._super._kill.call(this, a)
                }
            }(), window._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function(a, b) {
                var d, e, f, g, c = function() {
                        a.call(this, "css"), this._overwriteProps.length = 0
                    },
                    h = {},
                    i = c.prototype = new a("css");
                i.constructor = c, c.version = "1.9.3", c.API = 2, c.defaultTransformPerspective = 0, i = "px", c.suffixMap = {
                    top: i,
                    right: i,
                    bottom: i,
                    left: i,
                    width: i,
                    height: i,
                    fontSize: i,
                    padding: i,
                    margin: i,
                    perspective: i
                };
                var I, J, K, L, M, N, j = /(?:\d|\-\d|\.\d|\-\.\d)+/g,
                    k = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
                    l = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
                    m = /[^\d\-\.]/g,
                    n = /(?:\d|\-|\+|=|#|\.)*/g,
                    o = /opacity *= *([^)]*)/,
                    p = /opacity:([^;]*)/,
                    q = /alpha\(opacity *=.+?\)/i,
                    r = /^(rgb|hsl)/,
                    s = /([A-Z])/g,
                    t = /-([a-z])/gi,
                    u = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
                    v = function(a, b) {
                        return b.toUpperCase()
                    },
                    w = /(?:Left|Right|Width)/i,
                    x = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
                    y = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
                    z = /,(?=[^\)]*(?:\(|$))/gi,
                    A = Math.PI / 180,
                    B = 180 / Math.PI,
                    C = {},
                    D = document,
                    E = D.createElement("div"),
                    F = D.createElement("img"),
                    G = c._internals = {
                        _specialProps: h
                    },
                    H = navigator.userAgent,
                    O = function() {
                        var c, a = H.indexOf("Android"),
                            b = D.createElement("div");
                        return K = -1 !== H.indexOf("Safari") && -1 === H.indexOf("Chrome") && (-1 === a || Number(H.substr(a + 8, 1)) > 3), M = K && 6 > Number(H.substr(H.indexOf("Version/") + 8, 1)), L = -1 !== H.indexOf("Firefox"), /MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(H), N = parseFloat(RegExp.$1), b.innerHTML = "<a style='top:1px;opacity:.55;'>a</a>", c = b.getElementsByTagName("a")[0], c ? /^0.55/.test(c.style.opacity) : !1
                    }(),
                    P = function(a) {
                        return o.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1
                    },
                    Q = function(a) {
                        window.console && console.log(a)
                    },
                    R = "",
                    S = "",
                    T = function(a, b) {
                        b = b || E;
                        var d, e, c = b.style;
                        if (void 0 !== c[a]) return a;
                        for (a = a.charAt(0).toUpperCase() + a.substr(1), d = ["O", "Moz", "ms", "Ms", "Webkit"], e = 5; --e > -1 && void 0 === c[d[e] + a];);
                        return e >= 0 ? (S = 3 === e ? "ms" : d[e], R = "-" + S.toLowerCase() + "-", S + a) : null
                    },
                    U = D.defaultView ? D.defaultView.getComputedStyle : function() {},
                    V = c.getStyle = function(a, b, c, d, e) {
                        var f;
                        return O || "opacity" !== b ? (!d && a.style[b] ? f = a.style[b] : (c = c || U(a, null)) ? (a = c.getPropertyValue(b.replace(s, "-$1").toLowerCase()), f = a || c.length ? a : c[b]) : a.currentStyle && (c = a.currentStyle, f = c[b]), null == e || f && "none" !== f && "auto" !== f && "auto auto" !== f ? f : e) : P(a)
                    },
                    W = function(a, b, c, d, e) {
                        if ("px" === d || !d) return c;
                        if ("auto" === d || !c) return 0;
                        var j, f = w.test(b),
                            g = a,
                            h = E.style,
                            i = 0 > c;
                        return i && (c = -c), "%" === d && -1 !== b.indexOf("border") ? j = c / 100 * (f ? a.clientWidth : a.clientHeight) : (h.cssText = "border-style:solid; border-width:0; position:absolute; line-height:0;", "%" !== d && g.appendChild ? h[f ? "borderLeftWidth" : "borderTopWidth"] = c + d : (g = a.parentNode || D.body, h[f ? "width" : "height"] = c + d), g.appendChild(E), j = parseFloat(E[f ? "offsetWidth" : "offsetHeight"]), g.removeChild(E), 0 !== j || e || (j = W(a, b, c, d, !0))), i ? -j : j
                    },
                    X = function(a, b, c) {
                        if ("absolute" !== V(a, "position", c)) return 0;
                        var d = "left" === b ? "Left" : "Top",
                            e = V(a, "margin" + d, c);
                        return a["offset" + d] - (W(a, b, parseFloat(e), e.replace(n, "")) || 0)
                    },
                    Y = function(a, b) {
                        var d, e, c = {};
                        if (b = b || U(a, null))
                            if (d = b.length)
                                for (; --d > -1;) c[b[d].replace(t, v)] = b.getPropertyValue(b[d]);
                            else
                                for (d in b) c[d] = b[d];
                        else if (b = a.currentStyle || a.style)
                            for (d in b) c[d.replace(t, v)] = b[d];
                        return O || (c.opacity = P(a)), e = zb(a, b, !1), c.rotation = e.rotation * B, c.skewX = e.skewX * B, c.scaleX = e.scaleX, c.scaleY = e.scaleY, c.x = e.x, c.y = e.y, yb && (c.z = e.z, c.rotationX = e.rotationX * B, c.rotationY = e.rotationY * B, c.scaleZ = e.scaleZ), c.filters && delete c.filters, c
                    },
                    Z = function(a, b, c, d, e) {
                        var h, i, j, f = {},
                            g = a.style;
                        for (i in c) "cssText" !== i && "length" !== i && isNaN(i) && (b[i] !== (h = c[i]) || e && e[i]) && -1 === i.indexOf("Origin") && ("number" == typeof h || "string" == typeof h) && (f[i] = "auto" !== h || "left" !== i && "top" !== i ? "" !== h && "auto" !== h && "none" !== h || "string" != typeof b[i] || "" === b[i].replace(m, "") ? h : 0 : X(a, i), void 0 !== g[i] && (j = new mb(g, i, g[i], j)));
                        if (d)
                            for (i in d) "className" !== i && (f[i] = d[i]);
                        return {
                            difs: f,
                            firstMPT: j
                        }
                    },
                    $ = {
                        width: ["Left", "Right"],
                        height: ["Top", "Bottom"]
                    },
                    _ = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
                    ab = function(a, b, c) {
                        var d = parseFloat("width" === b ? a.offsetWidth : a.offsetHeight),
                            e = $[b],
                            f = e.length;
                        for (c = c || U(a, null); --f > -1;) d -= parseFloat(V(a, "padding" + e[f], c, !0)) || 0, d -= parseFloat(V(a, "border" + e[f] + "Width", c, !0)) || 0;
                        return d
                    },
                    bb = function(a, b) {
                        (null == a || "" === a || "auto" === a || "auto auto" === a) && (a = "0 0");
                        var c = a.split(" "),
                            d = -1 !== a.indexOf("left") ? "0%" : -1 !== a.indexOf("right") ? "100%" : c[0],
                            e = -1 !== a.indexOf("top") ? "0%" : -1 !== a.indexOf("bottom") ? "100%" : c[1];
                        return null == e ? e = "0" : "center" === e && (e = "50%"), ("center" === d || isNaN(parseFloat(d))) && (d = "50%"), b && (b.oxp = -1 !== d.indexOf("%"), b.oyp = -1 !== e.indexOf("%"), b.oxr = "=" === d.charAt(1), b.oyr = "=" === e.charAt(1), b.ox = parseFloat(d.replace(m, "")), b.oy = parseFloat(e.replace(m, ""))), d + " " + e + (c.length > 2 ? " " + c[2] : "")
                    },
                    cb = function(a, b) {
                        return "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b)
                    },
                    db = function(a, b) {
                        return null == a ? b : "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * Number(a.substr(2)) + b : parseFloat(a)
                    },
                    eb = function(a, b, c, d) {
                        var f, g, h, i, j, e = 1e-6;
                        return null == a ? j = b : "number" == typeof a ? j = a * A : (f = 2 * Math.PI, g = a.split("_"), h = Number(g[0].replace(m, "")) * (-1 === a.indexOf("rad") ? A : 1) - ("=" === a.charAt(1) ? 0 : b), i = g[1], i && d && (d[c] = b + h), "short" === i ? (h %= f, h !== h % (f / 2) && (h = 0 > h ? h + f : h - f)) : "cw" === i && 0 > h ? h = (h + 9999999999 * f) % f - (0 | h / f) * f : "ccw" === i && h > 0 && (h = (h - 9999999999 * f) % f - (0 | h / f) * f), j = b + h), e > j && j > -e && (j = 0), j
                    },
                    fb = {
                        aqua: [0, 255, 255],
                        lime: [0, 255, 0],
                        silver: [192, 192, 192],
                        black: [0, 0, 0],
                        maroon: [128, 0, 0],
                        teal: [0, 128, 128],
                        blue: [0, 0, 255],
                        navy: [0, 0, 128],
                        white: [255, 255, 255],
                        fuchsia: [255, 0, 255],
                        olive: [128, 128, 0],
                        yellow: [255, 255, 0],
                        orange: [255, 165, 0],
                        gray: [128, 128, 128],
                        purple: [128, 0, 128],
                        green: [0, 128, 0],
                        red: [255, 0, 0],
                        pink: [255, 192, 203],
                        cyan: [0, 255, 255],
                        transparent: [255, 255, 255, 0]
                    },
                    gb = function(a, b, c) {
                        return a = 0 > a ? a + 1 : a > 1 ? a - 1 : a, 0 | 255 * (1 > 6 * a ? b + 6 * (c - b) * a : .5 > a ? c : 2 > 3 * a ? b + 6 * (c - b) * (2 / 3 - a) : b) + .5
                    },
                    hb = function(a) {
                        var b, c, d, e, f, g;
                        return a && "" !== a ? "number" == typeof a ? [a >> 16, 255 & a >> 8, 255 & a] : ("," === a.charAt(a.length - 1) && (a = a.substr(0, a.length - 1)), fb[a] ? fb[a] : "#" === a.charAt(0) ? (4 === a.length && (b = a.charAt(1), c = a.charAt(2), d = a.charAt(3), a = "#" + b + b + c + c + d + d), a = parseInt(a.substr(1), 16), [a >> 16, 255 & a >> 8, 255 & a]) : "hsl" === a.substr(0, 3) ? (a = a.match(j), e = Number(a[0]) % 360 / 360, f = Number(a[1]) / 100, g = Number(a[2]) / 100, c = .5 >= g ? g * (f + 1) : g + f - g * f, b = 2 * g - c, a.length > 3 && (a[3] = Number(a[3])), a[0] = gb(e + 1 / 3, b, c), a[1] = gb(e, b, c), a[2] = gb(e - 1 / 3, b, c), a) : (a = a.match(j) || fb.transparent, a[0] = Number(a[0]), a[1] = Number(a[1]), a[2] = Number(a[2]), a.length > 3 && (a[3] = Number(a[3])), a)) : fb.black
                    },
                    ib = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#.+?\\b";
                for (i in fb) ib += "|" + i + "\\b";
                ib = RegExp(ib + ")", "gi");
                var jb = function(a, b, c, d) {
                        if (null == a) return function(a) {
                            return a
                        };
                        var n, e = b ? (a.match(ib) || [""])[0] : "",
                            f = a.split(e).join("").match(l) || [],
                            g = a.substr(0, a.indexOf(f[0])),
                            h = ")" === a.charAt(a.length - 1) ? ")" : "",
                            i = -1 !== a.indexOf(" ") ? " " : ",",
                            k = f.length,
                            m = k > 0 ? f[0].replace(j, "") : "";
                        return k ? n = b ? function(a) {
                            var b, j, o, p;
                            if ("number" == typeof a) a += m;
                            else if (d && z.test(a)) {
                                for (p = a.replace(z, "|").split("|"), o = 0; p.length > o; o++) p[o] = n(p[o]);
                                return p.join(",")
                            }
                            if (b = (a.match(ib) || [e])[0], j = a.split(b).join("").match(l) || [], o = j.length, k > o--)
                                for (; k > ++o;) j[o] = c ? j[(o - 1) / 2 >> 0] : f[o];
                            return g + j.join(i) + i + b + h + (-1 !== a.indexOf("inset") ? " inset" : "")
                        } : function(a) {
                            var b, e, j;
                            if ("number" == typeof a) a += m;
                            else if (d && z.test(a)) {
                                for (e = a.replace(z, "|").split("|"), j = 0; e.length > j; j++) e[j] = n(e[j]);
                                return e.join(",")
                            }
                            if (b = a.match(l) || [], j = b.length, k > j--)
                                for (; k > ++j;) b[j] = c ? b[(j - 1) / 2 >> 0] : f[j];
                            return g + b.join(i) + h
                        } : function(a) {
                            return a
                        }
                    },
                    kb = function(a) {
                        return a = a.split(","),
                            function(b, c, d, e, f, g, h) {
                                var j, i = (c + "").split(" ");
                                for (h = {}, j = 0; 4 > j; j++) h[a[j]] = i[j] = i[j] || i[(j - 1) / 2 >> 0];
                                return e.parse(b, h, f, g)
                            }
                    },
                    mb = (G._setPluginRatio = function(a) {
                        this.plugin.setRatio(a);
                        for (var f, g, h, i, b = this.data, c = b.proxy, d = b.firstMPT, e = 1e-6; d;) f = c[d.v], d.r ? f = f > 0 ? f + .5 >> 0 : f - .5 >> 0 : e > f && f > -e && (f = 0), d.t[d.p] = f, d = d._next;
                        if (b.autoRotate && (b.autoRotate.rotation = c.rotation), 1 === a)
                            for (d = b.firstMPT; d;) {
                                if (g = d.t, g.type) {
                                    if (1 === g.type) {
                                        for (i = g.xs0 + g.s + g.xs1, h = 1; g.l > h; h++) i += g["xn" + h] + g["xs" + (h + 1)];
                                        g.e = i
                                    }
                                } else g.e = g.s + g.xs0;
                                d = d._next
                            }
                    }, function(a, b, c, d, e) {
                        this.t = a, this.p = b, this.v = c, this.r = e, d && (d._prev = this, this._next = d)
                    }),
                    ob = (G._parseToProxy = function(a, b, c, d, e, f) {
                        var l, m, n, o, p, g = d,
                            h = {},
                            i = {},
                            j = c._transform,
                            k = C;
                        for (c._transform = null, C = b, d = p = c.parse(a, b, d, e), C = k, f && (c._transform = j, g && (g._prev = null, g._prev && (g._prev._next = null))); d && d !== g;) {
                            if (1 >= d.type && (m = d.p, i[m] = d.s + d.c, h[m] = d.s, f || (o = new mb(d, "s", m, o, d.r), d.c = 0), 1 === d.type))
                                for (l = d.l; --l > 0;) n = "xn" + l, m = d.p + "_" + n, i[m] = d.data[n], h[m] = d[n], f || (o = new mb(d, n, m, o, d.rxp[n]));
                            d = d._next
                        }
                        return {
                            proxy: h,
                            end: i,
                            firstMPT: o,
                            pt: p
                        }
                    }, G.CSSPropTween = function(a, b, c, e, f, h, i, j, k, l, m) {
                        this.t = a, this.p = b, this.s = c, this.c = e, this.n = i || "css_" + b, a instanceof ob || g.push(this.n), this.r = j, this.type = h || 0, k && (this.pr = k, d = !0), this.b = void 0 === l ? c : l, this.e = void 0 === m ? c + e : m, f && (this._next = f, f._prev = this)
                    }),
                    pb = c.parseComplex = function(a, b, c, d, e, f, g, h, i, l) {
                        g = new ob(a, b, 0, 0, g, l ? 2 : 1, null, !1, h, c, d), d += "";
                        var q, s, t, u, v, w, x, y, A, B, C, D, m = c.split(", ").join(",").split(" "),
                            n = d.split(", ").join(",").split(" "),
                            o = m.length,
                            p = I !== !1;
                        for ((-1 !== d.indexOf(",") || -1 !== c.indexOf(",")) && (m = m.join(" ").replace(z, ", ").split(" "), n = n.join(" ").replace(z, ", ").split(" "), o = m.length), o !== n.length && (m = (f || "").split(" "), o = m.length), g.plugin = i, g.setRatio = l, q = 0; o > q; q++)
                            if (u = m[q], v = n[q], y = parseFloat(u), y || 0 === y) g.appendXtra("", y, cb(v, y), v.replace(k, ""), p && -1 !== v.indexOf("px"), !0);
                            else if (e && ("#" === u.charAt(0) || fb[u] || r.test(u))) D = "," === v.charAt(v.length - 1) ? ")," : ")", u = hb(u), v = hb(v), A = u.length + v.length > 6, A && !O && 0 === v[3] ? (g["xs" + g.l] += g.l ? " transparent" : "transparent", g.e = g.e.split(n[q]).join("transparent")) : (O || (A = !1), g.appendXtra(A ? "rgba(" : "rgb(", u[0], v[0] - u[0], ",", !0, !0).appendXtra("", u[1], v[1] - u[1], ",", !0).appendXtra("", u[2], v[2] - u[2], A ? "," : D, !0), A && (u = 4 > u.length ? 1 : u[3], g.appendXtra("", u, (4 > v.length ? 1 : v[3]) - u, D, !1)));
                        else if (w = u.match(j)) {
                            if (x = v.match(k), !x || x.length !== w.length) return g;
                            for (t = 0, s = 0; w.length > s; s++) C = w[s], B = u.indexOf(C, t), g.appendXtra(u.substr(t, B - t), Number(C), cb(x[s], C), "", p && "px" === u.substr(B + C.length, 2), 0 === s), t = B + C.length;
                            g["xs" + g.l] += u.substr(t)
                        } else g["xs" + g.l] += g.l ? " " + u : u;
                        if (-1 !== d.indexOf("=") && g.data) {
                            for (D = g.xs0 + g.data.s, q = 1; g.l > q; q++) D += g["xs" + q] + g.data["xn" + q];
                            g.e = D + g["xs" + q]
                        }
                        return g.l || (g.type = -1, g.xs0 = g.e), g.xfirst || g
                    },
                    qb = 9;
                for (i = ob.prototype, i.l = i.pr = 0; --qb > 0;) i["xn" + qb] = 0, i["xs" + qb] = "";
                i.xs0 = "", i._next = i._prev = i.xfirst = i.data = i.plugin = i.setRatio = i.rxp = null, i.appendXtra = function(a, b, c, d, e, f) {
                    var g = this,
                        h = g.l;
                    return g["xs" + h] += f && h ? " " + a : a || "", c || 0 === h || g.plugin ? (g.l++, g.type = g.setRatio ? 2 : 1, g["xs" + g.l] = d || "", h > 0 ? (g.data["xn" + h] = b + c, g.rxp["xn" + h] = e, g["xn" + h] = b, g.plugin || (g.xfirst = new ob(g, "xn" + h, b, c, g.xfirst || g, 0, g.n, e, g.pr), g.xfirst.xs0 = 0), g) : (g.data = {
                        s: b + c
                    }, g.rxp = {}, g.s = b, g.c = c, g.r = e, g)) : (g["xs" + h] += b + (d || ""), g)
                };
                var rb = function(a, b) {
                        b = b || {}, this.p = b.prefix ? T(a) || a : a, h[a] = h[this.p] = this, this.format = b.formatter || jb(b.defaultValue, b.color, b.collapsible, b.multi), b.parser && (this.parse = b.parser), this.clrs = b.color, this.multi = b.multi, this.keyword = b.keyword, this.dflt = b.defaultValue, this.pr = b.priority || 0
                    },
                    sb = G._registerComplexSpecialProp = function(a, b, c) {
                        "object" != typeof b && (b = {
                            parser: c
                        });
                        var f, g, d = a.split(","),
                            e = b.defaultValue;
                        for (c = c || [e], f = 0; d.length > f; f++) b.prefix = 0 === f && b.prefix, b.defaultValue = c[f] || e, g = new rb(d[f], b)
                    },
                    tb = function(a) {
                        if (!h[a]) {
                            var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
                            sb(a, {
                                parser: function(a, c, d, e, f, g, i) {
                                    var j = (window.GreenSockGlobals || window).com.greensock.plugins[b];
                                    return j ? (j._cssRegister(), h[d].parse(a, c, d, e, f, g, i)) : (Q("Error: " + b + " js file not loaded."), f)
                                }
                            })
                        }
                    };
                i = rb.prototype, i.parseComplex = function(a, b, c, d, e, f) {
                    var h, i, j, k, l, m, g = this.keyword;
                    if (this.multi && (z.test(c) || z.test(b) ? (i = b.replace(z, "|").split("|"), j = c.replace(z, "|").split("|")) : g && (i = [b], j = [c])), j) {
                        for (k = j.length > i.length ? j.length : i.length, h = 0; k > h; h++) b = i[h] = i[h] || this.dflt, c = j[h] = j[h] || this.dflt, g && (l = b.indexOf(g), m = c.indexOf(g), l !== m && (c = -1 === m ? j : i, c[h] += " " + g));
                        b = i.join(", "), c = j.join(", ")
                    }
                    return pb(a, this.p, b, c, this.clrs, this.dflt, d, this.pr, e, f)
                }, i.parse = function(a, b, c, d, e, g) {
                    return this.parseComplex(a.style, this.format(V(a, this.p, f, !1, this.dflt)), this.format(b), e, g)
                }, c.registerSpecialProp = function(a, b, c) {
                    sb(a, {
                        parser: function(a, d, e, f, g, h) {
                            var j = new ob(a, e, 0, 0, g, 2, e, !1, c);
                            return j.plugin = h, j.setRatio = b(a, d, f._tween, e), j
                        },
                        priority: c
                    })
                };
                var ub = "scaleX,scaleY,scaleZ,x,y,z,skewX,rotation,rotationX,rotationY,perspective".split(","),
                    vb = T("transform"),
                    wb = R + "transform",
                    xb = T("transformOrigin"),
                    yb = null !== T("perspective"),
                    zb = function(a, b, d) {
                        var l, m, n, o, p, q, r, s, t, u, v, w, y, e = d ? a._gsTransform || {
                                skewY: 0
                            } : {
                                skewY: 0
                            },
                            f = 0 > e.scaleX,
                            g = 2e-5,
                            h = 1e5,
                            i = -Math.PI + 1e-4,
                            j = Math.PI - 1e-4,
                            k = yb ? parseFloat(V(a, xb, b, !1, "0 0 0").split(" ")[2]) || e.zOrigin || 0 : 0;
                        for (vb ? l = V(a, wb, b, !0) : a.currentStyle && (l = a.currentStyle.filter.match(x), l = l && 4 === l.length ? l[0].substr(4) + "," + Number(l[2].substr(4)) + "," + Number(l[1].substr(4)) + "," + l[3].substr(4) + "," + (e ? e.x : 0) + "," + (e ? e.y : 0) : null), m = (l || "").match(/(?:\-|\b)[\d\-\.e]+\b/gi) || [], n = m.length; --n > -1;) o = Number(m[n]), m[n] = (p = o - (o |= 0)) ? (0 | p * h + (0 > p ? -.5 : .5)) / h + o : o;
                        if (16 === m.length) {
                            var z = m[8],
                                A = m[9],
                                B = m[10],
                                C = m[12],
                                D = m[13],
                                E = m[14];
                            if (e.zOrigin && (E = -e.zOrigin, C = z * E - m[12], D = A * E - m[13], E = B * E + e.zOrigin - m[14]), !d || C !== e.x || D !== e.y || E !== e.z) {
                                var Q, R, S, T, U, W, X, Y, F = m[0],
                                    G = m[1],
                                    H = m[2],
                                    I = m[3],
                                    J = m[4],
                                    K = m[5],
                                    L = m[6],
                                    M = m[7],
                                    N = m[11],
                                    O = e.rotationX = Math.atan2(L, B),
                                    P = i > O || O > j;
                                O && (U = Math.cos(-O), W = Math.sin(-O), Q = J * U + z * W, R = K * U + A * W, S = L * U + B * W, T = M * U + N * W, z = J * -W + z * U, A = K * -W + A * U, B = L * -W + B * U, N = M * -W + N * U, J = Q, K = R, L = S), O = e.rotationY = Math.atan2(z, F), O && (X = i > O || O > j, U = Math.cos(-O), W = Math.sin(-O), Q = F * U - z * W, R = G * U - A * W, S = H * U - B * W, T = I * U - N * W, A = G * W + A * U, B = H * W + B * U, N = I * W + N * U, F = Q, G = R, H = S), O = e.rotation = Math.atan2(G, K), O && (Y = i > O || O > j, U = Math.cos(-O), W = Math.sin(-O), F = F * U + J * W, R = G * U + K * W, K = G * -W + K * U, L = H * -W + L * U, G = R), Y && P ? e.rotation = e.rotationX = 0 : Y && X ? e.rotation = e.rotationY = 0 : X && P && (e.rotationY = e.rotationX = 0), e.scaleX = (Math.sqrt(F * F + G * G) * h + .5 >> 0) / h, e.scaleY = (Math.sqrt(K * K + A * A) * h + .5 >> 0) / h, e.scaleZ = (Math.sqrt(L * L + B * B) * h + .5 >> 0) / h, e.skewX = 0, e.perspective = N ? 1 / (0 > N ? -N : N) : 0, e.x = C, e.y = D, e.z = E
                            }
                        } else if (!(yb && 0 !== m.length && e.x === m[4] && e.y === m[5] && (e.rotationX || e.rotationY) || void 0 !== e.x && "none" === V(a, "display", b))) {
                            var Z = m.length >= 6,
                                $ = Z ? m[0] : 1,
                                _ = m[1] || 0,
                                ab = m[2] || 0,
                                bb = Z ? m[3] : 1;
                            e.x = m[4] || 0, e.y = m[5] || 0, q = Math.sqrt($ * $ + _ * _), r = Math.sqrt(bb * bb + ab * ab), s = $ || _ ? Math.atan2(_, $) : e.rotation || 0, t = ab || bb ? Math.atan2(ab, bb) + s : e.skewX || 0, u = q - Math.abs(e.scaleX || 0), v = r - Math.abs(e.scaleY || 0), Math.abs(t) > Math.PI / 2 && Math.abs(t) < 1.5 * Math.PI && (f ? (q *= -1, t += 0 >= s ? Math.PI : -Math.PI, s += 0 >= s ? Math.PI : -Math.PI) : (r *= -1, t += 0 >= t ? Math.PI : -Math.PI)), w = (s - e.rotation) % Math.PI, y = (t - e.skewX) % Math.PI, (void 0 === e.skewX || u > g || -g > u || v > g || -g > v || w > i && j > w && 0 !== w * h >> 0 || y > i && j > y && 0 !== y * h >> 0) && (e.scaleX = q, e.scaleY = r, e.rotation = s, e.skewX = t), yb && (e.rotationX = e.rotationY = e.z = 0, e.perspective = parseFloat(c.defaultTransformPerspective) || 0, e.scaleZ = 1)
                        }
                        e.zOrigin = k;
                        for (n in e) g > e[n] && e[n] > -g && (e[n] = 0);
                        return d && (a._gsTransform = e), e
                    },
                    Ab = function(a) {
                        var l, m, b = this.data,
                            c = -b.rotation,
                            d = c + b.skewX,
                            e = 1e5,
                            f = (Math.cos(c) * b.scaleX * e >> 0) / e,
                            g = (Math.sin(c) * b.scaleX * e >> 0) / e,
                            h = (Math.sin(d) * -b.scaleY * e >> 0) / e,
                            i = (Math.cos(d) * b.scaleY * e >> 0) / e,
                            j = this.t.style,
                            k = this.t.currentStyle;
                        if (k) {
                            m = g, g = -h, h = -m, l = k.filter, j.filter = "";
                            var v, w, p = this.t.offsetWidth,
                                q = this.t.offsetHeight,
                                r = "absolute" !== k.position,
                                s = "progid:DXImageTransform.Microsoft.Matrix(M11=" + f + ", M12=" + g + ", M21=" + h + ", M22=" + i,
                                t = b.x,
                                u = b.y;
                            if (null != b.ox && (v = (b.oxp ? .01 * p * b.ox : b.ox) - p / 2, w = (b.oyp ? .01 * q * b.oy : b.oy) - q / 2, t += v - (v * f + w * g), u += w - (v * h + w * i)), r) v = p / 2, w = q / 2, s += ", Dx=" + (v - (v * f + w * g) + t) + ", Dy=" + (w - (v * h + w * i) + u) + ")";
                            else {
                                var z, A, B, x = 8 > N ? 1 : -1;
                                for (v = b.ieOffsetX || 0, w = b.ieOffsetY || 0, b.ieOffsetX = Math.round((p - ((0 > f ? -f : f) * p + (0 > g ? -g : g) * q)) / 2 + t), b.ieOffsetY = Math.round((q - ((0 > i ? -i : i) * q + (0 > h ? -h : h) * p)) / 2 + u), qb = 0; 4 > qb; qb++) A = _[qb], z = k[A], m = -1 !== z.indexOf("px") ? parseFloat(z) : W(this.t, A, parseFloat(z), z.replace(n, "")) || 0, B = m !== b[A] ? 2 > qb ? -b.ieOffsetX : -b.ieOffsetY : 2 > qb ? v - b.ieOffsetX : w - b.ieOffsetY, j[A] = (b[A] = Math.round(m - B * (0 === qb || 2 === qb ? 1 : x))) + "px";
                                s += ", sizingMethod='auto expand')"
                            }
                            j.filter = -1 !== l.indexOf("DXImageTransform.Microsoft.Matrix(") ? l.replace(y, s) : s + " " + l, (0 === a || 1 === a) && 1 === f && 0 === g && 0 === h && 1 === i && (r && -1 === s.indexOf("Dx=0, Dy=0") || o.test(l) && 100 !== parseFloat(RegExp.$1) || -1 === l.indexOf("gradient(") && j.removeAttribute("filter"))
                        }
                    },
                    Bb = function() {
                        var x, y, z, A, B, C, D, E, F, b = this.data,
                            c = this.t.style,
                            d = b.perspective,
                            e = b.scaleX,
                            f = 0,
                            g = 0,
                            h = 0,
                            i = 0,
                            j = b.scaleY,
                            k = 0,
                            l = 0,
                            m = 0,
                            n = 0,
                            o = b.scaleZ,
                            p = 0,
                            q = 0,
                            r = 0,
                            s = d ? -1 / d : 0,
                            t = b.rotation,
                            u = b.zOrigin,
                            v = ",",
                            w = 1e5;
                        L && (D = c.top ? "top" : c.bottom ? "bottom" : parseFloat(V(this.t, "top", null, !1)) ? "bottom" : "top", z = V(this.t, D, null, !1), E = parseFloat(z) || 0, F = z.substr((E + "").length) || "px", b._ffFix = !b._ffFix, c[D] = (b._ffFix ? E + .05 : E - .05) + F), (t || b.skewX) && (z = e * Math.cos(t), A = j * Math.sin(t), t -= b.skewX, f = e * -Math.sin(t), j *= Math.cos(t), e = z, i = A), t = b.rotationY, t && (x = Math.cos(t), y = Math.sin(t), z = e * x, A = i * x, B = o * -y, C = s * -y, g = e * y, k = i * y, o *= x, s *= x, e = z, i = A, m = B, q = C), t = b.rotationX, t && (x = Math.cos(t), y = Math.sin(t), z = f * x + g * y, A = j * x + k * y, B = n * x + o * y, C = r * x + s * y, g = f * -y + g * x, k = j * -y + k * x, o = n * -y + o * x, s = r * -y + s * x, f = z, j = A, n = B, r = C), u && (p -= u, h = g * p, l = k * p, p = o * p + u), h = (z = (h += b.x) - (h |= 0)) ? (0 | z * w + (0 > z ? -.5 : .5)) / w + h : h, l = (z = (l += b.y) - (l |= 0)) ? (0 | z * w + (0 > z ? -.5 : .5)) / w + l : l, p = (z = (p += b.z) - (p |= 0)) ? (0 | z * w + (0 > z ? -.5 : .5)) / w + p : p, c[vb] = "matrix3d(" + (e * w >> 0) / w + v + (i * w >> 0) / w + v + (m * w >> 0) / w + v + (q * w >> 0) / w + v + (f * w >> 0) / w + v + (j * w >> 0) / w + v + (n * w >> 0) / w + v + (r * w >> 0) / w + v + (g * w >> 0) / w + v + (k * w >> 0) / w + v + (o * w >> 0) / w + v + (s * w >> 0) / w + v + h + v + l + v + p + v + (d ? 1 + -p / d : 1) + ")"
                    },
                    Cb = function() {
                        var e, f, g, h, i, j, k, l, m, b = this.data,
                            c = this.t,
                            d = c.style;
                        L && (e = d.top ? "top" : d.bottom ? "bottom" : parseFloat(V(c, "top", null, !1)) ? "bottom" : "top", f = V(c, e, null, !1), g = parseFloat(f) || 0, h = f.substr((g + "").length) || "px", b._ffFix = !b._ffFix, d[e] = (b._ffFix ? g + .05 : g - .05) + h), b.rotation || b.skewX ? (i = b.rotation, j = i - b.skewX, k = 1e5, l = b.scaleX * k, m = b.scaleY * k, d[vb] = "matrix(" + (Math.cos(i) * l >> 0) / k + "," + (Math.sin(i) * l >> 0) / k + "," + (Math.sin(j) * -m >> 0) / k + "," + (Math.cos(j) * m >> 0) / k + "," + b.x + "," + b.y + ")") : d[vb] = "matrix(" + b.scaleX + ",0,0," + b.scaleY + "," + b.x + "," + b.y + ")"
                    };
                sb("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,transformPerspective,directionalRotation", {
                    parser: function(a, b, c, d, e, g, h) {
                        if (d._transform) return e;
                        var o, p, q, r, s, t, u, i = d._transform = zb(a, f, !0),
                            j = a.style,
                            k = 1e-6,
                            l = ub.length,
                            m = h,
                            n = {};
                        if ("string" == typeof m.transform && vb) q = j.cssText, j[vb] = m.transform, j.display = "block", o = zb(a, null, !1), j.cssText = q;
                        else if ("object" == typeof m) {
                            if (o = {
                                    scaleX: db(null != m.scaleX ? m.scaleX : m.scale, i.scaleX),
                                    scaleY: db(null != m.scaleY ? m.scaleY : m.scale, i.scaleY),
                                    scaleZ: db(null != m.scaleZ ? m.scaleZ : m.scale, i.scaleZ),
                                    x: db(m.x, i.x),
                                    y: db(m.y, i.y),
                                    z: db(m.z, i.z),
                                    perspective: db(m.transformPerspective, i.perspective)
                                }, u = m.directionalRotation, null != u)
                                if ("object" == typeof u)
                                    for (q in u) m[q] = u[q];
                                else m.rotation = u;
                            o.rotation = eb("rotation" in m ? m.rotation : "shortRotation" in m ? m.shortRotation + "_short" : "rotationZ" in m ? m.rotationZ : i.rotation * B, i.rotation, "rotation", n), yb && (o.rotationX = eb("rotationX" in m ? m.rotationX : "shortRotationX" in m ? m.shortRotationX + "_short" : i.rotationX * B || 0, i.rotationX, "rotationX", n), o.rotationY = eb("rotationY" in m ? m.rotationY : "shortRotationY" in m ? m.shortRotationY + "_short" : i.rotationY * B || 0, i.rotationY, "rotationY", n)), o.skewX = null == m.skewX ? i.skewX : eb(m.skewX, i.skewX), o.skewY = null == m.skewY ? i.skewY : eb(m.skewY, i.skewY), (p = o.skewY - i.skewY) && (o.skewX += p, o.rotation += p)
                        }
                        for (s = i.z || i.rotationX || i.rotationY || o.z || o.rotationX || o.rotationY || o.perspective, s || null == m.scale || (o.scaleZ = 1); --l > -1;) c = ub[l], r = o[c] - i[c], (r > k || -k > r || null != C[c]) && (t = !0, e = new ob(i, c, i[c], r, e), c in n && (e.e = n[c]), e.xs0 = 0, e.plugin = g, d._overwriteProps.push(e.n));
                        return r = m.transformOrigin, (r || yb && s && i.zOrigin) && (vb ? (t = !0, r = (r || V(a, c, f, !1, "50% 50%")) + "", c = xb, e = new ob(j, c, 0, 0, e, -1, "css_transformOrigin"), e.b = j[c], e.plugin = g, yb ? (q = i.zOrigin, r = r.split(" "), i.zOrigin = (r.length > 2 ? parseFloat(r[2]) : q) || 0, e.xs0 = e.e = j[c] = r[0] + " " + (r[1] || "50%") + " 0px", e = new ob(i, "zOrigin", 0, 0, e, -1, e.n), e.b = q, e.xs0 = e.e = i.zOrigin) : e.xs0 = e.e = j[c] = r) : bb(r + "", i)), t && (d._transformType = s || 3 === this._transformType ? 3 : 2), e
                    },
                    prefix: !0
                }), sb("boxShadow", {
                    defaultValue: "0px 0px 0px 0px #999",
                    prefix: !0,
                    color: !0,
                    multi: !0,
                    keyword: "inset"
                }), sb("borderRadius", {
                    defaultValue: "0px",
                    parser: function(a, b, c, d, g) {
                        b = this.format(b);
                        var k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, i = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                            j = a.style;
                        for (s = parseFloat(a.offsetWidth), t = parseFloat(a.offsetHeight), k = b.split(" "), l = 0; i.length > l; l++) this.p.indexOf("border") && (i[l] = T(i[l])), o = n = V(a, i[l], f, !1, "0px"), -1 !== o.indexOf(" ") && (n = o.split(" "), o = n[0], n = n[1]), p = m = k[l], q = parseFloat(o), v = o.substr((q + "").length), w = "=" === p.charAt(1), w ? (r = parseInt(p.charAt(0) + "1", 10), p = p.substr(2), r *= parseFloat(p), u = p.substr((r + "").length - (0 > r ? 1 : 0)) || "") : (r = parseFloat(p), u = p.substr((r + "").length)), "" === u && (u = e[c] || v), u !== v && (x = W(a, "borderLeft", q, v), y = W(a, "borderTop", q, v), "%" === u ? (o = 100 * (x / s) + "%", n = 100 * (y / t) + "%") : "em" === u ? (z = W(a, "borderLeft", 1, "em"), o = x / z + "em", n = y / z + "em") : (o = x + "px", n = y + "px"), w && (p = parseFloat(o) + r + u, m = parseFloat(n) + r + u)), g = pb(j, i[l], o + " " + n, p + " " + m, !1, "0px", g);
                        return g
                    },
                    prefix: !0,
                    formatter: jb("0px 0px 0px 0px", !1, !0)
                }), sb("backgroundPosition", {
                    defaultValue: "0 0",
                    parser: function(a, b, c, d, e, g) {
                        var l, m, n, o, p, q, h = "background-position",
                            i = f || U(a, null),
                            j = this.format((i ? N ? i.getPropertyValue(h + "-x") + " " + i.getPropertyValue(h + "-y") : i.getPropertyValue(h) : a.currentStyle.backgroundPositionX + " " + a.currentStyle.backgroundPositionY) || "0 0"),
                            k = this.format(b);
                        if (-1 !== j.indexOf("%") != (-1 !== k.indexOf("%")) && (q = V(a, "backgroundImage").replace(u, ""), q && "none" !== q)) {
                            for (l = j.split(" "), m = k.split(" "), F.setAttribute("src", q), n = 2; --n > -1;) j = l[n], o = -1 !== j.indexOf("%"), o !== (-1 !== m[n].indexOf("%")) && (p = 0 === n ? a.offsetWidth - F.width : a.offsetHeight - F.height, l[n] = o ? parseFloat(j) / 100 * p + "px" : 100 * (parseFloat(j) / p) + "%");
                            j = l.join(" ")
                        }
                        return this.parseComplex(a.style, j, k, e, g)
                    },
                    formatter: bb
                }), sb("backgroundSize", {
                    defaultValue: "0 0",
                    formatter: bb
                }), sb("perspective", {
                    defaultValue: "0px",
                    prefix: !0
                }), sb("perspectiveOrigin", {
                    defaultValue: "50% 50%",
                    prefix: !0
                }), sb("transformStyle", {
                    prefix: !0
                }), sb("backfaceVisibility", {
                    prefix: !0
                }), sb("margin", {
                    parser: kb("marginTop,marginRight,marginBottom,marginLeft")
                }), sb("padding", {
                    parser: kb("paddingTop,paddingRight,paddingBottom,paddingLeft")
                }), sb("clip", {
                    defaultValue: "rect(0px,0px,0px,0px)",
                    parser: function(a, b, c, d, e, g) {
                        var h, i, j;
                        return 9 > N ? (i = a.currentStyle, j = 8 > N ? " " : ",", h = "rect(" + i.clipTop + j + i.clipRight + j + i.clipBottom + j + i.clipLeft + ")", b = this.format(b).split(",").join(j)) : (h = this.format(V(a, this.p, f, !1, this.dflt)), b = this.format(b)), this.parseComplex(a.style, h, b, e, g)
                    }
                }), sb("textShadow", {
                    defaultValue: "0px 0px 0px #999",
                    color: !0,
                    multi: !0
                }), sb("autoRound,strictUnits", {
                    parser: function(a, b, c, d, e) {
                        return e
                    }
                }), sb("border", {
                    defaultValue: "0px solid #000",
                    parser: function(a, b, c, d, e, g) {
                        return this.parseComplex(a.style, this.format(V(a, "borderTopWidth", f, !1, "0px") + " " + V(a, "borderTopStyle", f, !1, "solid") + " " + V(a, "borderTopColor", f, !1, "#000")), this.format(b), e, g)
                    },
                    color: !0,
                    formatter: function(a) {
                        var b = a.split(" ");
                        return b[0] + " " + (b[1] || "solid") + " " + (a.match(ib) || ["#000"])[0]
                    }
                }), sb("float,cssFloat,styleFloat", {
                    parser: function(a, b, c, d, e) {
                        var g = a.style,
                            h = "cssFloat" in g ? "cssFloat" : "styleFloat";
                        return new ob(g, h, 0, 0, e, -1, c, !1, 0, g[h], b)
                    }
                });
                var Db = function(a) {
                    var e, b = this.t,
                        c = b.filter,
                        d = this.s + this.c * a >> 0;
                    100 === d && (-1 === c.indexOf("atrix(") && -1 === c.indexOf("radient(") ? (b.removeAttribute("filter"), e = !V(this.data, "filter")) : (b.filter = c.replace(q, ""), e = !0)), e || (this.xn1 && (b.filter = c = c || "alpha(opacity=100)"), -1 === c.indexOf("opacity") ? b.filter += " alpha(opacity=" + d + ")" : b.filter = c.replace(o, "opacity=" + d))
                };
                sb("opacity,alpha,autoAlpha", {
                    defaultValue: "1",
                    parser: function(a, b, c, d, e, g) {
                        var j, h = parseFloat(V(a, "opacity", f, !1, "1")),
                            i = a.style;
                        return b = parseFloat(b), "autoAlpha" === c && (j = V(a, "visibility", f), 1 === h && "hidden" === j && 0 !== b && (h = 0), e = new ob(i, "visibility", 0, 0, e, -1, null, !1, 0, 0 !== h ? "visible" : "hidden", 0 === b ? "hidden" : "visible"), e.xs0 = "visible", d._overwriteProps.push(e.n)), O ? e = new ob(i, "opacity", h, b - h, e) : (e = new ob(i, "opacity", 100 * h, 100 * (b - h), e), e.xn1 = "autoAlpha" === c ? 1 : 0, i.zoom = 1, e.type = 2, e.b = "alpha(opacity=" + e.s + ")", e.e = "alpha(opacity=" + (e.s + e.c) + ")", e.data = a, e.plugin = g, e.setRatio = Db), e
                    }
                });
                var Eb = function(a, b) {
                        b && (a.removeProperty ? a.removeProperty(b.replace(s, "-$1").toLowerCase()) : a.removeAttribute(b))
                    },
                    Fb = function(a) {
                        if (this.t._gsClassPT = this, 1 === a || 0 === a) {
                            this.t.className = 0 === a ? this.b : this.e;
                            for (var b = this.data, c = this.t.style; b;) b.v ? c[b.p] = b.v : Eb(c, b.p), b = b._next;
                            1 === a && this.t._gsClassPT === this && (this.t._gsClassPT = null)
                        } else this.t.className !== this.e && (this.t.className = this.e)
                    };
                sb("className", {
                    parser: function(a, b, c, e, g, h, i) {
                        var l, m, n, o, p, j = a.className,
                            k = a.style.cssText;
                        if (g = e._classNamePT = new ob(a, c, 0, 0, g, 2), g.setRatio = Fb, g.pr = -11, d = !0, g.b = j, m = Y(a, f), n = a._gsClassPT) {
                            for (o = {}, p = n.data; p;) o[p.p] = 1, p = p._next;
                            n.setRatio(1)
                        }
                        return a._gsClassPT = g, g.e = "=" !== b.charAt(1) ? b : j.replace(RegExp("\\s*\\b" + b.substr(2) + "\\b"), "") + ("+" === b.charAt(0) ? " " + b.substr(2) : ""), e._tween._duration && (a.className = g.e, l = Z(a, m, Y(a), i, o), a.className = j, g.data = l.firstMPT, a.style.cssText = k, g = g.xfirst = e.parse(a, l.difs, g, h)), g
                    }
                });
                var Gb = function(a) {
                    if ((1 === a || 0 === a) && this.data._totalTime === this.data._totalDuration)
                        for (var g, b = "all" === this.e, c = this.t.style, d = b ? c.cssText.split(";") : this.e.split(","), e = d.length, f = h.transform.parse; --e > -1;) g = d[e], b && (g = g.substr(0, g.indexOf(":")).split(" ").join("")), h[g] && (g = h[g].parse === f ? vb : h[g].p), Eb(c, g)
                };
                for (sb("clearProps", {
                        parser: function(a, b, c, e, f) {
                            return f = new ob(a, c, 0, 0, f, 2), f.setRatio = Gb, f.e = b, f.pr = -10, f.data = e._tween, d = !0, f
                        }
                    }), i = "bezier,throwProps,physicsProps,physics2D".split(","), qb = i.length; qb--;) tb(i[qb]);
                i = c.prototype, i._firstPT = null, i._onInitTween = function(a, b, h) {
                    if (!a.nodeType) return !1;
                    this._target = a, this._tween = h, this._vars = b, I = b.autoRound, d = !1, e = b.suffixMap || c.suffixMap, f = U(a, ""), g = this._overwriteProps;
                    var j, k, l, m, n, o, q, r, s, i = a.style;
                    if (J && "" === i.zIndex && (j = V(a, "zIndex", f), ("auto" === j || "" === j) && (i.zIndex = 0)), "string" == typeof b && (m = i.cssText, j = Y(a, f), i.cssText = m + ";" + b, j = Z(a, j, Y(a)).difs, !O && p.test(b) && (j.opacity = parseFloat(RegExp.$1)), b = j, i.cssText = m), this._firstPT = k = this.parse(a, b, null), this._transformType) {
                        for (s = 3 === this._transformType, vb ? K && (J = !0, "" === i.zIndex && (q = V(a, "zIndex", f), ("auto" === q || "" === q) && (i.zIndex = 0)), M && (i.WebkitBackfaceVisibility = this._vars.WebkitBackfaceVisibility || (s ? "visible" : "hidden"))) : i.zoom = 1, l = k; l && l._next;) l = l._next;
                        r = new ob(a, "transform", 0, 0, null, 2), this._linkCSSP(r, null, l), r.setRatio = s && yb ? Bb : vb ? Cb : Ab, r.data = this._transform || zb(a, f, !0), g.pop()
                    }
                    if (d) {
                        for (; k;) {
                            for (o = k._next, l = m; l && l.pr > k.pr;) l = l._next;
                            (k._prev = l ? l._prev : n) ? k._prev._next = k: m = k, (k._next = l) ? l._prev = k : n = k, k = o
                        }
                        this._firstPT = m
                    }
                    return !0
                }, i.parse = function(a, b, c, d) {
                    var i, j, k, l, m, o, p, q, s, t, g = a.style;
                    for (i in b) o = b[i], j = h[i], j ? c = j.parse(a, o, i, this, c, d, b) : (m = V(a, i, f) + "", s = "string" == typeof o, "color" === i || "fill" === i || "stroke" === i || -1 !== i.indexOf("Color") || s && r.test(o) ? (s || (o = hb(o), o = (o.length > 3 ? "rgba(" : "rgb(") + o.join(",") + ")"), c = pb(g, i, m, o, !0, "transparent", c, 0, d)) : !s || -1 === o.indexOf(" ") && -1 === o.indexOf(",") ? (k = parseFloat(m), p = k || 0 === k ? m.substr((k + "").length) : "", ("" === m || "auto" === m) && ("width" === i || "height" === i ? (k = ab(a, i, f), p = "px") : "left" === i || "top" === i ? (k = X(a, i, f), p = "px") : (k = "opacity" !== i ? 0 : 1, p = "")), t = s && "=" === o.charAt(1), t ? (l = parseInt(o.charAt(0) + "1", 10), o = o.substr(2), l *= parseFloat(o), q = o.replace(n, "")) : (l = parseFloat(o), q = s ? o.substr((l + "").length) || "" : ""), "" === q && (q = e[i] || p), o = l || 0 === l ? (t ? l + k : l) + q : b[i], p !== q && "" !== q && (l || 0 === l) && (k || 0 === k) && (k = W(a, i, k, p), "%" === q ? (k /= W(a, i, 100, "%") / 100, k > 100 && (k = 100), b.strictUnits !== !0 && (m = k + "%")) : "em" === q ? k /= W(a, i, 1, "em") : (l = W(a, i, l, q), q = "px"), t && (l || 0 === l) && (o = l + k + q)), t && (l += k), !k && 0 !== k || !l && 0 !== l ? o || "NaN" != o + "" && null != o ? (c = new ob(g, i, l || k || 0, 0, c, -1, "css_" + i, !1, 0, m, o), c.xs0 = "none" !== o || "display" !== i && -1 === i.indexOf("Style") ? o : m) : Q("invalid " + i + " tween value: " + b[i]) : (c = new ob(g, i, k, l - k, c, 0, "css_" + i, I !== !1 && ("px" === q || "zIndex" === i), 0, m, o), c.xs0 = q)) : c = pb(g, i, m, o, !0, null, c, 0, d)), d && c && !c.plugin && (c.plugin = d);
                    return c
                }, i.setRatio = function(a) {
                    var d, e, f, b = this._firstPT,
                        c = 1e-6;
                    if (1 !== a || this._tween._time !== this._tween._duration && 0 !== this._tween._time)
                        if (a || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -1e-6)
                            for (; b;) {
                                if (d = b.c * a + b.s, b.r ? d = d > 0 ? d + .5 >> 0 : d - .5 >> 0 : c > d && d > -c && (d = 0), b.type)
                                    if (1 === b.type)
                                        if (f = b.l, 2 === f) b.t[b.p] = b.xs0 + d + b.xs1 + b.xn1 + b.xs2;
                                        else if (3 === f) b.t[b.p] = b.xs0 + d + b.xs1 + b.xn1 + b.xs2 + b.xn2 + b.xs3;
                                else if (4 === f) b.t[b.p] = b.xs0 + d + b.xs1 + b.xn1 + b.xs2 + b.xn2 + b.xs3 + b.xn3 + b.xs4;
                                else if (5 === f) b.t[b.p] = b.xs0 + d + b.xs1 + b.xn1 + b.xs2 + b.xn2 + b.xs3 + b.xn3 + b.xs4 + b.xn4 + b.xs5;
                                else {
                                    for (e = b.xs0 + d + b.xs1, f = 1; b.l > f; f++) e += b["xn" + f] + b["xs" + (f + 1)];
                                    b.t[b.p] = e
                                } else -1 === b.type ? b.t[b.p] = b.xs0 : b.setRatio && b.setRatio(a);
                                else b.t[b.p] = d + b.xs0;
                                b = b._next
                            } else
                                for (; b;) 2 !== b.type ? b.t[b.p] = b.b : b.setRatio(a), b = b._next;
                        else
                            for (; b;) 2 !== b.type ? b.t[b.p] = b.e : b.setRatio(a), b = b._next
                }, i._enableTransforms = function(a) {
                    this._transformType = a || 3 === this._transformType ? 3 : 2
                }, i._linkCSSP = function(a, b, c, d) {
                    return a && (b && (b._prev = a), a._next && (a._next._prev = a._prev), c ? c._next = a : d || null !== this._firstPT || (this._firstPT = a), a._prev ? a._prev._next = a._next : this._firstPT === a && (this._firstPT = a._next), a._next = b, a._prev = c), a
                }, i._kill = function(b) {
                    var d, e, f, c = b;
                    if (b.css_autoAlpha || b.css_alpha) {
                        c = {};
                        for (e in b) c[e] = b[e];
                        c.css_opacity = 1, c.css_autoAlpha && (c.css_visibility = 1)
                    }
                    return b.css_className && (d = this._classNamePT) && (f = d.xfirst, f && f._prev ? this._linkCSSP(f._prev, d._next, f._prev._prev) : f === this._firstPT && (this._firstPT = d._next), d._next && this._linkCSSP(d._next, d._next._next, f._prev), this._classNamePT = null), a.prototype._kill.call(this, c)
                };
                var Hb = function(a, b, c) {
                    var d, e, f, g;
                    if (a.slice)
                        for (e = a.length; --e > -1;) Hb(a[e], b, c);
                    else
                        for (d = a.childNodes, e = d.length; --e > -1;) f = d[e], g = f.type, f.style && (b.push(Y(f)), c && c.push(f)), 1 !== g && 9 !== g && 11 !== g || !f.childNodes.length || Hb(f, b, c)
                };
                return c.cascadeTo = function(a, c, d) {
                    var k, l, m, e = b.to(a, c, d),
                        f = [e],
                        g = [],
                        h = [],
                        i = [],
                        j = b._internals.reservedProps;
                    for (a = e._targets || e.target, Hb(a, g, i), e.render(c, !0), Hb(a, h), e.render(0, !0), e._enabled(!0), k = i.length; --k > -1;)
                        if (l = Z(i[k], g[k], h[k]), l.firstMPT) {
                            l = l.difs;
                            for (m in d) j[m] && (l[m] = d[m]);
                            f.push(b.to(i[k], c, l))
                        } return f
                }, a.activate([c]), c
            }, !0),
            function() {
                var a = window._gsDefine.plugin({
                        propName: "roundProps",
                        priority: -1,
                        API: 2,
                        init: function(a, b, c) {
                            return this._tween = c, !0
                        }
                    }),
                    b = a.prototype;
                b._onInitAllProps = function() {
                    for (var f, g, h, a = this._tween, b = a.vars.roundProps instanceof Array ? a.vars.roundProps : a.vars.roundProps.split(","), c = b.length, d = {}, e = a._propLookup.roundProps; --c > -1;) d[b[c]] = 1;
                    for (c = b.length; --c > -1;)
                        for (f = b[c], g = a._firstPT; g;) h = g._next, g.pg ? g.t._roundProps(d, !0) : g.n === f && (this._add(g.t, f, g.s, g.c), h && (h._prev = g._prev), g._prev ? g._prev._next = h : a._firstPT === g && (a._firstPT = h), g._next = g._prev = null, a._propLookup[f] = e), g = h;
                    return !1
                }, b._add = function(a, b, c, d) {
                    this._addTween(a, b, c, c + d, b, !0), this._overwriteProps.push(b)
                }
            }(), window._gsDefine.plugin({
                propName: "attr",
                API: 2,
                init: function(a, b) {
                    var d;
                    if ("function" != typeof a.setAttribute) return !1;
                    this._target = a, this._proxy = {};
                    for (d in b) this._addTween(this._proxy, d, parseFloat(a.getAttribute(d)), b[d], d), this._overwriteProps.push(d);
                    return !0
                },
                set: function(a) {
                    this._super.setRatio.call(this, a);
                    for (var d, b = this._overwriteProps, c = b.length; --c > -1;) d = b[c], this._target.setAttribute(d, this._proxy[d] + "")
                }
            }), window._gsDefine.plugin({
                propName: "directionalRotation",
                API: 2,
                init: function(a, b) {
                    "object" != typeof b && (b = {
                        rotation: b
                    }), this.finals = {};
                    var e, f, g, h, i, j, k, d = b.useRadians === !0 ? 2 * Math.PI : 360;
                    for (e in b) "useRadians" !== e && (j = (b[e] + "").split("_"), f = j[0], k = j[1], g = parseFloat("function" != typeof a[e] ? a[e] : a[e.indexOf("set") || "function" != typeof a["get" + e.substr(3)] ? e : "get" + e.substr(3)]()), h = this.finals[e] = "string" == typeof f && "=" === f.charAt(1) ? g + parseInt(f.charAt(0) + "1", 10) * Number(f.substr(2)) : Number(f) || 0, i = h - g, "short" === k ? (i %= d, i !== i % (d / 2) && (i = 0 > i ? i + d : i - d)) : "cw" === k && 0 > i ? i = (i + 9999999999 * d) % d - (0 | i / d) * d : "ccw" === k && i > 0 && (i = (i - 9999999999 * d) % d - (0 | i / d) * d), this._addTween(a, e, g, g + i, e), this._overwriteProps.push(e));
                    return !0
                },
                set: function(a) {
                    var b;
                    if (1 !== a) this._super.setRatio.call(this, a);
                    else
                        for (b = this._firstPT; b;) b.f ? b.t[b.p](this.finals[b.p]) : b.t[b.p] = this.finals[b.p], b = b._next
                }
            })._autoCSS = !0, window._gsDefine("easing.Back", ["easing.Ease"], function(a) {
                var o, p, q, b = window.GreenSockGlobals || window,
                    c = b.com.greensock,
                    d = 2 * Math.PI,
                    e = Math.PI / 2,
                    f = c._class,
                    g = function(b, c) {
                        var d = f("easing." + b, function() {}, !0),
                            e = d.prototype = new a;
                        return e.constructor = d, e.getRatio = c, d
                    },
                    h = a.register || function() {},
                    i = function(a, b, c, d) {
                        var g = f("easing." + a, {
                            easeOut: new b,
                            easeIn: new c,
                            easeInOut: new d
                        }, !0);
                        return h(g, a), g
                    },
                    j = function(a, b, c) {
                        this.t = a, this.v = b, c && (this.next = c, c.prev = this, this.c = c.v - b, this.gap = c.t - a)
                    },
                    k = function(b, c) {
                        var d = f("easing." + b, function(a) {
                                this._p1 = a || 0 === a ? a : 1.70158, this._p2 = 1.525 * this._p1
                            }, !0),
                            e = d.prototype = new a;
                        return e.constructor = d, e.getRatio = c, e.config = function(a) {
                            return new d(a)
                        }, d
                    },
                    l = i("Back", k("BackOut", function(a) {
                        return (a -= 1) * a * ((this._p1 + 1) * a + this._p1) + 1
                    }), k("BackIn", function(a) {
                        return a * a * ((this._p1 + 1) * a - this._p1)
                    }), k("BackInOut", function(a) {
                        return 1 > (a *= 2) ? .5 * a * a * ((this._p2 + 1) * a - this._p2) : .5 * ((a -= 2) * a * ((this._p2 + 1) * a + this._p2) + 2)
                    })),
                    m = f("easing.SlowMo", function(a, b, c) {
                        b = b || 0 === b ? b : .7, null == a ? a = .7 : a > 1 && (a = 1), this._p = 1 !== a ? b : 0, this._p1 = (1 - a) / 2, this._p2 = a, this._p3 = this._p1 + this._p2, this._calcEnd = c === !0
                    }, !0),
                    n = m.prototype = new a;
                return n.constructor = m, n.getRatio = function(a) {
                    var b = a + (.5 - a) * this._p;
                    return this._p1 > a ? this._calcEnd ? 1 - (a = 1 - a / this._p1) * a : b - (a = 1 - a / this._p1) * a * a * a * b : a > this._p3 ? this._calcEnd ? 1 - (a = (a - this._p3) / this._p1) * a : b + (a - b) * (a = (a - this._p3) / this._p1) * a * a * a : this._calcEnd ? 1 : b
                }, m.ease = new m(.7, .7), n.config = m.config = function(a, b, c) {
                    return new m(a, b, c)
                }, o = f("easing.SteppedEase", function(a) {
                    a = a || 1, this._p1 = 1 / a, this._p2 = a + 1
                }, !0), n = o.prototype = new a, n.constructor = o, n.getRatio = function(a) {
                    return 0 > a ? a = 0 : a >= 1 && (a = .999999999), (this._p2 * a >> 0) * this._p1
                }, n.config = o.config = function(a) {
                    return new o(a)
                }, p = f("easing.RoughEase", function(b) {
                    b = b || {};
                    for (var m, n, o, p, q, r, c = b.taper || "none", d = [], e = 0, f = 0 | (b.points || 20), g = f, h = b.randomize !== !1, i = b.clamp === !0, k = b.template instanceof a ? b.template : null, l = "number" == typeof b.strength ? .4 * b.strength : .4; --g > -1;) m = h ? Math.random() : 1 / f * g, n = k ? k.getRatio(m) : m, "none" === c ? o = l : "out" === c ? (p = 1 - m, o = p * p * l) : "in" === c ? o = m * m * l : .5 > m ? (p = 2 * m, o = .5 * p * p * l) : (p = 2 * (1 - m), o = .5 * p * p * l), h ? n += Math.random() * o - .5 * o : g % 2 ? n += .5 * o : n -= .5 * o, i && (n > 1 ? n = 1 : 0 > n && (n = 0)), d[e++] = {
                        x: m,
                        y: n
                    };
                    for (d.sort(function(a, b) {
                            return a.x - b.x
                        }), r = new j(1, 1, null), g = f; --g > -1;) q = d[g], r = new j(q.x, q.y, r);
                    this._prev = new j(0, 0, 0 !== r.t ? r : r.next)
                }, !0), n = p.prototype = new a, n.constructor = p, n.getRatio = function(a) {
                    var b = this._prev;
                    if (a > b.t) {
                        for (; b.next && a >= b.t;) b = b.next;
                        b = b.prev
                    } else
                        for (; b.prev && b.t >= a;) b = b.prev;
                    return this._prev = b, b.v + (a - b.t) / b.gap * b.c
                }, n.config = function(a) {
                    return new p(a)
                }, p.ease = new p, i("Bounce", g("BounceOut", function(a) {
                    return 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375
                }), g("BounceIn", function(a) {
                    return 1 / 2.75 > (a = 1 - a) ? 1 - 7.5625 * a * a : 2 / 2.75 > a ? 1 - (7.5625 * (a -= 1.5 / 2.75) * a + .75) : 2.5 / 2.75 > a ? 1 - (7.5625 * (a -= 2.25 / 2.75) * a + .9375) : 1 - (7.5625 * (a -= 2.625 / 2.75) * a + .984375)
                }), g("BounceInOut", function(a) {
                    var b = .5 > a;
                    return a = b ? 1 - 2 * a : 2 * a - 1, a = 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375, b ? .5 * (1 - a) : .5 * a + .5
                })), i("Circ", g("CircOut", function(a) {
                    return Math.sqrt(1 - (a -= 1) * a)
                }), g("CircIn", function(a) {
                    return -(Math.sqrt(1 - a * a) - 1)
                }), g("CircInOut", function(a) {
                    return 1 > (a *= 2) ? -.5 * (Math.sqrt(1 - a * a) - 1) : .5 * (Math.sqrt(1 - (a -= 2) * a) + 1)
                })), q = function(b, c, e) {
                    var g = f("easing." + b, function(a, b) {
                            this._p1 = a || 1, this._p2 = b || e, this._p3 = this._p2 / d * (Math.asin(1 / this._p1) || 0)
                        }, !0),
                        h = g.prototype = new a;
                    return h.constructor = g, h.getRatio = c, h.config = function(a, b) {
                        return new g(a, b)
                    }, g
                }, i("Elastic", q("ElasticOut", function(a) {
                    return this._p1 * Math.pow(2, -10 * a) * Math.sin((a - this._p3) * d / this._p2) + 1
                }, .3), q("ElasticIn", function(a) {
                    return -(this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * d / this._p2))
                }, .3), q("ElasticInOut", function(a) {
                    return 1 > (a *= 2) ? -.5 * this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * d / this._p2) : .5 * this._p1 * Math.pow(2, -10 * (a -= 1)) * Math.sin((a - this._p3) * d / this._p2) + 1
                }, .45)), i("Expo", g("ExpoOut", function(a) {
                    return 1 - Math.pow(2, -10 * a)
                }), g("ExpoIn", function(a) {
                    return Math.pow(2, 10 * (a - 1)) - .001
                }), g("ExpoInOut", function(a) {
                    return 1 > (a *= 2) ? .5 * Math.pow(2, 10 * (a - 1)) : .5 * (2 - Math.pow(2, -10 * (a - 1)))
                })), i("Sine", g("SineOut", function(a) {
                    return Math.sin(a * e)
                }), g("SineIn", function(a) {
                    return -Math.cos(a * e) + 1
                }), g("SineInOut", function(a) {
                    return -.5 * (Math.cos(Math.PI * a) - 1)
                })), f("easing.EaseLookup", {
                    find: function(b) {
                        return a.map[b]
                    }
                }, !0), h(b.SlowMo, "SlowMo", "ease,"), h(p, "RoughEase", "ease,"), h(o, "SteppedEase", "ease,"), l
            }, !0)
    }),
    function(a) {
        "use strict";
        var f, g, h, i, j, b = a.GreenSockGlobals || a,
            c = function(a) {
                var e, c = a.split("."),
                    d = b;
                for (e = 0; c.length > e; e++) d[c[e]] = d = d[c[e]] || {};
                return d
            },
            d = c("com.greensock"),
            e = function() {},
            k = {},
            l = function(d, e, f, g) {
                this.sc = k[d] ? k[d].sc : [], k[d] = this, this.gsClass = null, this.func = f;
                var h = [];
                this.check = function(i) {
                    for (var n, o, p, q, j = e.length, m = j; --j > -1;)(n = k[e[j]] || new l(e[j], [])).gsClass ? (h[j] = n.gsClass, m--) : i && n.sc.push(this);
                    if (0 === m && f)
                        for (o = ("com.greensock." + d).split("."), p = o.pop(), q = c(o.join("."))[p] = this.gsClass = f.apply(f, h), g && (b[p] = q, "function" == typeof define && define.amd ? define((a.GreenSockAMDPath ? a.GreenSockAMDPath + "/" : "") + d.split(".").join("/"), [], function() {
                                return q
                            }) : "undefined" != typeof module && module.exports && (module.exports = q)), j = 0; this.sc.length > j; j++) this.sc[j].check()
                }, this.check(!0)
            },
            m = a._gsDefine = function(a, b, c, d) {
                return new l(a, b, c, d)
            },
            n = d._class = function(a, b, c) {
                return b = b || function() {}, m(a, [], function() {
                    return b
                }, c), b
            };
        m.globals = b;
        var o = [0, 0, 1, 1],
            p = [],
            q = n("easing.Ease", function(a, b, c, d) {
                this._func = a, this._type = c || 0, this._power = d || 0, this._params = b ? o.concat(b) : o
            }, !0),
            r = q.map = {},
            s = q.register = function(a, b, c, e) {
                for (var i, j, k, l, f = b.split(","), g = f.length, h = (c || "easeIn,easeOut,easeInOut").split(","); --g > -1;)
                    for (j = f[g], i = e ? n("easing." + j, null, !0) : d.easing[j] || {}, k = h.length; --k > -1;) l = h[k], r[j + "." + l] = r[l + j] = i[l] = a.getRatio ? a : a[l] || new a
            };
        for (h = q.prototype, h._calcEnd = !1, h.getRatio = function(a) {
                if (this._func) return this._params[0] = a, this._func.apply(null, this._params);
                var b = this._type,
                    c = this._power,
                    d = 1 === b ? 1 - a : 2 === b ? a : .5 > a ? 2 * a : 2 * (1 - a);
                return 1 === c ? d *= d : 2 === c ? d *= d * d : 3 === c ? d *= d * d * d : 4 === c && (d *= d * d * d * d), 1 === b ? 1 - d : 2 === b ? d : .5 > a ? d / 2 : 1 - d / 2
            }, f = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"], g = f.length; --g > -1;) h = f[g] + ",Power" + g, s(new q(null, null, 1, g), h, "easeOut", !0), s(new q(null, null, 2, g), h, "easeIn" + (0 === g ? ",easeNone" : "")), s(new q(null, null, 3, g), h, "easeInOut");
        r.linear = d.easing.Linear.easeIn, r.swing = d.easing.Quad.easeInOut;
        var t = n("events.EventDispatcher", function(a) {
            this._listeners = {}, this._eventTarget = a || this
        });
        h = t.prototype, h.addEventListener = function(a, b, c, d, e) {
            e = e || 0;
            var h, k, f = this._listeners[a],
                g = 0;
            for (null == f && (this._listeners[a] = f = []), k = f.length; --k > -1;) h = f[k], h.c === b && h.s === c ? f.splice(k, 1) : 0 === g && e > h.pr && (g = k + 1);
            f.splice(g, 0, {
                c: b,
                s: c,
                up: d,
                pr: e
            }), this !== i || j || i.wake()
        }, h.removeEventListener = function(a, b) {
            var d, c = this._listeners[a];
            if (c)
                for (d = c.length; --d > -1;)
                    if (c[d].c === b) return c.splice(d, 1), void 0
        }, h.dispatchEvent = function(a) {
            var c, d, e, b = this._listeners[a];
            if (b)
                for (c = b.length, d = this._eventTarget; --c > -1;) e = b[c], e.up ? e.c.call(e.s || d, {
                    type: a,
                    target: d
                }) : e.c.call(e.s || d)
        };
        var u = a.requestAnimationFrame,
            v = a.cancelAnimationFrame,
            w = Date.now || function() {
                return (new Date).getTime()
            };
        for (f = ["ms", "moz", "webkit", "o"], g = f.length; --g > -1 && !u;) u = a[f[g] + "RequestAnimationFrame"], v = a[f[g] + "CancelAnimationFrame"] || a[f[g] + "CancelRequestAnimationFrame"];
        n("Ticker", function(a, b) {
            var g, h, k, l, m, c = this,
                d = w(),
                f = b !== !1 && u,
                n = function(a) {
                    c.time = (w() - d) / 1e3, (!g || c.time >= m || a === !0) && (c.frame++, m = c.time + l, c.dispatchEvent("tick")), a !== !0 && (k = h(n))
                };
            t.call(c), this.time = this.frame = 0, this.tick = function() {
                n(!0)
            }, this.sleep = function() {
                null != k && (f && v ? v(k) : clearTimeout(k), h = e, k = null, c === i && (j = !1))
            }, this.wake = function() {
                k && c.sleep(), h = 0 === g ? e : f && u ? u : function(a) {
                    return setTimeout(a, 1e3 * l)
                }, c === i && (j = !0), n()
            }, this.fps = function(a) {
                return arguments.length ? (g = a, l = 1 / (g || 60), m = this.time + l, c.wake(), void 0) : g
            }, this.useRAF = function(a) {
                return arguments.length ? (f = a, c.fps(g), void 0) : f
            }, c.fps(a), setTimeout(function() {
                f && !k && c.useRAF(!1)
            }, 1e3)
        }), h = d.Ticker.prototype = new d.events.EventDispatcher, h.constructor = d.Ticker;
        var x = n("core.Animation", function(a, b) {
            if (this.vars = b || {}, this._duration = this._totalDuration = a || 0, this._delay = Number(this.vars.delay) || 0, this._timeScale = 1, this._active = this.vars.immediateRender === !0, this.data = this.vars.data, this._reversed = this.vars.reversed === !0, K) {
                j || i.wake();
                var c = this.vars.useFrames ? J : K;
                c.add(this, c._time), this.vars.paused && this.paused(!0)
            }
        });
        i = x.ticker = new d.Ticker, h = x.prototype, h._dirty = h._gc = h._initted = h._paused = !1, h._totalTime = h._time = 0, h._rawPrevTime = -1, h._next = h._last = h._onUpdate = h._timeline = h.timeline = null, h._paused = !1, h.play = function(a, b) {
            return arguments.length && this.seek(a, b), this.reversed(!1), this.paused(!1)
        }, h.pause = function(a, b) {
            return arguments.length && this.seek(a, b), this.paused(!0)
        }, h.resume = function(a, b) {
            return arguments.length && this.seek(a, b), this.paused(!1)
        }, h.seek = function(a, b) {
            return this.totalTime(Number(a), b !== !1)
        }, h.restart = function(a, b) {
            return this.reversed(!1), this.paused(!1), this.totalTime(a ? -this._delay : 0, b !== !1)
        }, h.reverse = function(a, b) {
            return arguments.length && this.seek(a || this.totalDuration(), b), this.reversed(!0), this.paused(!1)
        }, h.render = function() {}, h.invalidate = function() {
            return this
        }, h._enabled = function(a, b) {
            return j || i.wake(), this._gc = !a, this._active = a && !this._paused && this._totalTime > 0 && this._totalTime < this._totalDuration, b !== !0 && (a && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !a && this.timeline && this._timeline._remove(this, !0)), !1
        }, h._kill = function() {
            return this._enabled(!1, !1)
        }, h.kill = function(a, b) {
            return this._kill(a, b), this
        }, h._uncache = function(a) {
            for (var b = a ? this : this.timeline; b;) b._dirty = !0, b = b.timeline;
            return this
        }, h.eventCallback = function(a, b, c, d) {
            if (null == a) return null;
            if ("on" === a.substr(0, 2)) {
                var f, e = this.vars;
                if (1 === arguments.length) return e[a];
                if (null == b) delete e[a];
                else if (e[a] = b, e[a + "Params"] = c, e[a + "Scope"] = d, c)
                    for (f = c.length; --f > -1;) "{self}" === c[f] && (c = e[a + "Params"] = c.concat(), c[f] = this);
                "onUpdate" === a && (this._onUpdate = b)
            }
            return this
        }, h.delay = function(a) {
            return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + a - this._delay), this._delay = a, this) : this._delay
        }, h.duration = function(a) {
            return arguments.length ? (this._duration = this._totalDuration = a, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== a && this.totalTime(this._totalTime * (a / this._duration), !0), this) : (this._dirty = !1, this._duration)
        }, h.totalDuration = function(a) {
            return this._dirty = !1, arguments.length ? this.duration(a) : this._totalDuration
        }, h.time = function(a, b) {
            return arguments.length ? (this._dirty && this.totalDuration(), a > this._duration && (a = this._duration), this.totalTime(a, b)) : this._time
        }, h.totalTime = function(a, b) {
            if (j || i.wake(), !arguments.length) return this._totalTime;
            if (this._timeline) {
                if (0 > a && (a += this.totalDuration()), this._timeline.smoothChildTiming) {
                    this._dirty && this.totalDuration();
                    var c = this._totalDuration,
                        d = this._timeline;
                    if (a > c && (a = c), this._startTime = (this._paused ? this._pauseTime : d._time) - (this._reversed ? c - a : a) / this._timeScale, d._dirty || this._uncache(!1), !d._active)
                        for (; d._timeline;) d.totalTime(d._totalTime, !0), d = d._timeline
                }
                this._gc && this._enabled(!0, !1), this._totalTime !== a && this.render(a, b, !1)
            }
            return this
        }, h.startTime = function(a) {
            return arguments.length ? (a !== this._startTime && (this._startTime = a, this.timeline && this.timeline._sortChildren && this.timeline.add(this, a - this._delay)), this) : this._startTime
        }, h.timeScale = function(a) {
            if (!arguments.length) return this._timeScale;
            if (a = a || 1e-6, this._timeline && this._timeline.smoothChildTiming) {
                var b = this._pauseTime,
                    c = b || 0 === b ? b : this._timeline.totalTime();
                this._startTime = c - (c - this._startTime) * this._timeScale / a
            }
            return this._timeScale = a, this._uncache(!1)
        }, h.reversed = function(a) {
            return arguments.length ? (a != this._reversed && (this._reversed = a, this.totalTime(this._totalTime, !0)), this) : this._reversed
        }, h.paused = function(a) {
            if (!arguments.length) return this._paused;
            if (a != this._paused && this._timeline) {
                j || a || i.wake();
                var b = this._timeline.rawTime(),
                    c = b - this._pauseTime;
                !a && this._timeline.smoothChildTiming && (this._startTime += c, this._uncache(!1)), this._pauseTime = a ? b : null, this._paused = a, this._active = !a && this._totalTime > 0 && this._totalTime < this._totalDuration, a || 0 === c || 0 === this._duration || this.render(this._time, !0, !0)
            }
            return this._gc && !a && this._enabled(!0, !1), this
        };
        var y = n("core.SimpleTimeline", function(a) {
            x.call(this, 0, a), this.autoRemoveChildren = this.smoothChildTiming = !0
        });
        h = y.prototype = new x, h.constructor = y, h.kill()._gc = !1, h._first = h._last = null, h._sortChildren = !1, h.add = function(a, b) {
            var e, f;
            if (a._startTime = Number(b || 0) + a._delay, a._paused && this !== a._timeline && (a._pauseTime = a._startTime + (this.rawTime() - a._startTime) / a._timeScale), a.timeline && a.timeline._remove(a, !0), a.timeline = a._timeline = this, a._gc && a._enabled(!0, !0), e = this._last, this._sortChildren)
                for (f = a._startTime; e && e._startTime > f;) e = e._prev;
            return e ? (a._next = e._next, e._next = a) : (a._next = this._first, this._first = a), a._next ? a._next._prev = a : this._last = a, a._prev = e, this._timeline && this._uncache(!0), this
        }, h.insert = h.add, h._remove = function(a, b) {
            return a.timeline === this && (b || a._enabled(!1, !0), a.timeline = null, a._prev ? a._prev._next = a._next : this._first === a && (this._first = a._next), a._next ? a._next._prev = a._prev : this._last === a && (this._last = a._prev), this._timeline && this._uncache(!0)), this
        }, h.render = function(a, b, c) {
            var e, d = this._first;
            for (this._totalTime = this._time = this._rawPrevTime = a; d;) e = d._next, (d._active || a >= d._startTime && !d._paused) && (d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)), d = e
        }, h.rawTime = function() {
            return j || i.wake(), this._totalTime
        };
        var z = n("TweenLite", function(a, b, c) {
                if (x.call(this, b, c), null == a) throw "Cannot tween a null target.";
                this.target = a = "string" != typeof a ? a : z.selector(a) || a;
                var f, g, h, d = a.jquery || "function" == typeof a.each && a[0] && a[0].nodeType && a[0].style,
                    e = this.vars.overwrite;
                if (this._overwrite = e = null == e ? I[z.defaultOverwrite] : "number" == typeof e ? e >> 0 : I[e], (d || a instanceof Array) && "number" != typeof a[0])
                    for (this._targets = h = d && !a.slice ? B(a) : a.slice(0), this._propLookup = [], this._siblings = [], f = 0; h.length > f; f++) g = h[f], g ? "string" != typeof g ? "function" == typeof g.each && g[0] && g[0].nodeType && g[0].style ? (h.splice(f--, 1), this._targets = h = h.concat(B(g))) : (this._siblings[f] = L(g, this, !1), 1 === e && this._siblings[f].length > 1 && M(g, this, null, 1, this._siblings[f])) : (g = h[f--] = z.selector(g), "string" == typeof g && h.splice(f + 1, 1)) : h.splice(f--, 1);
                else this._propLookup = {}, this._siblings = L(a, this, !1), 1 === e && this._siblings.length > 1 && M(a, this, null, 1, this._siblings);
                (this.vars.immediateRender || 0 === b && 0 === this._delay && this.vars.immediateRender !== !1) && this.render(-this._delay, !1, !0)
            }, !0),
            A = function(a) {
                return "function" == typeof a.each && a[0] && a[0].nodeType && a[0].style
            },
            B = function(a) {
                var b = [];
                return a.each(function() {
                    b.push(this)
                }), b
            },
            C = function(a, b) {
                var d, c = {};
                for (d in a) H[d] || d in b && "x" !== d && "y" !== d && "width" !== d && "height" !== d && "className" !== d || !(!E[d] || E[d] && E[d]._autoCSS) || (c[d] = a[d], delete a[d]);
                a.css = c
            };
        h = z.prototype = new x, h.constructor = z, h.kill()._gc = !1, h.ratio = 0, h._firstPT = h._targets = h._overwrittenProps = h._startAt = null, h._notifyPluginsOfEnabled = !1, z.version = "1.9.3", z.defaultEase = h._ease = new q(null, null, 1, 1), z.defaultOverwrite = "auto", z.ticker = i, z.autoSleep = !0, z.selector = a.$ || a.jQuery || function(b) {
            return a.$ ? (z.selector = a.$, a.$(b)) : a.document ? a.document.getElementById("#" === b.charAt(0) ? b.substr(1) : b) : b
        };
        var D = z._internals = {},
            E = z._plugins = {},
            F = z._tweenLookup = {},
            G = 0,
            H = D.reservedProps = {
                ease: 1,
                delay: 1,
                overwrite: 1,
                onComplete: 1,
                onCompleteParams: 1,
                onCompleteScope: 1,
                useFrames: 1,
                runBackwards: 1,
                startAt: 1,
                onUpdate: 1,
                onUpdateParams: 1,
                onUpdateScope: 1,
                onStart: 1,
                onStartParams: 1,
                onStartScope: 1,
                onReverseComplete: 1,
                onReverseCompleteParams: 1,
                onReverseCompleteScope: 1,
                onRepeat: 1,
                onRepeatParams: 1,
                onRepeatScope: 1,
                easeParams: 1,
                yoyo: 1,
                immediateRender: 1,
                repeat: 1,
                repeatDelay: 1,
                data: 1,
                paused: 1,
                reversed: 1,
                autoCSS: 1
            },
            I = {
                none: 0,
                all: 1,
                auto: 2,
                concurrent: 3,
                allOnStart: 4,
                preexisting: 5,
                "true": 1,
                "false": 0
            },
            J = x._rootFramesTimeline = new y,
            K = x._rootTimeline = new y;
        K._startTime = i.time, J._startTime = i.frame, K._active = J._active = !0, x._updateRoot = function() {
            if (K.render((i.time - K._startTime) * K._timeScale, !1, !1), J.render((i.frame - J._startTime) * J._timeScale, !1, !1), !(i.frame % 120)) {
                var a, b, c;
                for (c in F) {
                    for (b = F[c].tweens, a = b.length; --a > -1;) b[a]._gc && b.splice(a, 1);
                    0 === b.length && delete F[c]
                }
                if (c = K._first, (!c || c._paused) && z.autoSleep && !J._first && 1 === i._listeners.tick.length) {
                    for (; c && c._paused;) c = c._next;
                    c || i.sleep()
                }
            }
        }, i.addEventListener("tick", x._updateRoot);
        var L = function(a, b, c) {
                var e, f, d = a._gsTweenID;
                if (F[d || (a._gsTweenID = d = "t" + G++)] || (F[d] = {
                        target: a,
                        tweens: []
                    }), b && (e = F[d].tweens, e[f = e.length] = b, c))
                    for (; --f > -1;) e[f] === b && e.splice(f, 1);
                return F[d].tweens
            },
            M = function(a, b, c, d, e) {
                var f, g, h, i;
                if (1 === d || d >= 4) {
                    for (i = e.length, f = 0; i > f; f++)
                        if ((h = e[f]) !== b) h._gc || h._enabled(!1, !1) && (g = !0);
                        else if (5 === d) break;
                    return g
                }
                var n, j = b._startTime + 1e-10,
                    k = [],
                    l = 0,
                    m = 0 === b._duration;
                for (f = e.length; --f > -1;)(h = e[f]) === b || h._gc || h._paused || (h._timeline !== b._timeline ? (n = n || N(b, 0, m), 0 === N(h, n, m) && (k[l++] = h)) : j >= h._startTime && h._startTime + h.totalDuration() / h._timeScale + 1e-10 > j && ((m || !h._initted) && 2e-10 >= j - h._startTime || (k[l++] = h)));
                for (f = l; --f > -1;) h = k[f], 2 === d && h._kill(c, a) && (g = !0), (2 !== d || !h._firstPT && h._initted) && h._enabled(!1, !1) && (g = !0);
                return g
            },
            N = function(a, b, c) {
                for (var d = a._timeline, e = d._timeScale, f = a._startTime; d._timeline;) {
                    if (f += d._startTime, e *= d._timeScale, d._paused) return -100;
                    d = d._timeline
                }
                return f /= e, f > b ? f - b : c && f === b || !a._initted && 2e-10 > f - b ? 1e-10 : (f += a.totalDuration() / a._timeScale / e) > b ? 0 : f - b - 1e-10
            };
        h._init = function() {
            var e, f, g, h, a = this.vars,
                b = this._overwrittenProps,
                c = this._duration,
                d = a.ease;
            if (a.startAt) {
                if (a.startAt.overwrite = 0, a.startAt.immediateRender = !0, this._startAt = z.to(this.target, 0, a.startAt), a.immediateRender && (this._startAt = null, 0 === this._time && 0 !== c)) return
            } else if (a.runBackwards && a.immediateRender && 0 !== c)
                if (this._startAt) this._startAt.render(-1, !0), this._startAt = null;
                else if (0 === this._time) {
                g = {};
                for (h in a) H[h] && "autoCSS" !== h || (g[h] = a[h]);
                return g.overwrite = 0, this._startAt = z.to(this.target, 0, g), void 0
            }
            if (this._ease = d ? d instanceof q ? a.easeParams instanceof Array ? d.config.apply(d, a.easeParams) : d : "function" == typeof d ? new q(d, a.easeParams) : r[d] || z.defaultEase : z.defaultEase, this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets)
                for (e = this._targets.length; --e > -1;) this._initProps(this._targets[e], this._propLookup[e] = {}, this._siblings[e], b ? b[e] : null) && (f = !0);
            else f = this._initProps(this.target, this._propLookup, this._siblings, b);
            if (f && z._onPluginEvent("_onInitAllProps", this), b && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), a.runBackwards)
                for (g = this._firstPT; g;) g.s += g.c, g.c = -g.c, g = g._next;
            this._onUpdate = a.onUpdate, this._initted = !0
        }, h._initProps = function(a, b, c, d) {
            var e, f, g, h, i, j, k;
            if (null == a) return !1;
            this.vars.css || a.style && a.nodeType && E.css && this.vars.autoCSS !== !1 && C(this.vars, a);
            for (e in this.vars) {
                if (H[e]) {
                    if (("onStartParams" === e || "onUpdateParams" === e || "onCompleteParams" === e || "onReverseCompleteParams" === e || "onRepeatParams" === e) && (i = this.vars[e]))
                        for (f = i.length; --f > -1;) "{self}" === i[f] && (i = this.vars[e] = i.concat(), i[f] = this)
                } else if (E[e] && (h = new E[e])._onInitTween(a, this.vars[e], this)) {
                    for (this._firstPT = j = {
                            _next: this._firstPT,
                            t: h,
                            p: "setRatio",
                            s: 0,
                            c: 1,
                            f: !0,
                            n: e,
                            pg: !0,
                            pr: h._priority
                        }, f = h._overwriteProps.length; --f > -1;) b[h._overwriteProps[f]] = this._firstPT;
                    (h._priority || h._onInitAllProps) && (g = !0), (h._onDisable || h._onEnable) && (this._notifyPluginsOfEnabled = !0)
                } else this._firstPT = b[e] = j = {
                    _next: this._firstPT,
                    t: a,
                    p: e,
                    f: "function" == typeof a[e],
                    n: e,
                    pg: !1,
                    pr: 0
                }, j.s = j.f ? a[e.indexOf("set") || "function" != typeof a["get" + e.substr(3)] ? e : "get" + e.substr(3)]() : parseFloat(a[e]), k = this.vars[e], j.c = "string" == typeof k && "=" === k.charAt(1) ? parseInt(k.charAt(0) + "1", 10) * Number(k.substr(2)) : Number(k) - j.s || 0;
                j && j._next && (j._next._prev = j)
            }
            return d && this._kill(d, a) ? this._initProps(a, b, c, d) : this._overwrite > 1 && this._firstPT && c.length > 1 && M(a, this, b, this._overwrite, c) ? (this._kill(b, a), this._initProps(a, b, c, d)) : g
        }, h.render = function(a, b, c) {
            var e, f, g, d = this._time;
            if (a >= this._duration) this._totalTime = this._time = this._duration, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (e = !0, f = "onComplete"), 0 === this._duration && ((0 === a || 0 > this._rawPrevTime) && this._rawPrevTime !== a && (c = !0), this._rawPrevTime = a);
            else if (1e-7 > a) this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== d || 0 === this._duration && this._rawPrevTime > 0) && (f = "onReverseComplete", e = this._reversed), 0 > a ? (this._active = !1, 0 === this._duration && (this._rawPrevTime >= 0 && (c = !0), this._rawPrevTime = a)) : this._initted || (c = !0);
            else if (this._totalTime = this._time = a, this._easeType) {
                var h = a / this._duration,
                    i = this._easeType,
                    j = this._easePower;
                (1 === i || 3 === i && h >= .5) && (h = 1 - h), 3 === i && (h *= 2), 1 === j ? h *= h : 2 === j ? h *= h * h : 3 === j ? h *= h * h * h : 4 === j && (h *= h * h * h * h), this.ratio = 1 === i ? 1 - h : 2 === i ? h : .5 > a / this._duration ? h / 2 : 1 - h / 2
            } else this.ratio = this._ease.getRatio(a / this._duration);
            if (this._time !== d || c) {
                if (!this._initted) {
                    if (this._init(), !this._initted) return;
                    this._time && !e ? this.ratio = this._ease.getRatio(this._time / this._duration) : e && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
                }
                for (this._active || this._paused || (this._active = !0), 0 === d && (this._startAt && (a >= 0 ? this._startAt.render(a, b, c) : f || (f = "_dummyGS")), this.vars.onStart && (0 !== this._time || 0 === this._duration) && (b || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || p))), g = this._firstPT; g;) g.f ? g.t[g.p](g.c * this.ratio + g.s) : g.t[g.p] = g.c * this.ratio + g.s, g = g._next;
                this._onUpdate && (0 > a && this._startAt && this._startAt.render(a, b, c), b || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || p)), f && (this._gc || (0 > a && this._startAt && !this._onUpdate && this._startAt.render(a, b, c), e && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !b && this.vars[f] && this.vars[f].apply(this.vars[f + "Scope"] || this, this.vars[f + "Params"] || p)))
            }
        }, h._kill = function(a, b) {
            if ("all" === a && (a = null), null == a && (null == b || b === this.target)) return this._enabled(!1, !1);
            b = "string" != typeof b ? b || this._targets || this.target : z.selector(b) || b;
            var c, d, e, f, g, h, i, j;
            if ((b instanceof Array || A(b)) && "number" != typeof b[0])
                for (c = b.length; --c > -1;) this._kill(a, b[c]) && (h = !0);
            else {
                if (this._targets) {
                    for (c = this._targets.length; --c > -1;)
                        if (b === this._targets[c]) {
                            g = this._propLookup[c] || {}, this._overwrittenProps = this._overwrittenProps || [], d = this._overwrittenProps[c] = a ? this._overwrittenProps[c] || {} : "all";
                            break
                        }
                } else {
                    if (b !== this.target) return !1;
                    g = this._propLookup, d = this._overwrittenProps = a ? this._overwrittenProps || {} : "all"
                }
                if (g) {
                    i = a || g, j = a !== d && "all" !== d && a !== g && (null == a || a._tempKill !== !0);
                    for (e in i)(f = g[e]) && (f.pg && f.t._kill(i) && (h = !0), f.pg && 0 !== f.t._overwriteProps.length || (f._prev ? f._prev._next = f._next : f === this._firstPT && (this._firstPT = f._next), f._next && (f._next._prev = f._prev), f._next = f._prev = null), delete g[e]), j && (d[e] = 1);
                    this._firstPT || this._enabled(!1, !1)
                }
            }
            return h
        }, h.invalidate = function() {
            return this._notifyPluginsOfEnabled && z._onPluginEvent("_onDisable", this), this._firstPT = null, this._overwrittenProps = null, this._onUpdate = null, this._startAt = null, this._initted = this._active = this._notifyPluginsOfEnabled = !1, this._propLookup = this._targets ? {} : [], this
        }, h._enabled = function(a, b) {
            if (j || i.wake(), a && this._gc) {
                var d, c = this._targets;
                if (c)
                    for (d = c.length; --d > -1;) this._siblings[d] = L(c[d], this, !0);
                else this._siblings = L(this.target, this, !0)
            }
            return x.prototype._enabled.call(this, a, b), this._notifyPluginsOfEnabled && this._firstPT ? z._onPluginEvent(a ? "_onEnable" : "_onDisable", this) : !1
        }, z.to = function(a, b, c) {
            return new z(a, b, c)
        }, z.from = function(a, b, c) {
            return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, new z(a, b, c)
        }, z.fromTo = function(a, b, c, d) {
            return d.startAt = c, d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender, new z(a, b, d)
        }, z.delayedCall = function(a, b, c, d, e) {
            return new z(b, 0, {
                delay: a,
                onComplete: b,
                onCompleteParams: c,
                onCompleteScope: d,
                onReverseComplete: b,
                onReverseCompleteParams: c,
                onReverseCompleteScope: d,
                immediateRender: !1,
                useFrames: e,
                overwrite: 0
            })
        }, z.set = function(a, b) {
            return new z(a, 0, b)
        }, z.killTweensOf = z.killDelayedCallsTo = function(a, b) {
            for (var c = z.getTweensOf(a), d = c.length; --d > -1;) c[d]._kill(b, a)
        }, z.getTweensOf = function(a) {
            if (null == a) return [];
            a = "string" != typeof a ? a : z.selector(a) || a;
            var b, c, d, e;
            if ((a instanceof Array || A(a)) && "number" != typeof a[0]) {
                for (b = a.length, c = []; --b > -1;) c = c.concat(z.getTweensOf(a[b]));
                for (b = c.length; --b > -1;)
                    for (e = c[b], d = b; --d > -1;) e === c[d] && c.splice(b, 1)
            } else
                for (c = L(a).concat(), b = c.length; --b > -1;) c[b]._gc && c.splice(b, 1);
            return c
        };
        var O = n("plugins.TweenPlugin", function(a, b) {
            this._overwriteProps = (a || "").split(","), this._propName = this._overwriteProps[0], this._priority = b || 0, this._super = O.prototype
        }, !0);
        if (h = O.prototype, O.version = "1.9.1", O.API = 2, h._firstPT = null, h._addTween = function(a, b, c, d, e, f) {
                var g, h;
                null != d && (g = "number" == typeof d || "=" !== d.charAt(1) ? Number(d) - c : parseInt(d.charAt(0) + "1", 10) * Number(d.substr(2))) && (this._firstPT = h = {
                    _next: this._firstPT,
                    t: a,
                    p: b,
                    s: c,
                    c: g,
                    f: "function" == typeof a[b],
                    n: e || b,
                    r: f
                }, h._next && (h._next._prev = h))
            }, h.setRatio = function(a) {
                for (var d, b = this._firstPT, c = 1e-6; b;) d = b.c * a + b.s, b.r ? d = d + (d > 0 ? .5 : -.5) >> 0 : c > d && d > -c && (d = 0), b.f ? b.t[b.p](d) : b.t[b.p] = d, b = b._next
            }, h._kill = function(a) {
                var d, b = this._overwriteProps,
                    c = this._firstPT;
                if (null != a[this._propName]) this._overwriteProps = [];
                else
                    for (d = b.length; --d > -1;) null != a[b[d]] && b.splice(d, 1);
                for (; c;) null != a[c.n] && (c._next && (c._next._prev = c._prev), c._prev ? (c._prev._next = c._next, c._prev = null) : this._firstPT === c && (this._firstPT = c._next)), c = c._next;
                return !1
            }, h._roundProps = function(a, b) {
                for (var c = this._firstPT; c;)(a[this._propName] || null != c.n && a[c.n.split(this._propName + "_").join("")]) && (c.r = b), c = c._next
            }, z._onPluginEvent = function(a, b) {
                var d, e, f, g, h, c = b._firstPT;
                if ("_onInitAllProps" === a) {
                    for (; c;) {
                        for (h = c._next, e = f; e && e.pr > c.pr;) e = e._next;
                        (c._prev = e ? e._prev : g) ? c._prev._next = c: f = c, (c._next = e) ? e._prev = c : g = c, c = h
                    }
                    c = b._firstPT = f
                }
                for (; c;) c.pg && "function" == typeof c.t[a] && c.t[a]() && (d = !0), c = c._next;
                return d
            }, O.activate = function(a) {
                for (var b = a.length; --b > -1;) a[b].API === O.API && (E[(new a[b])._propName] = a[b]);
                return !0
            }, m.plugin = function(a) {
                if (!(a && a.propName && a.init && a.API)) throw "illegal plugin definition.";
                var h, b = a.propName,
                    c = a.priority || 0,
                    d = a.overwriteProps,
                    e = {
                        init: "_onInitTween",
                        set: "setRatio",
                        kill: "_kill",
                        round: "_roundProps",
                        initAll: "_onInitAllProps"
                    },
                    f = n("plugins." + b.charAt(0).toUpperCase() + b.substr(1) + "Plugin", function() {
                        O.call(this, b, c), this._overwriteProps = d || []
                    }, a.global === !0),
                    g = f.prototype = new O(b);
                g.constructor = f, f.API = a.API;
                for (h in e) "function" == typeof a[h] && (g[e[h]] = a[h]);
                return f.version = a.version, O.activate([f]), f
            }, f = a._gsQueue) {
            for (g = 0; f.length > g; g++) f[g]();
            for (h in k) k[h].func || a.console.log("GSAP encountered missing dependency: com.greensock." + h)
        }
        j = !1
    }(window);
/* Main */
$(function() {
    function e() {
        var e = 150;
        var t = 150;
        canvas.width = e;
        canvas.height = t;
        r.x = e / 2;
        r.y = t / 2
    }

    function t() {
        if (!!!document.createElement("canvas").getContext) {
            var t = document.getElementById("canvas_wrapper");
            t.innerHTML = "<img src='assets/images/backUp.png' alt='backUp.png'></img>";
            return
        }
        var i = document.getElementById("canvasM");
        var s = i.getContext("2d");
        window.ctx = s;
        window.canvas = i;
        bounds = new Rectangle;
        n = new Stage(i);
        window.stage = n;
        window.stage.enableMouseOver();
        r = new Container;
        window.containerFrame = r;
        n.addChild(r);
        e();
        bounds.width = i.width;
        bounds.height = i.height;
        r.regX = bounds.width / 2;
        r.regY = bounds.height / 2;
        var o = "Frame1";
        var u = new Frame1;
        r.addChild(u);
        $("body").bind("frameCompleted", function() {
            switch (o) {
                case "Frame1":
                    o = "Frame2";
                    var e = new Frame2;
                    r.addChild(e);
                    break
            }
        });
        $(window).resize(function() {
            e()
        });
        Ticker.setFPS(60);
        Ticker.addListener(window)
    }
    var n;
    var r;
    var i = 0;
    var s = 0;
    window.tick = function() {
        n.update()
    };
    t()
});
(function(e) {
    function t() {
        this.initialize()
    }
    t.prototype = new Container;
    t.prototype.Container_initialize = t.prototype.initialize;
    t.prototype.Container_tick = t.prototype.tick;
    t.prototype.dial;
    t.prototype.aiguilleHeure;
    t.prototype.aiguilleMinute;
    t.prototype.aiguilleSeconde;
    t.prototype.vis;
    t.prototype.container1;
    t.prototype.initialize = function() {
        this.Container_initialize();
        this.initVisual()
    };
    t.prototype.initVisual = function() {
        this.name = "b";
        this.container1 = new Container;
        this.container1.name = "CONTENEUR_1";
        this.addChild(this.container1);
        this.dial = new Bitmap("fileadmin/templates/pyhrn-priel/images/weltcup/dial.png");
        this.container1.addChild(this.dial);
        this.aiguilleHeure = new AiguilleHeure;
        this.aiguilleHeure.shadow = new Shadow("rgba(0,0,0,0.4)", 0, 2, 4);
        this.aiguilleHeure.regX = 4.15;
        this.aiguilleHeure.regY = 32.85;
        this.aiguilleHeure.x = 72.3;
        this.aiguilleHeure.y = 73.75;
        this.container1.addChild(this.aiguilleHeure);
        this.aiguilleMinute = new AiguilleMinute;
        this.aiguilleMinute.shadow = new Shadow("rgba(0,0,0,0.4)", 0, 3, 4);
        this.aiguilleMinute.regX = 3.7;
        this.aiguilleMinute.regY = 48;
        this.aiguilleMinute.x = 72.35;
        this.aiguilleMinute.y = 73.7;
        this.container1.addChild(this.aiguilleMinute);
        this.aiguilleSeconde = new AiguilleSeconde;
        this.aiguilleSeconde.shadow = new Shadow("rgba(0,0,0,0.3)", 0, 3, 2);
        this.aiguilleSeconde.regX = 2.95;
        this.aiguilleSeconde.regY = 49.8;
        this.aiguilleSeconde.x = 72.3;
        this.aiguilleSeconde.y = 73.7;
        this.container1.addChild(this.aiguilleSeconde);
        this.vis = new Bitmap("fileadmin/templates/pyhrn-priel/images/weltcup/vis.png");
        this.vis.regX = 2 / 2;
        this.vis.regY = 2 / 2;
        this.vis.x = 72;
        this.vis.y = 72.5;
        this.container1.addChild(this.vis);
        this.heureDeDepart(10, 8, 42, 0);
        this.runAnimation()
    };
    t.prototype.heureDeDepart = function(e, t, n, r) {
        var i = new Date;
        i.setHours(e);
        i.setMinutes(t);
        i.setSeconds(n);
        i.setMilliseconds(r);
        this.monTemps = i.getTime();
        this.aiguilleHeure.rotation = this.afficheHeure(i);
        this.aiguilleMinute.rotation = this.afficheMinute(i);
        this.aiguilleSeconde.rotation = this.afficheSeconde(i)
    };
    t.prototype.afficheHeure = function(e) {
        return 360 / 12 * e.getHours() + 360 / 12 / 60 * e.getMinutes()
    };
    t.prototype.afficheMinute = function(e) {
        return 6 * e.getMinutes() + 6 / 60 * e.getSeconds()
    };
    t.prototype.afficheSeconde = function(e) {
        return 6 * e.getSeconds() + 6 / 1e3 * e.getMilliseconds()
    };
    t.prototype.runAnimation = function() {
        var e = new Date;
        var t = e.getHours() > 12 ? e.getHours() - 12 : e.getHours();
        t = 360 / 12 * t + 360 / 12 / 60 * e.getMinutes();
        var n = 5;
        var r = e.getTime() + n * 1e3;
        e.setTime(r);
        TweenLite.to(this.aiguilleSeconde, n, {
            rotation: this.afficheSeconde(e),
            onComplete: this.onCompletedAnimation,
            onCompleteScope: this,
            ease: Strong.easeInOut
        });
        TweenLite.to(this, n, {
            monTemps: r,
            onUpdate: this.animDepart,
            onUpdateScope: this,
            ease: Strong.easeInOut
        })
    };
    t.prototype.animDepart = function() {
        var e = new Date;
        e.setTime(this.monTemps);
        this.aiguilleHeure.rotation = this.afficheHeure(e);
        this.aiguilleMinute.rotation = this.afficheMinute(e)
    };
    t.prototype.onCompletedAnimation = function() {
        Ticker.setFPS(8);
        Ticker.addListener(this)
    };
    t.prototype.tick = function() {
        var e = new Date;
        this.aiguilleHeure.rotation = this.afficheHeure(e);
        this.aiguilleMinute.rotation = this.afficheMinute(e);
        this.aiguilleSeconde.rotation = this.afficheSeconde(e)
    };
    e.Frame1 = t
})(window);
(function(e) {
    function t() {
        this.initialize()
    }
    t.prototype = new Container;
    t.prototype.Shape_initialize = t.prototype.initialize;
    t.prototype.initialize = function() {
        this.Shape_initialize();
        this.drawVector()
    };
    t.prototype.aiguille;
    t.prototype.fondAiguille;
    t.prototype.drawVector = function() {
        this.aiguille = new Container;
        this.addChild(this.aiguille);
        var e = new Graphics;
        e.beginFill(Graphics.getRGB(36, 70, 110, 100));
        e.moveTo(5.1, 28.7);
        e.bezierCurveTo(5.1, 28.7, 5.2, 28.6, 5.2, 28.5);
        e.bezierCurveTo(5.6, 23.1, 6, 22, 6.2, 18.9);
        e.bezierCurveTo(6.5, 14.8, 5.4, 8.9, 5.3, 7.7);
        e.bezierCurveTo(5, 6.1, 5, 1.8, 4.9, .6);
        e.bezierCurveTo(4.9, -0, 4.6, 0, 4.6, 0);
        e.bezierCurveTo(4.6, 0, 4.2, -0, 4.2, .7);
        e.bezierCurveTo(4.2, 1.5, 4.2, 6.2, 4, 7.8);
        e.bezierCurveTo(3.8, 9, 2.8, 14.8, 3.1, 18.8);
        e.bezierCurveTo(3.3, 22, 3.6, 23.5, 4, 28.6);
        e.bezierCurveTo(4, 28.6, 4, 28.7, 4, 28.7);
        e.bezierCurveTo(1.9, 29, .3, 30.7, .3, 32.9);
        e.bezierCurveTo(.3, 35.2, 2.2, 37.1, 4.5, 37.1);
        e.bezierCurveTo(6.8, 37.1, 8.7, 35.2, 8.7, 32.9);
        e.bezierCurveTo(8.7, 30.8, 7.1, 29.1, 5.1, 28.7);
        e.closePath();
        this.fondAiguille = new Shape;
        this.fondAiguille.graphics = e;
        this.aiguille.addChild(this.fondAiguille)
    };
    e.AiguilleHeure = t
})(window);
(function(e) {
    function t() {
        this.initialize()
    }
    t.prototype = new Container;
    t.prototype.Shape_initialize = t.prototype.initialize;
    t.prototype.initialize = function() {
        this.Shape_initialize();
        this.drawVector()
    };
    t.prototype.aiguille;
    t.prototype.fondAiguille;
    t.prototype.luminovaAiguille;
    t.prototype.drawVector = function() {
        this.aiguille = new Container;
        this.addChild(this.aiguille);
        var e = new Graphics;
        e.beginFill(Graphics.getRGB(36, 70, 110, 100));
        e.moveTo(4.6, 44.5);
        e.bezierCurveTo(4.7, 41.8, 4.9, 37.5, 5.2, 31);
        e.bezierCurveTo(5.5, 22.8, 4.9, 16.2, 4.5, 10.9);
        e.bezierCurveTo(4.2, 5.7, 4.1, 2.2, 4.1, 1.2);
        e.bezierCurveTo(4.1, .6, 3.9, .6, 3.9, .6);
        e.bezierCurveTo(3.9, .6, 3.7, .6, 3.7, 1.2);
        e.bezierCurveTo(3.7, 2.2, 3.6, 5.7, 3.3, 10.9);
        e.bezierCurveTo(2.9, 16.2, 2.2, 22.8, 2.6, 31);
        e.bezierCurveTo(2.9, 37.5, 3.1, 41.9, 3.2, 44.5);
        e.bezierCurveTo(1.7, 44.8, .5, 46.2, .5, 47.8);
        e.bezierCurveTo(.5, 49.7, 2.1, 51.2, 3.9, 51.2);
        e.bezierCurveTo(5.8, 51.2, 7.3, 49.7, 7.3, 47.8);
        e.bezierCurveTo(7.3, 46.2, 6.2, 44.8, 4.6, 44.5);
        e.closePath();
        this.fondAiguille = new Shape;
        this.fondAiguille.graphics = e;
        this.aiguille.addChild(this.fondAiguille)
    };
    e.AiguilleMinute = t
})(window);
(function(e) {
    function t() {
        this.initialize()
    }
    t.prototype = new Container;
    t.prototype.Shape_initialize = t.prototype.initialize;
    t.prototype.initialize = function() {
        this.Shape_initialize();
        this.drawVector()
    };
    t.prototype.aiguille;
    t.prototype.fondAiguille;
    t.prototype.drawVector = function() {
        this.aiguille = new Container;
        this.addChild(this.aiguille);
        var e = new Graphics;
        e.beginFill(Graphics.getRGB(36, 70, 110, 100));
        e.moveTo(5.9, 50.5);
        e.bezierCurveTo(5.9, 48.9, 4.7, 47.7, 3.2, 47.6);
        e.lineTo(3.1, .7);
        e.lineTo(2.8, .7);
        e.lineTo(2.7, 47.6);
        e.bezierCurveTo(1.2, 47.7, 0, 49, 0, 50.5);
        e.bezierCurveTo(0, 51.9, .9, 53, 2.2, 53.4);
        e.lineTo(1.1, 66.1);
        e.lineTo(2.9, 67.7);
        e.lineTo(4.6, 66.1);
        e.lineTo(3.6, 53.4);
        e.bezierCurveTo(4.9, 53.1, 5.9, 51.9, 5.9, 50.5);
        e.closePath();
        this.fondAiguille = new Shape;
        this.fondAiguille.graphics = e;
        this.aiguille.addChild(this.fondAiguille)
    };
    e.AiguilleSeconde = t
})(window);